
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb620"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb620"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("4aTru", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $30a31a517a2d5cc7$export$2b8d127b894957b9; }, function (v) { return $30a31a517a2d5cc7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $30a31a517a2d5cc7$export$cea3a54a6425200c; }, function (v) { return $30a31a517a2d5cc7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $30a31a517a2d5cc7$export$a7c73072b1a182ae; }, function (v) { return $30a31a517a2d5cc7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $30a31a517a2d5cc7$export$9f27bc3417b4524d; }, function (v) { return $30a31a517a2d5cc7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac; }, function (v) { return $30a31a517a2d5cc7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35; }, function (v) { return $30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $30a31a517a2d5cc7$export$ffb0004e005737fa; }, function (v) { return $30a31a517a2d5cc7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $30a31a517a2d5cc7$export$b624eff549462981; }, function (v) { return $30a31a517a2d5cc7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $30a31a517a2d5cc7$export$7897aa7841a5380c; }, function (v) { return $30a31a517a2d5cc7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $30a31a517a2d5cc7$export$602eac185826482c; }, function (v) { return $30a31a517a2d5cc7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $30a31a517a2d5cc7$export$e2c29f18771995cb; }, function (v) { return $30a31a517a2d5cc7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $30a31a517a2d5cc7$export$5f8d39834fd61797; }, function (v) { return $30a31a517a2d5cc7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5; }, function (v) { return $30a31a517a2d5cc7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $30a31a517a2d5cc7$export$92387174baf9b227; }, function (v) { return $30a31a517a2d5cc7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $30a31a517a2d5cc7$export$ec112efeb987d9c6; }, function (v) { return $30a31a517a2d5cc7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $30a31a517a2d5cc7$export$b706b080d889d2c9; }, function (v) { return $30a31a517a2d5cc7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $30a31a517a2d5cc7$export$5be5a87408f70ddc; }, function (v) { return $30a31a517a2d5cc7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d; }, function (v) { return $30a31a517a2d5cc7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $30a31a517a2d5cc7$export$455c2e768291efa6; }, function (v) { return $30a31a517a2d5cc7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $30a31a517a2d5cc7$export$9522e17588c12572; }, function (v) { return $30a31a517a2d5cc7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $30a31a517a2d5cc7$export$2110ac352bb060b9; }, function (v) { return $30a31a517a2d5cc7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $30a31a517a2d5cc7$export$56885ab8b9c456ab; }, function (v) { return $30a31a517a2d5cc7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de; }, function (v) { return $30a31a517a2d5cc7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $30a31a517a2d5cc7$export$b82d16f27459e05a; }, function (v) { return $30a31a517a2d5cc7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $30a31a517a2d5cc7$export$522c17b4f5e123e8; }, function (v) { return $30a31a517a2d5cc7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6; }, function (v) { return $30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $30a31a517a2d5cc7$export$9b621391a187a31a; }, function (v) { return $30a31a517a2d5cc7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f; }, function (v) { return $30a31a517a2d5cc7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30a31a517a2d5cc7$export$2b8d127b894957b9;
var $30a31a517a2d5cc7$export$cea3a54a6425200c;
var $30a31a517a2d5cc7$export$a7c73072b1a182ae;
var $30a31a517a2d5cc7$export$9f27bc3417b4524d;
var $30a31a517a2d5cc7$export$db77ccec0bb4ccac;
var $30a31a517a2d5cc7$export$8392c0c9d3dcbd35;
var $30a31a517a2d5cc7$export$ffb0004e005737fa;
var $30a31a517a2d5cc7$export$b624eff549462981;
var $30a31a517a2d5cc7$export$7897aa7841a5380c;
var $30a31a517a2d5cc7$export$602eac185826482c;
var $30a31a517a2d5cc7$export$e2c29f18771995cb;
var $30a31a517a2d5cc7$export$5f8d39834fd61797;
var $30a31a517a2d5cc7$export$74bf444e3cd11ea5;
var $30a31a517a2d5cc7$export$92387174baf9b227;
var $30a31a517a2d5cc7$export$ec112efeb987d9c6;
var $30a31a517a2d5cc7$export$b706b080d889d2c9;
var $30a31a517a2d5cc7$export$5be5a87408f70ddc;
var $30a31a517a2d5cc7$export$45a5e7f76e0caa8d;
var $30a31a517a2d5cc7$export$455c2e768291efa6;
var $30a31a517a2d5cc7$export$9522e17588c12572;
var $30a31a517a2d5cc7$export$2110ac352bb060b9;
var $30a31a517a2d5cc7$export$56885ab8b9c456ab;
var $30a31a517a2d5cc7$export$d927fcb6adf8f9de;
var $30a31a517a2d5cc7$export$b82d16f27459e05a;
var $30a31a517a2d5cc7$export$522c17b4f5e123e8;
var $30a31a517a2d5cc7$export$1aabd8a0274ecfd6;
var $30a31a517a2d5cc7$export$9b621391a187a31a;
var $30a31a517a2d5cc7$export$f5bbd400c2f4426f;
"use strict";
var $30a31a517a2d5cc7$var$b = "function" === typeof Symbol && Symbol.for, $30a31a517a2d5cc7$var$c = $30a31a517a2d5cc7$var$b ? Symbol.for("react.element") : 60103, $30a31a517a2d5cc7$var$d = $30a31a517a2d5cc7$var$b ? Symbol.for("react.portal") : 60106, $30a31a517a2d5cc7$var$e = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fragment") : 60107, $30a31a517a2d5cc7$var$f = $30a31a517a2d5cc7$var$b ? Symbol.for("react.strict_mode") : 60108, $30a31a517a2d5cc7$var$g = $30a31a517a2d5cc7$var$b ? Symbol.for("react.profiler") : 60114, $30a31a517a2d5cc7$var$h = $30a31a517a2d5cc7$var$b ? Symbol.for("react.provider") : 60109, $30a31a517a2d5cc7$var$k = $30a31a517a2d5cc7$var$b ? Symbol.for("react.context") : 60110, $30a31a517a2d5cc7$var$l = $30a31a517a2d5cc7$var$b ? Symbol.for("react.async_mode") : 60111, $30a31a517a2d5cc7$var$m = $30a31a517a2d5cc7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $30a31a517a2d5cc7$var$n = $30a31a517a2d5cc7$var$b ? Symbol.for("react.forward_ref") : 60112, $30a31a517a2d5cc7$var$p = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense") : 60113, $30a31a517a2d5cc7$var$q = $30a31a517a2d5cc7$var$b ? Symbol.for("react.suspense_list") : 60120, $30a31a517a2d5cc7$var$r = $30a31a517a2d5cc7$var$b ? Symbol.for("react.memo") : 60115, $30a31a517a2d5cc7$var$t = $30a31a517a2d5cc7$var$b ? Symbol.for("react.lazy") : 60116, $30a31a517a2d5cc7$var$v = $30a31a517a2d5cc7$var$b ? Symbol.for("react.block") : 60121, $30a31a517a2d5cc7$var$w = $30a31a517a2d5cc7$var$b ? Symbol.for("react.fundamental") : 60117, $30a31a517a2d5cc7$var$x = $30a31a517a2d5cc7$var$b ? Symbol.for("react.responder") : 60118, $30a31a517a2d5cc7$var$y = $30a31a517a2d5cc7$var$b ? Symbol.for("react.scope") : 60119;
function $30a31a517a2d5cc7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $30a31a517a2d5cc7$var$c:
                switch(a = a.type, a){
                    case $30a31a517a2d5cc7$var$l:
                    case $30a31a517a2d5cc7$var$m:
                    case $30a31a517a2d5cc7$var$e:
                    case $30a31a517a2d5cc7$var$g:
                    case $30a31a517a2d5cc7$var$f:
                    case $30a31a517a2d5cc7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $30a31a517a2d5cc7$var$k:
                            case $30a31a517a2d5cc7$var$n:
                            case $30a31a517a2d5cc7$var$t:
                            case $30a31a517a2d5cc7$var$r:
                            case $30a31a517a2d5cc7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $30a31a517a2d5cc7$var$d:
                return u;
        }
    }
}
function $30a31a517a2d5cc7$var$A(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$m;
}
$30a31a517a2d5cc7$export$2b8d127b894957b9 = $30a31a517a2d5cc7$var$l;
$30a31a517a2d5cc7$export$cea3a54a6425200c = $30a31a517a2d5cc7$var$m;
$30a31a517a2d5cc7$export$a7c73072b1a182ae = $30a31a517a2d5cc7$var$k;
$30a31a517a2d5cc7$export$9f27bc3417b4524d = $30a31a517a2d5cc7$var$h;
$30a31a517a2d5cc7$export$db77ccec0bb4ccac = $30a31a517a2d5cc7$var$c;
$30a31a517a2d5cc7$export$8392c0c9d3dcbd35 = $30a31a517a2d5cc7$var$n;
$30a31a517a2d5cc7$export$ffb0004e005737fa = $30a31a517a2d5cc7$var$e;
$30a31a517a2d5cc7$export$b624eff549462981 = $30a31a517a2d5cc7$var$t;
$30a31a517a2d5cc7$export$7897aa7841a5380c = $30a31a517a2d5cc7$var$r;
$30a31a517a2d5cc7$export$602eac185826482c = $30a31a517a2d5cc7$var$d;
$30a31a517a2d5cc7$export$e2c29f18771995cb = $30a31a517a2d5cc7$var$g;
$30a31a517a2d5cc7$export$5f8d39834fd61797 = $30a31a517a2d5cc7$var$f;
$30a31a517a2d5cc7$export$74bf444e3cd11ea5 = $30a31a517a2d5cc7$var$p;
$30a31a517a2d5cc7$export$92387174baf9b227 = function(a) {
    return $30a31a517a2d5cc7$var$A(a) || $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$l;
};
$30a31a517a2d5cc7$export$ec112efeb987d9c6 = $30a31a517a2d5cc7$var$A;
$30a31a517a2d5cc7$export$b706b080d889d2c9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$k;
};
$30a31a517a2d5cc7$export$5be5a87408f70ddc = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$h;
};
$30a31a517a2d5cc7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $30a31a517a2d5cc7$var$c;
};
$30a31a517a2d5cc7$export$455c2e768291efa6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$n;
};
$30a31a517a2d5cc7$export$9522e17588c12572 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$e;
};
$30a31a517a2d5cc7$export$2110ac352bb060b9 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$t;
};
$30a31a517a2d5cc7$export$56885ab8b9c456ab = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$r;
};
$30a31a517a2d5cc7$export$d927fcb6adf8f9de = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$d;
};
$30a31a517a2d5cc7$export$b82d16f27459e05a = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$g;
};
$30a31a517a2d5cc7$export$522c17b4f5e123e8 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$f;
};
$30a31a517a2d5cc7$export$1aabd8a0274ecfd6 = function(a) {
    return $30a31a517a2d5cc7$var$z(a) === $30a31a517a2d5cc7$var$p;
};
$30a31a517a2d5cc7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $30a31a517a2d5cc7$var$e || a === $30a31a517a2d5cc7$var$m || a === $30a31a517a2d5cc7$var$g || a === $30a31a517a2d5cc7$var$f || a === $30a31a517a2d5cc7$var$p || a === $30a31a517a2d5cc7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $30a31a517a2d5cc7$var$t || a.$$typeof === $30a31a517a2d5cc7$var$r || a.$$typeof === $30a31a517a2d5cc7$var$h || a.$$typeof === $30a31a517a2d5cc7$var$k || a.$$typeof === $30a31a517a2d5cc7$var$n || a.$$typeof === $30a31a517a2d5cc7$var$w || a.$$typeof === $30a31a517a2d5cc7$var$x || a.$$typeof === $30a31a517a2d5cc7$var$y || a.$$typeof === $30a31a517a2d5cc7$var$v);
};
$30a31a517a2d5cc7$export$f5bbd400c2f4426f = $30a31a517a2d5cc7$var$z;

});

parcelRegister("Ee11v", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7B0TL.default;
    }
});

var $7B0TL = parcelRequire("7B0TL");

});
parcelRegister("7B0TL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587caf852a5d6450$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $35wch = parcelRequire("35wch");

var $ih19M = parcelRequire("ih19M");
"use client";
function $587caf852a5d6450$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $35wch.default), (0, $4WYaH.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $35wch.default).muiName;
    return /*#__PURE__*/ $bh6RR.memo(/*#__PURE__*/ $bh6RR.forwardRef(Component));
}

});
parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("35wch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fad063f0767f1f$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $b2lJO = parcelRequire("b2lJO");

var $ih19M = parcelRequire("ih19M");
"use client";
const $23fad063f0767f1f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $23fad063f0767f1f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $fGH8N.default)(color)}`,
            `fontSize${(0, $fGH8N.default)(fontSize)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $b2lJO.getSvgIconUtilityClass), classes);
};
const $23fad063f0767f1f$var$SvgIconRoot = (0, $g4l1t.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            styles[`fontSize${(0, $fGH8N.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $23fad063f0767f1f$var$SvgIcon = /*#__PURE__*/ $bh6RR.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $hCIyK.default)(props, $23fad063f0767f1f$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $bh6RR.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $23fad063f0767f1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($23fad063f0767f1f$var$SvgIconRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $1cdNx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ih19M.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$23fad063f0767f1f$var$SvgIcon.muiName = "SvgIcon";
var $23fad063f0767f1f$export$2e2bcd8739ae039 = $23fad063f0767f1f$var$SvgIcon;

});
parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("1cdNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0df19d6a68672c49$export$2e2bcd8739ae039; });
function $0df19d6a68672c49$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $0df19d6a68672c49$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $0df19d6a68672c49$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $0df19d6a68672c49$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $0df19d6a68672c49$export$2e2bcd8739ae039 = $0df19d6a68672c49$export$4f5d2d50c9deca37;

});

parcelRegister("96ZcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a2426d16525cd13$export$2e2bcd8739ae039; });
function $6a2426d16525cd13$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("fGH8N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6bc3e223b7a0835$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");
var $b6bc3e223b7a0835$export$2e2bcd8739ae039 = (0, $5pCmM.default);

});
parcelRegister("5pCmM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0d0c569d2896e9$export$2e2bcd8739ae039; });

var $avV9A = parcelRequire("avV9A");
function $3f0d0c569d2896e9$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $avV9A.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("avV9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a79222bf14c8db7$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $7a79222bf14c8db7$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("cNBED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9517450a96abd5a0$export$2e2bcd8739ae039; });

var $2DXvq = parcelRequire("2DXvq");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
function $9517450a96abd5a0$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $2DXvq.default)({
        props: props,
        name: name,
        defaultTheme: $OFmxN.default,
        themeId: (0, $wllwT.default)
    });
}

});
parcelRegister("2DXvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ecd61e8c633a3b4$export$2e2bcd8739ae039; });

var $lGIi0 = parcelRequire("lGIi0");

var $dm6dP = parcelRequire("dm6dP");
"use client";
function $1ecd61e8c633a3b4$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $dm6dP.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $lGIi0.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("lGIi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9fe0280c7e2b01$export$2e2bcd8739ae039; });

var $e0O1m = parcelRequire("e0O1m");
function $fc9fe0280c7e2b01$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $e0O1m.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("e0O1m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a337dde2edf8b2e6$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $a337dde2edf8b2e6$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $4WYaH.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $4WYaH.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $4WYaH.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $a337dde2edf8b2e6$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("dm6dP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b922804b7aaad5c$export$2e2bcd8739ae039; });

var $1zcRx = parcelRequire("1zcRx");

var $hDooL = parcelRequire("hDooL");
"use client";
const $9b922804b7aaad5c$export$35e57303dbd8a66 = (0, $1zcRx.default)();
function $9b922804b7aaad5c$var$useTheme(defaultTheme = $9b922804b7aaad5c$export$35e57303dbd8a66) {
    return (0, $hDooL.default)(defaultTheme);
}
var $9b922804b7aaad5c$export$2e2bcd8739ae039 = $9b922804b7aaad5c$var$useTheme;

});
parcelRegister("1zcRx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124309933ba5fccb$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");

var $9HQTC = parcelRequire("9HQTC");

var $8gTYU = parcelRequire("8gTYU");

var $b6RkN = parcelRequire("b6RkN");

var $f9NmP = parcelRequire("f9NmP");

var $8RAwN = parcelRequire("8RAwN");

var $cxNpU = parcelRequire("cxNpU");
const $124309933ba5fccb$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $124309933ba5fccb$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $hCIyK.default)(options, $124309933ba5fccb$var$_excluded);
    const breakpoints = (0, $9HQTC.default)(breakpointsInput);
    const spacing = (0, $b6RkN.default)(spacingInput);
    let muiTheme = (0, $5syur.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $4WYaH.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $4WYaH.default)({}, (0, $8gTYU.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $cxNpU.default);
    muiTheme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $4WYaH.default)({}, (0, $8RAwN.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $124309933ba5fccb$export$2e2bcd8739ae039 = $124309933ba5fccb$var$createTheme;

});
parcelRegister("5syur", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $3f9a524a63e48d58$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $3f9a524a63e48d58$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $3f9a524a63e48d58$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $3f9a524a63e48d58$var$deepClone(source) {
    if (!$3f9a524a63e48d58$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $3f9a524a63e48d58$var$deepClone(source[key]);
    });
    return output;
}
function $3f9a524a63e48d58$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $4WYaH.default)({}, target) : target;
    if ($3f9a524a63e48d58$export$53b83ca8eaab0383(target) && $3f9a524a63e48d58$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($3f9a524a63e48d58$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $3f9a524a63e48d58$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $3f9a524a63e48d58$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $3f9a524a63e48d58$export$53b83ca8eaab0383(source[key]) ? $3f9a524a63e48d58$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("9HQTC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71112941b22e40ae$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
const $71112941b22e40ae$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $71112941b22e40ae$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $71112941b22e40ae$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $4WYaH.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $71112941b22e40ae$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $hCIyK.default)(breakpoints, $71112941b22e40ae$var$_excluded);
    const sortedValues = $71112941b22e40ae$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $4WYaH.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("8gTYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $605b3e14c17458d8$export$2e2bcd8739ae039; });
const $605b3e14c17458d8$var$shape = {
    borderRadius: 4
};
var $605b3e14c17458d8$export$2e2bcd8739ae039 = $605b3e14c17458d8$var$shape;

});

parcelRegister("b6RkN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8169a057809484de$export$2e2bcd8739ae039; });

var $lqJyU = parcelRequire("lqJyU");
function $8169a057809484de$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $lqJyU.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("lqJyU", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $f99f5e5de94dd506$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $f99f5e5de94dd506$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $f99f5e5de94dd506$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $f99f5e5de94dd506$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $f99f5e5de94dd506$export$6f98e8eaf0be1996; });


var $eP4dZ = parcelRequire("eP4dZ");

var $8ZvsC = parcelRequire("8ZvsC");

var $e4At2 = parcelRequire("e4At2");

var $e2KKj = parcelRequire("e2KKj");
const $f99f5e5de94dd506$var$properties = {
    m: "margin",
    p: "padding"
};
const $f99f5e5de94dd506$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $f99f5e5de94dd506$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f99f5e5de94dd506$var$getCssProperties = (0, $e2KKj.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f99f5e5de94dd506$var$aliases[prop]) prop = $f99f5e5de94dd506$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $f99f5e5de94dd506$var$properties[a];
    const direction = $f99f5e5de94dd506$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f99f5e5de94dd506$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $f99f5e5de94dd506$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $f99f5e5de94dd506$var$spacingKeys = [
    ...$f99f5e5de94dd506$export$aab52a0dde05ad8a,
    ...$f99f5e5de94dd506$export$f8397d44f03ab6ad
];
function $f99f5e5de94dd506$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $8ZvsC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $f99f5e5de94dd506$export$1def6f833384e3d1(theme) {
    return $f99f5e5de94dd506$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $f99f5e5de94dd506$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $f99f5e5de94dd506$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f99f5e5de94dd506$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $f99f5e5de94dd506$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $f99f5e5de94dd506$var$getCssProperties(prop);
    const styleFromPropValue = $f99f5e5de94dd506$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $eP4dZ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $f99f5e5de94dd506$var$style(props, keys) {
    const transformer = $f99f5e5de94dd506$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$f99f5e5de94dd506$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $e4At2.default), {});
}
function $f99f5e5de94dd506$export$7ede87f9b603dd3c(props) {
    return $f99f5e5de94dd506$var$style(props, $f99f5e5de94dd506$export$aab52a0dde05ad8a);
}
$f99f5e5de94dd506$export$7ede87f9b603dd3c.propTypes = {};
$f99f5e5de94dd506$export$7ede87f9b603dd3c.filterProps = $f99f5e5de94dd506$export$aab52a0dde05ad8a;
function $f99f5e5de94dd506$export$6f98e8eaf0be1996(props) {
    return $f99f5e5de94dd506$var$style(props, $f99f5e5de94dd506$export$f8397d44f03ab6ad);
}
$f99f5e5de94dd506$export$6f98e8eaf0be1996.propTypes = {};
$f99f5e5de94dd506$export$6f98e8eaf0be1996.filterProps = $f99f5e5de94dd506$export$f8397d44f03ab6ad;
function $f99f5e5de94dd506$var$spacing(props) {
    return $f99f5e5de94dd506$var$style(props, $f99f5e5de94dd506$var$spacingKeys);
}
$f99f5e5de94dd506$var$spacing.propTypes = {};
$f99f5e5de94dd506$var$spacing.filterProps = $f99f5e5de94dd506$var$spacingKeys;
var $f99f5e5de94dd506$export$2e2bcd8739ae039 = $f99f5e5de94dd506$var$spacing;

});
parcelRegister("eP4dZ", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $aca91b02db9b460c$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $aca91b02db9b460c$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $aca91b02db9b460c$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $aca91b02db9b460c$export$8922c90b6e020726; });

var $4WYaH = parcelRequire("4WYaH");


var $5syur = parcelRequire("5syur");

var $e4At2 = parcelRequire("e4At2");
const $aca91b02db9b460c$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $aca91b02db9b460c$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$aca91b02db9b460c$export$68c286be0e7e55b7[key]}px)`
};
function $aca91b02db9b460c$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $aca91b02db9b460c$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $aca91b02db9b460c$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $aca91b02db9b460c$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $aca91b02db9b460c$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $aca91b02db9b460c$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $4WYaH.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $e4At2.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $aca91b02db9b460c$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $aca91b02db9b460c$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $aca91b02db9b460c$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $aca91b02db9b460c$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $5syur.default)(prev, next), {});
    return $aca91b02db9b460c$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $aca91b02db9b460c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $aca91b02db9b460c$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $aca91b02db9b460c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $aca91b02db9b460c$export$2e2bcd8739ae039 = $aca91b02db9b460c$var$breakpoints;

});
parcelRegister("e4At2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3edba0f8fdbb817$export$2e2bcd8739ae039; });

var $5syur = parcelRequire("5syur");
function $a3edba0f8fdbb817$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $5syur.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $a3edba0f8fdbb817$export$2e2bcd8739ae039 = $a3edba0f8fdbb817$var$merge;

});


parcelRegister("8ZvsC", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $68bc6cacc34785a6$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $68bc6cacc34785a6$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $68bc6cacc34785a6$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");


var $eP4dZ = parcelRequire("eP4dZ");
function $68bc6cacc34785a6$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $68bc6cacc34785a6$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $68bc6cacc34785a6$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $68bc6cacc34785a6$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $68bc6cacc34785a6$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $68bc6cacc34785a6$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $68bc6cacc34785a6$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $5pCmM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eP4dZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $68bc6cacc34785a6$export$2e2bcd8739ae039 = $68bc6cacc34785a6$var$style;

});

parcelRegister("e2KKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a39583580fc8bcb5$export$2e2bcd8739ae039; });
function $a39583580fc8bcb5$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("f9NmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08dfd925cd859a9$export$2e2bcd8739ae039; });

var $5pCmM = parcelRequire("5pCmM");

var $e4At2 = parcelRequire("e4At2");

var $8ZvsC = parcelRequire("8ZvsC");

var $eP4dZ = parcelRequire("eP4dZ");

var $8RAwN = parcelRequire("8RAwN");
function $b08dfd925cd859a9$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $b08dfd925cd859a9$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $b08dfd925cd859a9$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $8ZvsC.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $8ZvsC.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $8ZvsC.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $5pCmM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eP4dZ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $8RAwN.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $eP4dZ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $b08dfd925cd859a9$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $e4At2.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $eP4dZ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($b08dfd925cd859a9$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $e4At2.default)(css, breakpointsValues);
                        }
                    } else css = (0, $e4At2.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $eP4dZ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $b08dfd925cd859a9$var$styleFunctionSx = $b08dfd925cd859a9$export$7d53d8bf2911e013();
$b08dfd925cd859a9$var$styleFunctionSx.filterProps = [
    "sx"
];
var $b08dfd925cd859a9$export$2e2bcd8739ae039 = $b08dfd925cd859a9$var$styleFunctionSx;

});
parcelRegister("8RAwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673f9bacc92f414a$export$2e2bcd8739ae039; });

var $lqJyU = parcelRequire("lqJyU");

var $iXKnY = parcelRequire("iXKnY");

var $huOLh = parcelRequire("huOLh");

var $3qBJk = parcelRequire("3qBJk");

var $dX7gg = parcelRequire("dX7gg");
const $673f9bacc92f414a$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $iXKnY.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $3qBJk.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $3qBJk.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $3qBJk.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $lqJyU.padding)
    },
    pt: {
        style: (0, $lqJyU.padding)
    },
    pr: {
        style: (0, $lqJyU.padding)
    },
    pb: {
        style: (0, $lqJyU.padding)
    },
    pl: {
        style: (0, $lqJyU.padding)
    },
    px: {
        style: (0, $lqJyU.padding)
    },
    py: {
        style: (0, $lqJyU.padding)
    },
    padding: {
        style: (0, $lqJyU.padding)
    },
    paddingTop: {
        style: (0, $lqJyU.padding)
    },
    paddingRight: {
        style: (0, $lqJyU.padding)
    },
    paddingBottom: {
        style: (0, $lqJyU.padding)
    },
    paddingLeft: {
        style: (0, $lqJyU.padding)
    },
    paddingX: {
        style: (0, $lqJyU.padding)
    },
    paddingY: {
        style: (0, $lqJyU.padding)
    },
    paddingInline: {
        style: (0, $lqJyU.padding)
    },
    paddingInlineStart: {
        style: (0, $lqJyU.padding)
    },
    paddingInlineEnd: {
        style: (0, $lqJyU.padding)
    },
    paddingBlock: {
        style: (0, $lqJyU.padding)
    },
    paddingBlockStart: {
        style: (0, $lqJyU.padding)
    },
    paddingBlockEnd: {
        style: (0, $lqJyU.padding)
    },
    m: {
        style: (0, $lqJyU.margin)
    },
    mt: {
        style: (0, $lqJyU.margin)
    },
    mr: {
        style: (0, $lqJyU.margin)
    },
    mb: {
        style: (0, $lqJyU.margin)
    },
    ml: {
        style: (0, $lqJyU.margin)
    },
    mx: {
        style: (0, $lqJyU.margin)
    },
    my: {
        style: (0, $lqJyU.margin)
    },
    margin: {
        style: (0, $lqJyU.margin)
    },
    marginTop: {
        style: (0, $lqJyU.margin)
    },
    marginRight: {
        style: (0, $lqJyU.margin)
    },
    marginBottom: {
        style: (0, $lqJyU.margin)
    },
    marginLeft: {
        style: (0, $lqJyU.margin)
    },
    marginX: {
        style: (0, $lqJyU.margin)
    },
    marginY: {
        style: (0, $lqJyU.margin)
    },
    marginInline: {
        style: (0, $lqJyU.margin)
    },
    marginInlineStart: {
        style: (0, $lqJyU.margin)
    },
    marginInlineEnd: {
        style: (0, $lqJyU.margin)
    },
    marginBlock: {
        style: (0, $lqJyU.margin)
    },
    marginBlockStart: {
        style: (0, $lqJyU.margin)
    },
    marginBlockEnd: {
        style: (0, $lqJyU.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $huOLh.gap)
    },
    rowGap: {
        style: (0, $huOLh.rowGap)
    },
    columnGap: {
        style: (0, $huOLh.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $dX7gg.sizingTransform)
    },
    maxWidth: {
        style: (0, $dX7gg.maxWidth)
    },
    minWidth: {
        transform: (0, $dX7gg.sizingTransform)
    },
    height: {
        transform: (0, $dX7gg.sizingTransform)
    },
    maxHeight: {
        transform: (0, $dX7gg.sizingTransform)
    },
    minHeight: {
        transform: (0, $dX7gg.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $673f9bacc92f414a$export$2e2bcd8739ae039 = $673f9bacc92f414a$var$defaultSxConfig;

});
parcelRegister("iXKnY", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $dce1b7e2b09bec12$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $dce1b7e2b09bec12$export$7a57f79000377ca2; });


var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");

var $lqJyU = parcelRequire("lqJyU");

var $eP4dZ = parcelRequire("eP4dZ");
function $dce1b7e2b09bec12$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $dce1b7e2b09bec12$var$createBorderStyle(prop, transform) {
    return (0, $8ZvsC.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $dce1b7e2b09bec12$export$1edee58a52776cd9 = $dce1b7e2b09bec12$var$createBorderStyle("border", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$f9a7b6bd24892946 = $dce1b7e2b09bec12$var$createBorderStyle("borderTop", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$5abca33e6be905d2 = $dce1b7e2b09bec12$var$createBorderStyle("borderRight", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$e2ce9f12a980a822 = $dce1b7e2b09bec12$var$createBorderStyle("borderBottom", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$47658cca1a909427 = $dce1b7e2b09bec12$var$createBorderStyle("borderLeft", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$e7fb0694ba2404fc = $dce1b7e2b09bec12$var$createBorderStyle("borderColor");
const $dce1b7e2b09bec12$export$126a92c968acdb85 = $dce1b7e2b09bec12$var$createBorderStyle("borderTopColor");
const $dce1b7e2b09bec12$export$85cc51cb8fbb8c0e = $dce1b7e2b09bec12$var$createBorderStyle("borderRightColor");
const $dce1b7e2b09bec12$export$340b0327727f6d1a = $dce1b7e2b09bec12$var$createBorderStyle("borderBottomColor");
const $dce1b7e2b09bec12$export$60beef91a985b4bf = $dce1b7e2b09bec12$var$createBorderStyle("borderLeftColor");
const $dce1b7e2b09bec12$export$f9258c55612cbed7 = $dce1b7e2b09bec12$var$createBorderStyle("outline", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$621fe586efeb64b9 = $dce1b7e2b09bec12$var$createBorderStyle("outlineColor");
const $dce1b7e2b09bec12$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$dce1b7e2b09bec12$export$7a57f79000377ca2.propTypes = {};
$dce1b7e2b09bec12$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $dce1b7e2b09bec12$var$borders = (0, $4Nf9l.default)($dce1b7e2b09bec12$export$1edee58a52776cd9, $dce1b7e2b09bec12$export$f9a7b6bd24892946, $dce1b7e2b09bec12$export$5abca33e6be905d2, $dce1b7e2b09bec12$export$e2ce9f12a980a822, $dce1b7e2b09bec12$export$47658cca1a909427, $dce1b7e2b09bec12$export$e7fb0694ba2404fc, $dce1b7e2b09bec12$export$126a92c968acdb85, $dce1b7e2b09bec12$export$85cc51cb8fbb8c0e, $dce1b7e2b09bec12$export$340b0327727f6d1a, $dce1b7e2b09bec12$export$60beef91a985b4bf, $dce1b7e2b09bec12$export$7a57f79000377ca2, $dce1b7e2b09bec12$export$f9258c55612cbed7, $dce1b7e2b09bec12$export$621fe586efeb64b9);
var $dce1b7e2b09bec12$export$2e2bcd8739ae039 = $dce1b7e2b09bec12$var$borders;

});
parcelRegister("4Nf9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37d77d7211880bab$export$2e2bcd8739ae039; });

var $e4At2 = parcelRequire("e4At2");
function $37d77d7211880bab$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $e4At2.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $37d77d7211880bab$export$2e2bcd8739ae039 = $37d77d7211880bab$var$compose;

});


parcelRegister("huOLh", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $cbcc9d3026e306b1$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $cbcc9d3026e306b1$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $cbcc9d3026e306b1$export$8a833ffa5f5dbeda; });

var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");

var $lqJyU = parcelRequire("lqJyU");

var $eP4dZ = parcelRequire("eP4dZ");

const $cbcc9d3026e306b1$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$cbcc9d3026e306b1$export$5df9adcb0db95e1e.propTypes = {};
$cbcc9d3026e306b1$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $cbcc9d3026e306b1$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$cbcc9d3026e306b1$export$ec60d70ff941a580.propTypes = {};
$cbcc9d3026e306b1$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $cbcc9d3026e306b1$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$cbcc9d3026e306b1$export$8a833ffa5f5dbeda.propTypes = {};
$cbcc9d3026e306b1$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $cbcc9d3026e306b1$export$baf44164ca3a34e8 = (0, $8ZvsC.default)({
    prop: "gridColumn"
});
const $cbcc9d3026e306b1$export$8f7213a1cd01e832 = (0, $8ZvsC.default)({
    prop: "gridRow"
});
const $cbcc9d3026e306b1$export$b0e0abbc49ba668 = (0, $8ZvsC.default)({
    prop: "gridAutoFlow"
});
const $cbcc9d3026e306b1$export$bcd8b929d4b4142 = (0, $8ZvsC.default)({
    prop: "gridAutoColumns"
});
const $cbcc9d3026e306b1$export$e5039a674e14c828 = (0, $8ZvsC.default)({
    prop: "gridAutoRows"
});
const $cbcc9d3026e306b1$export$42bd9088661ffb03 = (0, $8ZvsC.default)({
    prop: "gridTemplateColumns"
});
const $cbcc9d3026e306b1$export$920682ae05b999bc = (0, $8ZvsC.default)({
    prop: "gridTemplateRows"
});
const $cbcc9d3026e306b1$export$1b88fbdd482fd33a = (0, $8ZvsC.default)({
    prop: "gridTemplateAreas"
});
const $cbcc9d3026e306b1$export$bdb486e40d52d26f = (0, $8ZvsC.default)({
    prop: "gridArea"
});
const $cbcc9d3026e306b1$var$grid = (0, $4Nf9l.default)($cbcc9d3026e306b1$export$5df9adcb0db95e1e, $cbcc9d3026e306b1$export$ec60d70ff941a580, $cbcc9d3026e306b1$export$8a833ffa5f5dbeda, $cbcc9d3026e306b1$export$baf44164ca3a34e8, $cbcc9d3026e306b1$export$8f7213a1cd01e832, $cbcc9d3026e306b1$export$b0e0abbc49ba668, $cbcc9d3026e306b1$export$bcd8b929d4b4142, $cbcc9d3026e306b1$export$e5039a674e14c828, $cbcc9d3026e306b1$export$42bd9088661ffb03, $cbcc9d3026e306b1$export$920682ae05b999bc, $cbcc9d3026e306b1$export$1b88fbdd482fd33a, $cbcc9d3026e306b1$export$bdb486e40d52d26f);
var $cbcc9d3026e306b1$export$2e2bcd8739ae039 = $cbcc9d3026e306b1$var$grid;

});

parcelRegister("3qBJk", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $27f1113b2e933e83$export$dbaffd4420ea0ac6; });

var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");
function $27f1113b2e933e83$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $27f1113b2e933e83$export$35e9368ef982300f = (0, $8ZvsC.default)({
    prop: "color",
    themeKey: "palette",
    transform: $27f1113b2e933e83$export$dbaffd4420ea0ac6
});
const $27f1113b2e933e83$export$2506f56c10355b33 = (0, $8ZvsC.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $27f1113b2e933e83$export$dbaffd4420ea0ac6
});
const $27f1113b2e933e83$export$8c5a050822fd698c = (0, $8ZvsC.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $27f1113b2e933e83$export$dbaffd4420ea0ac6
});
const $27f1113b2e933e83$var$palette = (0, $4Nf9l.default)($27f1113b2e933e83$export$35e9368ef982300f, $27f1113b2e933e83$export$2506f56c10355b33, $27f1113b2e933e83$export$8c5a050822fd698c);
var $27f1113b2e933e83$export$2e2bcd8739ae039 = $27f1113b2e933e83$var$palette;

});

parcelRegister("dX7gg", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $a2866b01e610646d$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $a2866b01e610646d$export$488fda99655ff65a; });

var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");

var $eP4dZ = parcelRequire("eP4dZ");
function $a2866b01e610646d$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a2866b01e610646d$export$7e3df82ee760448c = (0, $8ZvsC.default)({
    prop: "width",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $eP4dZ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $a2866b01e610646d$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $eP4dZ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a2866b01e610646d$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $a2866b01e610646d$export$ee148fbbe8357dd2 = (0, $8ZvsC.default)({
    prop: "minWidth",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$ac607276a8fe9f0a = (0, $8ZvsC.default)({
    prop: "height",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$dc0d8bd0b94f8570 = (0, $8ZvsC.default)({
    prop: "maxHeight",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$a43cf604e12f3b17 = (0, $8ZvsC.default)({
    prop: "minHeight",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$ffed9f14fb65e276 = (0, $8ZvsC.default)({
    prop: "size",
    cssProperty: "width",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$905076ed6620e671 = (0, $8ZvsC.default)({
    prop: "size",
    cssProperty: "height",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$6ccc93f785106a58 = (0, $8ZvsC.default)({
    prop: "boxSizing"
});
const $a2866b01e610646d$var$sizing = (0, $4Nf9l.default)($a2866b01e610646d$export$7e3df82ee760448c, $a2866b01e610646d$export$488fda99655ff65a, $a2866b01e610646d$export$ee148fbbe8357dd2, $a2866b01e610646d$export$ac607276a8fe9f0a, $a2866b01e610646d$export$dc0d8bd0b94f8570, $a2866b01e610646d$export$a43cf604e12f3b17, $a2866b01e610646d$export$6ccc93f785106a58);
var $a2866b01e610646d$export$2e2bcd8739ae039 = $a2866b01e610646d$var$sizing;

});



parcelRegister("cxNpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921ee6491134d507$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $921ee6491134d507$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("hDooL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd690132dfc7e660$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("7hler");
var $iwq56 = parcelRequire("iwq56");
"use client";
function $cd690132dfc7e660$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $cd690132dfc7e660$var$useTheme(defaultTheme = null) {
    const contextTheme = $bh6RR.useContext((0, $iwq56.T));
    return !contextTheme || $cd690132dfc7e660$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $cd690132dfc7e660$export$2e2bcd8739ae039 = $cd690132dfc7e660$var$useTheme;

});
parcelRegister("7hler", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $54ca97295c8c5003$export$98f03c5d19621d70; });
$parcel$export(module.exports, "keyframes", function () { return $54ca97295c8c5003$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("iwq56")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("iwq56")).w; });

var $iwq56 = parcelRequire("iwq56");

var $bh6RR = parcelRequire("bh6RR");

var $cdpIC = parcelRequire("cdpIC");

var $fPHYJ = parcelRequire("fPHYJ");

var $9v6T8 = parcelRequire("9v6T8");
parcelRequire("gbgGf");
parcelRequire("3Tqyg");
parcelRequire("ieFqf");

parcelRequire("adG4d");
var $54ca97295c8c5003$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $iwq56.h).call(props, "css")) return $bh6RR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iwq56.E);
    createElementArgArray[1] = (0, $iwq56.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $bh6RR.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $54ca97295c8c5003$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iwq56.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $9v6T8.serializeStyles)([
        styles
    ], undefined, $bh6RR.useContext((0, $iwq56.T)));
    if (!(0, $iwq56.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bh6RR.useRef();
    (0, $fPHYJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fPHYJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $cdpIC.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $54ca97295c8c5003$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9v6T8.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $54ca97295c8c5003$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $54ca97295c8c5003$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $54ca97295c8c5003$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $54ca97295c8c5003$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $cdpIC.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $54ca97295c8c5003$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $cdpIC.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $iwq56.i) && res !== undefined) rules += res;
        }
        if (!(0, $iwq56.i)) return rules;
    });
    if (!(0, $iwq56.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $54ca97295c8c5003$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iwq56.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $iwq56.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $9v6T8.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $cdpIC.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $iwq56.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $54ca97295c8c5003$var$merge(cache.registered, css, $54ca97295c8c5003$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bh6RR.useContext((0, $iwq56.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($54ca97295c8c5003$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("iwq56", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $d7bf72605dee4607$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $d7bf72605dee4607$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $d7bf72605dee4607$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $d7bf72605dee4607$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $d7bf72605dee4607$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $d7bf72605dee4607$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $d7bf72605dee4607$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $d7bf72605dee4607$export$a9c23c6ac3fc3eca; });

var $bh6RR = parcelRequire("bh6RR");

var $gbgGf = parcelRequire("gbgGf");

var $4WYaH = parcelRequire("4WYaH");

var $ieFqf = parcelRequire("ieFqf");

var $fFdqN = parcelRequire("fFdqN");

var $cdpIC = parcelRequire("cdpIC");

var $9v6T8 = parcelRequire("9v6T8");

var $fPHYJ = parcelRequire("fPHYJ");
var $d7bf72605dee4607$export$407448d2b89b1813 = false;
var $d7bf72605dee4607$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $d7bf72605dee4607$var$EmotionCacheContext = /* #__PURE__ */ $bh6RR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $gbgGf.default)({
    key: "css"
}) : null);
var $d7bf72605dee4607$export$e7094788287c5e9b = $d7bf72605dee4607$var$EmotionCacheContext.Provider;
var $d7bf72605dee4607$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $bh6RR.useContext)($d7bf72605dee4607$var$EmotionCacheContext);
};
var $d7bf72605dee4607$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bh6RR.useContext)($d7bf72605dee4607$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$d7bf72605dee4607$export$23f2a1d2818174ef) $d7bf72605dee4607$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $bh6RR.useContext)($d7bf72605dee4607$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $gbgGf.default)({
                key: "css"
            });
            return /*#__PURE__*/ $bh6RR.createElement($d7bf72605dee4607$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $d7bf72605dee4607$export$971d5caa766a69d7 = /* #__PURE__ */ $bh6RR.createContext({});
var $d7bf72605dee4607$export$3b14a55fb2447963 = function useTheme() {
    return $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7);
};
var $d7bf72605dee4607$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, theme);
};
var $d7bf72605dee4607$var$createCacheWithTheme = /* #__PURE__ */ (0, $ieFqf.default)(function(outerTheme) {
    return (0, $ieFqf.default)(function(theme) {
        return $d7bf72605dee4607$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $d7bf72605dee4607$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d7bf72605dee4607$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bh6RR.createElement($d7bf72605dee4607$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d7bf72605dee4607$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bh6RR.createElement(Component, (0, $4WYaH.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $bh6RR.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fFdqN.default)(WithTheme, Component);
}
var $d7bf72605dee4607$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d7bf72605dee4607$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $d7bf72605dee4607$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($d7bf72605dee4607$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$d7bf72605dee4607$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $d7bf72605dee4607$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cdpIC.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cdpIC.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$d7bf72605dee4607$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $d7bf72605dee4607$var$Emotion = /* #__PURE__ */ $d7bf72605dee4607$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d7bf72605dee4607$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $cdpIC.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $9v6T8.serializeStyles)(registeredStyles, undefined, $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($d7bf72605dee4607$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $d7bf72605dee4607$var$typePropName && !$d7bf72605dee4607$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($d7bf72605dee4607$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $bh6RR.createElement(WrappedComponent, newProps));
});
var $d7bf72605dee4607$export$a9c23c6ac3fc3eca = $d7bf72605dee4607$var$Emotion;

});
parcelRegister("gbgGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7a9ccd09b383ef$export$2e2bcd8739ae039; });

var $k2OLv = parcelRequire("k2OLv");

var $sdBdz = parcelRequire("sdBdz");

var $ieFqf = parcelRequire("ieFqf");

var $cthCm = parcelRequire("cthCm");
var $bc7a9ccd09b383ef$var$isBrowser = typeof document !== "undefined";
var $bc7a9ccd09b383ef$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $sdBdz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $sdBdz.token)(character)) break;
        (0, $sdBdz.next)();
    }
    return (0, $sdBdz.slice)(begin, (0, $sdBdz.position));
};
var $bc7a9ccd09b383ef$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $sdBdz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $sdBdz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bc7a9ccd09b383ef$var$identifierWithPointTracking((0, $sdBdz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $sdBdz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $sdBdz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $sdBdz.from)(character);
    }
    while (character = (0, $sdBdz.next)());
    return parsed;
};
var $bc7a9ccd09b383ef$var$getRules = function getRules(value, points) {
    return (0, $sdBdz.dealloc)($bc7a9ccd09b383ef$var$toRules((0, $sdBdz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bc7a9ccd09b383ef$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bc7a9ccd09b383ef$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bc7a9ccd09b383ef$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bc7a9ccd09b383ef$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bc7a9ccd09b383ef$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bc7a9ccd09b383ef$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $bc7a9ccd09b383ef$var$prefix(value, length) {
    switch((0, $sdBdz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $sdBdz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $sdBdz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MOZ) + value + (0, $sdBdz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
        // order
        case 6165:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.replace)(value, /(\w+).+(:[^]+)/, (0, $sdBdz.WEBKIT) + "box-$1$2" + (0, $sdBdz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-item-" + (0, $sdBdz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-line-pack" + (0, $sdBdz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $sdBdz.WEBKIT) + "box-" + (0, $sdBdz.replace)(value, "-grow", "") + (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $sdBdz.WEBKIT) + (0, $sdBdz.replace)(value, /([^-])(transform)/g, "$1" + (0, $sdBdz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(zoom-|grab)/, (0, $sdBdz.WEBKIT) + "$1"), /(image-set)/, (0, $sdBdz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $sdBdz.replace)(value, /(image-set\([^]*)/, (0, $sdBdz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $sdBdz.WEBKIT) + "box-pack:$3" + (0, $sdBdz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $sdBdz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $sdBdz.replace)(value, /(.+)-inline(.+)/, (0, $sdBdz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $sdBdz.strlen)(value) - 1 - length > 6) switch((0, $sdBdz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $sdBdz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $sdBdz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $sdBdz.WEBKIT) + "$2-$3" + "$1" + (0, $sdBdz.MOZ) + ((0, $sdBdz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $sdBdz.indexof)(value, "stretch") ? $bc7a9ccd09b383ef$var$prefix((0, $sdBdz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $sdBdz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $sdBdz.charat)(value, (0, $sdBdz.strlen)(value) - 3 - (~(0, $sdBdz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $sdBdz.replace)(value, ":", ":" + (0, $sdBdz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $sdBdz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $sdBdz.WEBKIT) + ((0, $sdBdz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $sdBdz.WEBKIT) + "$2$3" + "$1" + (0, $sdBdz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $sdBdz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
    }
    return value;
}
var $bc7a9ccd09b383ef$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $sdBdz.DECLARATION:
                element["return"] = $bc7a9ccd09b383ef$var$prefix(element.value, element.length);
                break;
            case 0, $sdBdz.KEYFRAMES:
                return (0, $sdBdz.serialize)([
                    (0, $sdBdz.copy)(element, {
                        value: (0, $sdBdz.replace)(element.value, "@", "@" + (0, $sdBdz.WEBKIT))
                    })
                ], callback);
            case 0, $sdBdz.RULESET:
                if (element.length) return (0, $sdBdz.combine)(element.props, function(value) {
                    switch((0, $sdBdz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(read-\w+)/, ":" + (0, $sdBdz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ":" + (0, $sdBdz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ":" + (0, $sdBdz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, (0, $sdBdz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $bc7a9ccd09b383ef$var$getServerStylisCache = $bc7a9ccd09b383ef$var$isBrowser ? undefined : (0, $ieFqf.default)(function() {
    return (0, $cthCm.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $bc7a9ccd09b383ef$var$defaultStylisPlugins = [
    $bc7a9ccd09b383ef$var$prefixer
];
var $bc7a9ccd09b383ef$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($bc7a9ccd09b383ef$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $bc7a9ccd09b383ef$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($bc7a9ccd09b383ef$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $bc7a9ccd09b383ef$var$compat,
        $bc7a9ccd09b383ef$var$removeLabel
    ];
    if ($bc7a9ccd09b383ef$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $sdBdz.stringify),
            (0, $sdBdz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $sdBdz.stringify)
        ];
        var _serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), _serializer);
        };
        var serverStylisCache = $bc7a9ccd09b383ef$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $k2OLv.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("k2OLv", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e97b5f72ed127b53$export$9d753cd7ae895cce; });
var $e97b5f72ed127b53$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e97b5f72ed127b53$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e97b5f72ed127b53$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e97b5f72ed127b53$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e97b5f72ed127b53$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e97b5f72ed127b53$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e97b5f72ed127b53$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("sdBdz", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $783faa7ec18221fc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $783faa7ec18221fc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $783faa7ec18221fc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $783faa7ec18221fc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $783faa7ec18221fc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $783faa7ec18221fc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $783faa7ec18221fc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $783faa7ec18221fc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $783faa7ec18221fc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $783faa7ec18221fc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $783faa7ec18221fc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $783faa7ec18221fc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $783faa7ec18221fc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $783faa7ec18221fc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $783faa7ec18221fc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $783faa7ec18221fc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $783faa7ec18221fc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $783faa7ec18221fc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $783faa7ec18221fc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $783faa7ec18221fc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $783faa7ec18221fc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $783faa7ec18221fc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $783faa7ec18221fc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $783faa7ec18221fc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $783faa7ec18221fc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $783faa7ec18221fc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $783faa7ec18221fc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $783faa7ec18221fc$export$38bcb760f1d4871c; });
var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(j += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $783faa7ec18221fc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(j) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(y = $783faa7ec18221fc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, y, y, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $783faa7ec18221fc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) j += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(g = j += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $783faa7ec18221fc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $783faa7ec18221fc$export$2f35ab04d2335697(e, v + 1, v = $783faa7ec18221fc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $783faa7ec18221fc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span") ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch") ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $783faa7ec18221fc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ieFqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d469aa6647f846c1$export$2e2bcd8739ae039; });
var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("fFdqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6751a8254c8738e$export$2e2bcd8739ae039; });

var $adG4d = parcelRequire("adG4d");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b6751a8254c8738e$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(targetComponent, sourceComponent);
};

});
parcelRegister("adG4d", function(module, exports) {
"use strict";

var $aX2tJ = parcelRequire("aX2tJ");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$aX2tJ.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$aX2tJ.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($aX2tJ.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component["$$typeof"]] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("aX2tJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4aTru"));

});



parcelRegister("cdpIC", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $8e4aa61dd4b95f07$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $8e4aa61dd4b95f07$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $8e4aa61dd4b95f07$export$6f077d94b33a01aa; });
var $8e4aa61dd4b95f07$var$isBrowser = typeof document !== "undefined";
function $8e4aa61dd4b95f07$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $8e4aa61dd4b95f07$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8e4aa61dd4b95f07$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8e4aa61dd4b95f07$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8e4aa61dd4b95f07$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$8e4aa61dd4b95f07$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8e4aa61dd4b95f07$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("9v6T8", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $6eac5a28f6e72cd5$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $amwve = parcelRequire("amwve");

var $cthCm = parcelRequire("cthCm");
var $6eac5a28f6e72cd5$var$isDevelopment = false;
var $6eac5a28f6e72cd5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6eac5a28f6e72cd5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6eac5a28f6e72cd5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6eac5a28f6e72cd5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $6eac5a28f6e72cd5$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $6eac5a28f6e72cd5$var$isCustomProperty(styleName) ? styleName : styleName.replace($6eac5a28f6e72cd5$var$hyphenateRegex, "-$&").toLowerCase();
});
var $6eac5a28f6e72cd5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($6eac5a28f6e72cd5$var$animationRegex, function(match, p1, p2) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $amwve.default)[key] !== 1 && !$6eac5a28f6e72cd5$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $6eac5a28f6e72cd5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6eac5a28f6e72cd5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6eac5a28f6e72cd5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $6eac5a28f6e72cd5$var$cursor;
                var result = interpolation(mergedProps);
                $6eac5a28f6e72cd5$var$cursor = previousCursor;
                return $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($6eac5a28f6e72cd5$var$isProcessableValue(asString)) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $6eac5a28f6e72cd5$var$isDevelopment) throw new Error($6eac5a28f6e72cd5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($6eac5a28f6e72cd5$var$isProcessableValue(value[_i])) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $6eac5a28f6e72cd5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $6eac5a28f6e72cd5$var$cursor;
function $6eac5a28f6e72cd5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $6eac5a28f6e72cd5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $6eac5a28f6e72cd5$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6eac5a28f6e72cd5$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6eac5a28f6e72cd5$var$cursor
    };
}

});
parcelRegister("171Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf7dd2d70c55cf3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("amwve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b52bced097bc64$export$2e2bcd8739ae039; });
var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fPHYJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b86dbba518057278$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b86dbba518057278$export$811a713a7276cb9d; });

var $bh6RR = parcelRequire("bh6RR");
var $b86dbba518057278$var$isBrowser = typeof document !== "undefined";
var $b86dbba518057278$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b86dbba518057278$var$useInsertionEffect = $bh6RR.useInsertionEffect ? $bh6RR.useInsertionEffect : false;
var $b86dbba518057278$export$db21c7ffa21794e7 = !$b86dbba518057278$var$isBrowser ? $b86dbba518057278$var$syncFallback : $b86dbba518057278$var$useInsertionEffect || $b86dbba518057278$var$syncFallback;
var $b86dbba518057278$export$811a713a7276cb9d = $b86dbba518057278$var$useInsertionEffect || $bh6RR.useLayoutEffect;

});


parcelRegister("3Tqyg", function(module, exports) {
function $2d5b1ac1574da936$var$_extends() {
    return module.exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2d5b1ac1574da936$var$_extends.apply(null, arguments);
}
module.exports = $2d5b1ac1574da936$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("OFmxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0984c161637848f6$export$2e2bcd8739ae039; });

var $gcMmG = parcelRequire("gcMmG");
"use client";
const $0984c161637848f6$var$defaultTheme = (0, $gcMmG.default)();
var $0984c161637848f6$export$2e2bcd8739ae039 = $0984c161637848f6$var$defaultTheme;

});
parcelRegister("gcMmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcc348908a7dde4d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");
var $avV9A = parcelRequire("avV9A");

var $1zcRx = parcelRequire("1zcRx");
var $8RAwN = parcelRequire("8RAwN");
var $f9NmP = parcelRequire("f9NmP");


var $c8wlJ = parcelRequire("c8wlJ");

var $cjMfd = parcelRequire("cjMfd");

var $aXVsf = parcelRequire("aXVsf");

var $jyjJu = parcelRequire("jyjJu");

var $4SKzm = parcelRequire("4SKzm");

var $cVDai = parcelRequire("cVDai");
const $bcc348908a7dde4d$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $bcc348908a7dde4d$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $hCIyK.default)(options, $bcc348908a7dde4d$var$_excluded);
    if (options.vars) throw new Error((0, $avV9A.default)(18));
    const palette = (0, $cjMfd.default)(paletteInput);
    const systemTheme = (0, $1zcRx.default)(options);
    let muiTheme = (0, $5syur.default)(systemTheme, {
        mixins: (0, $c8wlJ.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jyjJu.default).slice(),
        typography: (0, $aXVsf.default)(palette, typographyInput),
        transitions: (0, $4SKzm.default)(transitionsInput),
        zIndex: (0, $4WYaH.default)({}, (0, $cVDai.default))
    });
    muiTheme = (0, $5syur.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $5syur.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $4WYaH.default)({}, (0, $8RAwN.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $bcc348908a7dde4d$var$warnedOnce = false;
function $bcc348908a7dde4d$export$c469355549431d9b(...args) {
    return $bcc348908a7dde4d$var$createTheme(...args);
}
var $bcc348908a7dde4d$export$2e2bcd8739ae039 = $bcc348908a7dde4d$var$createTheme;

});
parcelRegister("c8wlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d5f535890108345$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $8d5f535890108345$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $4WYaH.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("cjMfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f7caeba5148dee4$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");
var $avV9A = parcelRequire("avV9A");

var $jS8gC = parcelRequire("jS8gC");

var $7O7iL = parcelRequire("7O7iL");

var $8KKZ9 = parcelRequire("8KKZ9");

var $7KujM = parcelRequire("7KujM");

var $kJEL4 = parcelRequire("kJEL4");

var $bjzVt = parcelRequire("bjzVt");

var $gmWj5 = parcelRequire("gmWj5");

var $2hpx0 = parcelRequire("2hpx0");

var $bLCV4 = parcelRequire("bLCV4");
const $8f7caeba5148dee4$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $8f7caeba5148dee4$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $7O7iL.default).white,
        default: (0, $7O7iL.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $8f7caeba5148dee4$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $7O7iL.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $7O7iL.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $8f7caeba5148dee4$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $jS8gC.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $jS8gC.darken)(intent.main, tonalOffsetDark);
    }
}
function $8f7caeba5148dee4$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gmWj5.default)[200],
        light: (0, $gmWj5.default)[50],
        dark: (0, $gmWj5.default)[400]
    };
    return {
        main: (0, $gmWj5.default)[700],
        light: (0, $gmWj5.default)[400],
        dark: (0, $gmWj5.default)[800]
    };
}
function $8f7caeba5148dee4$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7KujM.default)[200],
        light: (0, $7KujM.default)[50],
        dark: (0, $7KujM.default)[400]
    };
    return {
        main: (0, $7KujM.default)[500],
        light: (0, $7KujM.default)[300],
        dark: (0, $7KujM.default)[700]
    };
}
function $8f7caeba5148dee4$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kJEL4.default)[500],
        light: (0, $kJEL4.default)[300],
        dark: (0, $kJEL4.default)[700]
    };
    return {
        main: (0, $kJEL4.default)[700],
        light: (0, $kJEL4.default)[400],
        dark: (0, $kJEL4.default)[800]
    };
}
function $8f7caeba5148dee4$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2hpx0.default)[400],
        light: (0, $2hpx0.default)[300],
        dark: (0, $2hpx0.default)[700]
    };
    return {
        main: (0, $2hpx0.default)[700],
        light: (0, $2hpx0.default)[500],
        dark: (0, $2hpx0.default)[900]
    };
}
function $8f7caeba5148dee4$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bLCV4.default)[400],
        light: (0, $bLCV4.default)[300],
        dark: (0, $bLCV4.default)[700]
    };
    return {
        main: (0, $bLCV4.default)[800],
        light: (0, $bLCV4.default)[500],
        dark: (0, $bLCV4.default)[900]
    };
}
function $8f7caeba5148dee4$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bjzVt.default)[400],
        light: (0, $bjzVt.default)[300],
        dark: (0, $bjzVt.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $bjzVt.default)[500],
        dark: (0, $bjzVt.default)[900]
    };
}
function $8f7caeba5148dee4$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $hCIyK.default)(palette, $8f7caeba5148dee4$var$_excluded);
    const primary = palette.primary || $8f7caeba5148dee4$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8f7caeba5148dee4$var$getDefaultSecondary(mode);
    const error = palette.error || $8f7caeba5148dee4$var$getDefaultError(mode);
    const info = palette.info || $8f7caeba5148dee4$var$getDefaultInfo(mode);
    const success = palette.success || $8f7caeba5148dee4$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8f7caeba5148dee4$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $jS8gC.getContrastRatio)(background, $8f7caeba5148dee4$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8f7caeba5148dee4$export$55ce6f3a06c59543.text.primary : $8f7caeba5148dee4$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $4WYaH.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $avV9A.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $avV9A.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $8f7caeba5148dee4$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $8f7caeba5148dee4$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $8f7caeba5148dee4$export$55ce6f3a06c59543,
        light: $8f7caeba5148dee4$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $5syur.default)((0, $4WYaH.default)({
        // A collection of common colors.
        common: (0, $4WYaH.default)({}, (0, $7O7iL.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $8KKZ9.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("jS8gC", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $e7797925b85e099e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $e7797925b85e099e$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $e7797925b85e099e$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $e7797925b85e099e$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $e7797925b85e099e$export$e665714f76e581fd; });

var $avV9A = parcelRequire("avV9A");

var $8fhtc = parcelRequire("8fhtc");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e7797925b85e099e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $8fhtc.default)(value, min, max);
}
function $e7797925b85e099e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $e7797925b85e099e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e7797925b85e099e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $e7797925b85e099e$export$677b39864803984e($e7797925b85e099e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $avV9A.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $avV9A.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e7797925b85e099e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e7797925b85e099e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $e7797925b85e099e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e7797925b85e099e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $e7797925b85e099e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $e7797925b85e099e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $e7797925b85e099e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e7797925b85e099e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $e7797925b85e099e$export$29fb7152bd3f781a(color) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $e7797925b85e099e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e7797925b85e099e$export$c852d90bf7403b62(color) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $e7797925b85e099e$export$677b39864803984e($e7797925b85e099e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e7797925b85e099e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e7797925b85e099e$export$c852d90bf7403b62(foreground);
    const lumB = $e7797925b85e099e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e7797925b85e099e$export$58f0f39f63f3cf42(color, value) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    value = $e7797925b85e099e$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e7797925b85e099e$export$211a73f2b8c10ce4(color);
}
function $e7797925b85e099e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e7797925b85e099e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$4b073707ff63303(color, coefficient) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    coefficient = $e7797925b85e099e$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e7797925b85e099e$export$211a73f2b8c10ce4(color);
}
function $e7797925b85e099e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e7797925b85e099e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$c0816ed86df316af(color, coefficient) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    coefficient = $e7797925b85e099e$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e7797925b85e099e$export$211a73f2b8c10ce4(color);
}
function $e7797925b85e099e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e7797925b85e099e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e7797925b85e099e$export$c852d90bf7403b62(color) > 0.5 ? $e7797925b85e099e$export$4b073707ff63303(color, coefficient) : $e7797925b85e099e$export$c0816ed86df316af(color, coefficient);
}
function $e7797925b85e099e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e7797925b85e099e$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e7797925b85e099e$export$677b39864803984e(background);
    const overlayColor = $e7797925b85e099e$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e7797925b85e099e$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("8fhtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600d469f4ea2b960$export$2e2bcd8739ae039; });
function $600d469f4ea2b960$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $600d469f4ea2b960$export$2e2bcd8739ae039 = $600d469f4ea2b960$var$clamp;

});


parcelRegister("7O7iL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af2ddd86bb7d498$export$2e2bcd8739ae039; });
const $5af2ddd86bb7d498$var$common = {
    black: "#000",
    white: "#fff"
};
var $5af2ddd86bb7d498$export$2e2bcd8739ae039 = $5af2ddd86bb7d498$var$common;

});

parcelRegister("8KKZ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65f710e911b7292d$export$2e2bcd8739ae039; });
const $65f710e911b7292d$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $65f710e911b7292d$export$2e2bcd8739ae039 = $65f710e911b7292d$var$grey;

});

parcelRegister("7KujM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4458d5f7fc7bf6$export$2e2bcd8739ae039; });
const $5a4458d5f7fc7bf6$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $5a4458d5f7fc7bf6$export$2e2bcd8739ae039 = $5a4458d5f7fc7bf6$var$purple;

});

parcelRegister("kJEL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f187a05573202cce$export$2e2bcd8739ae039; });
const $f187a05573202cce$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f187a05573202cce$export$2e2bcd8739ae039 = $f187a05573202cce$var$red;

});

parcelRegister("bjzVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83cd563b25e0fd36$export$2e2bcd8739ae039; });
const $83cd563b25e0fd36$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $83cd563b25e0fd36$export$2e2bcd8739ae039 = $83cd563b25e0fd36$var$orange;

});

parcelRegister("gmWj5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beabedf7811f9d48$export$2e2bcd8739ae039; });
const $beabedf7811f9d48$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $beabedf7811f9d48$export$2e2bcd8739ae039 = $beabedf7811f9d48$var$blue;

});

parcelRegister("2hpx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a90f95089dd0c31$export$2e2bcd8739ae039; });
const $1a90f95089dd0c31$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $1a90f95089dd0c31$export$2e2bcd8739ae039 = $1a90f95089dd0c31$var$lightBlue;

});

parcelRegister("bLCV4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $891246157fd9d9c5$export$2e2bcd8739ae039; });
const $891246157fd9d9c5$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $891246157fd9d9c5$export$2e2bcd8739ae039 = $891246157fd9d9c5$var$green;

});


parcelRegister("aXVsf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbbfb5695036e2b$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");
const $7fbbfb5695036e2b$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $7fbbfb5695036e2b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $7fbbfb5695036e2b$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $7fbbfb5695036e2b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $7fbbfb5695036e2b$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $7fbbfb5695036e2b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $hCIyK.default)(_ref, $7fbbfb5695036e2b$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $4WYaH.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $7fbbfb5695036e2b$var$defaultFontFamily ? {
            letterSpacing: `${$7fbbfb5695036e2b$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $7fbbfb5695036e2b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $7fbbfb5695036e2b$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $5syur.default)((0, $4WYaH.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jyjJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c07fd261e20251$export$2e2bcd8739ae039; });
const $e3c07fd261e20251$var$shadowKeyUmbraOpacity = 0.2;
const $e3c07fd261e20251$var$shadowKeyPenumbraOpacity = 0.14;
const $e3c07fd261e20251$var$shadowAmbientShadowOpacity = 0.12;
function $e3c07fd261e20251$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e3c07fd261e20251$var$shadows = [
    "none",
    $e3c07fd261e20251$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e3c07fd261e20251$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e3c07fd261e20251$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e3c07fd261e20251$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e3c07fd261e20251$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e3c07fd261e20251$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e3c07fd261e20251$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e3c07fd261e20251$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e3c07fd261e20251$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e3c07fd261e20251$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e3c07fd261e20251$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e3c07fd261e20251$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e3c07fd261e20251$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e3c07fd261e20251$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e3c07fd261e20251$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e3c07fd261e20251$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e3c07fd261e20251$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e3c07fd261e20251$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e3c07fd261e20251$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e3c07fd261e20251$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e3c07fd261e20251$export$2e2bcd8739ae039 = $e3c07fd261e20251$var$shadows;

});

parcelRegister("4SKzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e05443f54e4c38$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
const $38e05443f54e4c38$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $38e05443f54e4c38$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $38e05443f54e4c38$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $38e05443f54e4c38$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $38e05443f54e4c38$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $38e05443f54e4c38$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $4WYaH.default)({}, $38e05443f54e4c38$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $4WYaH.default)({}, $38e05443f54e4c38$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $hCIyK.default)(options, $38e05443f54e4c38$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $38e05443f54e4c38$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $38e05443f54e4c38$var$formatMs(delay)}`).join(",");
    };
    return (0, $4WYaH.default)({
        getAutoHeightDuration: $38e05443f54e4c38$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("cVDai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9699304106843fdd$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $9699304106843fdd$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $9699304106843fdd$export$2e2bcd8739ae039 = $9699304106843fdd$var$zIndex;

});



parcelRegister("wllwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06138c31a4420582$export$2e2bcd8739ae039; });
var $06138c31a4420582$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("g4l1t", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "default", function () { return $bb2d53ba8ea7fa4b$export$2e2bcd8739ae039; });

var $kX6Uk = parcelRequire("kX6Uk");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
const $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa = (prop)=>(0, $kX6Uk.shouldForwardProp)(prop) && prop !== "classes";
const $bb2d53ba8ea7fa4b$export$f10c5a10d27438e5 = (0, $kX6Uk.shouldForwardProp);
const $bb2d53ba8ea7fa4b$var$styled = (0, $kX6Uk.default)({
    themeId: (0, $wllwT.default),
    defaultTheme: $OFmxN.default,
    rootShouldForwardProp: $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa
});
var $bb2d53ba8ea7fa4b$export$2e2bcd8739ae039 = $bb2d53ba8ea7fa4b$var$styled;

});
parcelRegister("kX6Uk", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $f40ead0023894a05$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $f40ead0023894a05$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $8BdII = parcelRequire("8BdII");

var $5syur = parcelRequire("5syur");



var $1zcRx = parcelRequire("1zcRx");

var $f9NmP = parcelRequire("f9NmP");
const $f40ead0023894a05$var$_excluded = [
    "ownerState"
], $f40ead0023894a05$var$_excluded2 = [
    "variants"
], $f40ead0023894a05$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $f40ead0023894a05$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $f40ead0023894a05$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $f40ead0023894a05$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $f40ead0023894a05$export$35e57303dbd8a66 = (0, $1zcRx.default)();
const $f40ead0023894a05$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $f40ead0023894a05$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $f40ead0023894a05$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $f40ead0023894a05$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $f40ead0023894a05$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $hCIyK.default)(_ref, $f40ead0023894a05$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $4WYaH.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$f40ead0023894a05$var$processStyleArg(resolvedStyle, (0, $4WYaH.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $hCIyK.default)(resolvedStylesArg, $f40ead0023894a05$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $4WYaH.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $4WYaH.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $f40ead0023894a05$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $f40ead0023894a05$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $f40ead0023894a05$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $f40ead0023894a05$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $f9NmP.default)((0, $4WYaH.default)({}, props, {
            theme: $f40ead0023894a05$var$resolveTheme((0, $4WYaH.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $8BdII.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $f40ead0023894a05$var$defaultOverridesResolver($f40ead0023894a05$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $hCIyK.default)(inputOptions, $f40ead0023894a05$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $f40ead0023894a05$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($f40ead0023894a05$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $8BdII.default)(tag, (0, $4WYaH.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $5syur.isPlainObject)(stylesArg)) return (props)=>$f40ead0023894a05$var$processStyleArg(stylesArg, (0, $4WYaH.default)({}, props, {
                    theme: $f40ead0023894a05$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $f40ead0023894a05$var$resolveTheme((0, $4WYaH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $f40ead0023894a05$var$processStyleArg(slotStyle, (0, $4WYaH.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $f40ead0023894a05$var$resolveTheme((0, $4WYaH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $f40ead0023894a05$var$processStyleArg({
                    variants: themeVariants
                }, (0, $4WYaH.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("8BdII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $642c6bfe92b66bd8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $642c6bfe92b66bd8$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $cieRD = parcelRequire("cieRD");

var $7hler = parcelRequire("7hler");
var $iwq56 = parcelRequire("iwq56");


var $6SFe5 = parcelRequire("6SFe5");
"use client";
function $642c6bfe92b66bd8$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $cieRD.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $642c6bfe92b66bd8$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("cieRD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f32b2315dff74ec$export$2e2bcd8739ae039; });

var $iJl1t = parcelRequire("iJl1t");
parcelRequire("3Tqyg");
parcelRequire("bh6RR");
parcelRequire("e94ba");

parcelRequire("cdpIC");
parcelRequire("9v6T8");
parcelRequire("fPHYJ");
var $8f32b2315dff74ec$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $8f32b2315dff74ec$export$2e2bcd8739ae039 = (0, $iJl1t.default).bind();
$8f32b2315dff74ec$var$tags.forEach(function(tagName) {
    $8f32b2315dff74ec$export$2e2bcd8739ae039[tagName] = $8f32b2315dff74ec$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("iJl1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da2cbca4295b47ea$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $e94ba = parcelRequire("e94ba");
parcelRequire("7hler");
var $iwq56 = parcelRequire("iwq56");

var $cdpIC = parcelRequire("cdpIC");

var $9v6T8 = parcelRequire("9v6T8");

var $fPHYJ = parcelRequire("fPHYJ");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $da2cbca4295b47ea$var$testOmitPropsOnStringTag = (0, $e94ba.default);
var $da2cbca4295b47ea$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $da2cbca4295b47ea$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $da2cbca4295b47ea$var$testOmitPropsOnStringTag : $da2cbca4295b47ea$var$testOmitPropsOnComponent;
};
var $da2cbca4295b47ea$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $da2cbca4295b47ea$var$isDevelopment = false;
var $da2cbca4295b47ea$var$isBrowser = typeof document !== "undefined";
var $da2cbca4295b47ea$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cdpIC.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cdpIC.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$da2cbca4295b47ea$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $da2cbca4295b47ea$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $da2cbca4295b47ea$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $da2cbca4295b47ea$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $iwq56.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $bh6RR.useContext((0, $iwq56.T));
            }
            if (typeof props.className === "string") className = (0, $cdpIC.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $9v6T8.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $da2cbca4295b47ea$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($da2cbca4295b47ea$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $bh6RR.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $da2cbca4295b47ea$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $4WYaH.default)({}, options, nextOptions, {
                shouldForwardProp: $da2cbca4295b47ea$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("e94ba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c525d7dbc25949$export$2e2bcd8739ae039; });

var $cthCm = parcelRequire("cthCm");
// eslint-disable-next-line no-undef
var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cthCm.default)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("6SFe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5027c3e86ace5307$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");


var $7hler = parcelRequire("7hler");

var $ih19M = parcelRequire("ih19M");
"use client";
function $5027c3e86ace5307$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $5027c3e86ace5307$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($5027c3e86ace5307$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7hler.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("ih19M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("0qhf8"));

});





parcelRegister("b2lJO", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $8090be528a37166c$export$c7c50641356bdfa5; });

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $8090be528a37166c$export$c7c50641356bdfa5(slot) {
    return (0, $dmzXD.default)("MuiSvgIcon", slot);
}
const $8090be528a37166c$var$svgIconClasses = (0, $fYlYP.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $8090be528a37166c$export$2e2bcd8739ae039 = $8090be528a37166c$var$svgIconClasses;

});
parcelRegister("fYlYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0d826601bdb89a$export$2e2bcd8739ae039; });

var $dmzXD = parcelRequire("dmzXD");
function $ba0d826601bdb89a$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dmzXD.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dmzXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ba9398501f2167d$export$2e2bcd8739ae039; });

var $7tI36 = parcelRequire("7tI36");
const $9ba9398501f2167d$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $9ba9398501f2167d$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $9ba9398501f2167d$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $7tI36.default).generate(componentName)}-${slot}`;
}
function $9ba9398501f2167d$export$34c0130b1f3e8ae3(slot) {
    return $9ba9398501f2167d$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("7tI36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $571d691533056500$export$2e2bcd8739ae039; });
const $571d691533056500$var$defaultGenerator = (componentName)=>componentName;
const $571d691533056500$var$createClassNameGenerator = ()=>{
    let generate = $571d691533056500$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $571d691533056500$var$defaultGenerator;
        }
    };
};
const $571d691533056500$var$ClassNameGenerator = $571d691533056500$var$createClassNameGenerator();
var $571d691533056500$export$2e2bcd8739ae039 = $571d691533056500$var$ClassNameGenerator;

});








var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $b8f852338811df1a$export$30d21fd6d7295f52(pathname);
        matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $b8f852338811df1a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:[\w-]+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b8f852338811df1a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b8f852338811df1a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $b8f852338811df1a$export$4051a07651545597(data, init) {
    return new $b8f852338811df1a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b8f852338811df1a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $b8f852338811df1a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$b8f852338811df1a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$b8f852338811df1a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b8f852338811df1a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b8f852338811df1a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $b8f852338811df1a$var$findNearestBoundary(matches).route.id,
            {
                type: $b8f852338811df1a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b8f852338811df1a$var$isErrorResult(result) && $b8f852338811df1a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $b8f852338811df1a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: updatedMatches || matches
        }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $b8f852338811df1a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($b8f852338811df1a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $b8f852338811df1a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $b8f852338811df1a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult) || $b8f852338811df1a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $b8f852338811df1a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $b8f852338811df1a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $b8f852338811df1a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($b8f852338811df1a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $b8f852338811df1a$var$ResultType.redirect,
                response: $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $b8f852338811df1a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: $b8f852338811df1a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $b8f852338811df1a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $b8f852338811df1a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($b8f852338811df1a$var$isDataStrategyResult(e) && $b8f852338811df1a$var$isResponse(e.result)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $b8f852338811df1a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategy || $b8f852338811df1a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($b8f852338811df1a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($b8f852338811df1a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $b8f852338811df1a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: $b8f852338811df1a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $b8f852338811df1a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $b8f852338811df1a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $b8f852338811df1a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$b8f852338811df1a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $b8f852338811df1a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$b8f852338811df1a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $b8f852338811df1a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $b8f852338811df1a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $b8f852338811df1a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $b8f852338811df1a$var$ResultType.data,
                result: undefined
            });
        };
        return $b8f852338811df1a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b8f852338811df1a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($b8f852338811df1a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b8f852338811df1a$var$ResultType.error,
                error: e
            };
        }
        if (type === $b8f852338811df1a$var$ResultType.error) return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: new $b8f852338811df1a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $b8f852338811df1a$var$ResultType.error) {
        if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $b8f852338811df1a$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: result,
            statusCode: $b8f852338811df1a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $b8f852338811df1a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($b8f852338811df1a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $b8f852338811df1a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $b8f852338811df1a$var$ResultType.data || result.type === $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isRedirectDataStrategyResultResult(result) {
    return $b8f852338811df1a$var$isResponse(result.result) && $b8f852338811df1a$var$redirectStatusCodes.has(result.result.status);
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $b8f852338811df1a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $b8f852338811df1a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b8f852338811df1a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b8f852338811df1a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b8f852338811df1a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$81336c211d5ff295)(pattern, (0, $b8f852338811df1a$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $b8f852338811df1a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $b8f852338811df1a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6a9dcc96d11bcd0d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6a9dcc96d11bcd0d$var$DataRouterHook || {});
var $6a9dcc96d11bcd0d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6a9dcc96d11bcd0d$var$DataRouterStateHook || {});
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return $bh6RR.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $b8f852338811df1a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $b8f852338811df1a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        if (v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl) $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, (0, $b8f852338811df1a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6a9dcc96d11bcd0d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6a9dcc96d11bcd0d$var$AwaitRenderStatus || {});
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : "_data" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $b8f852338811df1a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bh6RR.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $b8f852338811df1a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0bd3411f2ec14e23$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bh6RR.createContext({
    isTransitioning: false
});
const $0bd3411f2ec14e23$export$148fd98d095596d4 = /*#__PURE__*/ $bh6RR.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
const $0bd3411f2ec14e23$var$FLUSH_SYNC = "flushSync";
const $0bd3411f2ec14e23$var$flushSyncImpl = $47cfd4084854a574$exports[$0bd3411f2ec14e23$var$FLUSH_SYNC];
const $0bd3411f2ec14e23$var$USE_ID = "useId";
const $0bd3411f2ec14e23$var$useIdImpl = $bh6RR[$0bd3411f2ec14e23$var$USE_ID];
function $0bd3411f2ec14e23$var$startTransitionSafe(cb) {
    if ($0bd3411f2ec14e23$var$startTransitionImpl) $0bd3411f2ec14e23$var$startTransitionImpl(cb);
    else cb();
}
function $0bd3411f2ec14e23$var$flushSyncSafe(cb) {
    if ($0bd3411f2ec14e23$var$flushSyncImpl) $0bd3411f2ec14e23$var$flushSyncImpl(cb);
    else cb();
}
class $0bd3411f2ec14e23$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0bd3411f2ec14e23$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bh6RR.useCallback((cb)=>{
        if (v7_startTransition) $0bd3411f2ec14e23$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bh6RR.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0bd3411f2ec14e23$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $bh6RR.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0bd3411f2ec14e23$var$MemoizedDataRoutes = /*#__PURE__*/ $bh6RR.memo($0bd3411f2ec14e23$var$DataRoutes);
function $0bd3411f2ec14e23$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $6a9dcc96d11bcd0d$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref7, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $6a9dcc96d11bcd0d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref8, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let routerState = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0bd3411f2ec14e23$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref9, $0bd3411f2ec14e23$var$_excluded3);
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
// Internal hooks
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e));
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $b8f852338811df1a$export$fe53371bee54353d)(location) === (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
let $0bd3411f2ec14e23$var$getUniqueFetcherId = ()=>"__" + String(++$0bd3411f2ec14e23$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let currentRouteId = (0, $6a9dcc96d11bcd0d$export$5fc8298006ad9e58)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0bd3411f2ec14e23$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let routeContext = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    !routeContext && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bh6RR.useContext($0bd3411f2ec14e23$export$148fd98d095596d4);
    let route = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0bd3411f2ec14e23$var$useIdImpl ? $0bd3411f2ec14e23$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0bd3411f2ec14e23$var$getUniqueFetcherId());
    // Registration/cleanup
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bh6RR.useCallback((href, opts)=>{
        !routeId && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback((target, opts)=>{
        submitImpl(target, $0bd3411f2ec14e23$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a7fed597f4b8afd8, $0bd3411f2ec14e23$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $b8f852338811df1a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0bd3411f2ec14e23$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let matches = (0, $6a9dcc96d11bcd0d$export$2378eb7f5ff86053)();
    let navigation = (0, $6a9dcc96d11bcd0d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $6a9dcc96d11bcd0d$export$b273b3273281a049)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0bd3411f2ec14e23$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bh6RR.useContext($0bd3411f2ec14e23$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.useViewTransitionState);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $b8f852338811df1a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $b8f852338811df1a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


const $e4be14b5d2706883$var$noop = ()=>{};
let $e4be14b5d2706883$var$_WINDOW = {};
let $e4be14b5d2706883$var$_DOCUMENT = {};
let $e4be14b5d2706883$var$_MUTATION_OBSERVER = null;
let $e4be14b5d2706883$var$_PERFORMANCE = {
    mark: $e4be14b5d2706883$var$noop,
    measure: $e4be14b5d2706883$var$noop
};
try {
    if (typeof window !== "undefined") $e4be14b5d2706883$var$_WINDOW = window;
    if (typeof document !== "undefined") $e4be14b5d2706883$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $e4be14b5d2706883$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $e4be14b5d2706883$var$_PERFORMANCE = performance;
} catch (e) {}
const { userAgent: $e4be14b5d2706883$var$userAgent = "" } = $e4be14b5d2706883$var$_WINDOW.navigator || {};
const $e4be14b5d2706883$var$WINDOW = $e4be14b5d2706883$var$_WINDOW;
const $e4be14b5d2706883$var$DOCUMENT = $e4be14b5d2706883$var$_DOCUMENT;
const $e4be14b5d2706883$var$MUTATION_OBSERVER = $e4be14b5d2706883$var$_MUTATION_OBSERVER;
const $e4be14b5d2706883$var$PERFORMANCE = $e4be14b5d2706883$var$_PERFORMANCE;
const $e4be14b5d2706883$var$IS_BROWSER = !!$e4be14b5d2706883$var$WINDOW.document;
const $e4be14b5d2706883$var$IS_DOM = !!$e4be14b5d2706883$var$DOCUMENT.documentElement && !!$e4be14b5d2706883$var$DOCUMENT.head && typeof $e4be14b5d2706883$var$DOCUMENT.addEventListener === "function" && typeof $e4be14b5d2706883$var$DOCUMENT.createElement === "function";
const $e4be14b5d2706883$var$IS_IE = ~$e4be14b5d2706883$var$userAgent.indexOf("MSIE") || ~$e4be14b5d2706883$var$userAgent.indexOf("Trident/");
var $e4be14b5d2706883$var$a = "classic", $e4be14b5d2706883$var$t = "duotone", $e4be14b5d2706883$var$r = "sharp", $e4be14b5d2706883$var$o = "sharp-duotone", $e4be14b5d2706883$var$c = [
    $e4be14b5d2706883$var$a,
    $e4be14b5d2706883$var$t,
    $e4be14b5d2706883$var$r,
    $e4be14b5d2706883$var$o
];
var $e4be14b5d2706883$var$et$1 = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds"
    }
};
var $e4be14b5d2706883$var$bt = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $e4be14b5d2706883$var$Ct = [
    "kit"
];
var $e4be14b5d2706883$var$Dt = /fa(s|r|l|t|d|b|k|kd|ss|sr|sl|st|sds)?[\-\ ]/, $e4be14b5d2706883$var$Kt = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var $e4be14b5d2706883$var$ao = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
var $e4be14b5d2706883$var$eo = {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds"
    }
}, $e4be14b5d2706883$var$lo = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds"
    }
}, $e4be14b5d2706883$var$y = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds"
    ]
}, $e4be14b5d2706883$var$no = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid"
    }
}, $e4be14b5d2706883$var$fo = {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        duotone: "fad",
        brands: "fab"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds"
    }
}, $e4be14b5d2706883$var$ho = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fad: "duotone",
        "fa-duotone": "duotone",
        fab: "brands",
        "fa-brands": "brands"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid"
    }
}, $e4be14b5d2706883$var$x$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands"
], $e4be14b5d2706883$var$u$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $e4be14b5d2706883$var$m$1 = $e4be14b5d2706883$var$u$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $e4be14b5d2706883$var$t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $e4be14b5d2706883$var$yo = [
    ...Object.keys($e4be14b5d2706883$var$y),
    ...$e4be14b5d2706883$var$x$1,
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $e4be14b5d2706883$var$t$1.GROUP,
    $e4be14b5d2706883$var$t$1.SWAP_OPACITY,
    $e4be14b5d2706883$var$t$1.PRIMARY,
    $e4be14b5d2706883$var$t$1.SECONDARY
].concat($e4be14b5d2706883$var$u$1.map((o)=>"".concat(o, "x"))).concat($e4be14b5d2706883$var$m$1.map((o)=>"w-".concat(o)));
var $e4be14b5d2706883$var$mo = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}, $e4be14b5d2706883$var$Io = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
}, $e4be14b5d2706883$var$Fo = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
}, $e4be14b5d2706883$var$So = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
const $e4be14b5d2706883$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
const $e4be14b5d2706883$var$UNITS_IN_GRID = 16;
const $e4be14b5d2706883$var$DEFAULT_CSS_PREFIX = "fa";
const $e4be14b5d2706883$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
const $e4be14b5d2706883$var$DATA_FA_I2SVG = "data-fa-i2svg";
const $e4be14b5d2706883$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
const $e4be14b5d2706883$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
const $e4be14b5d2706883$var$DATA_PREFIX = "data-prefix";
const $e4be14b5d2706883$var$DATA_ICON = "data-icon";
const $e4be14b5d2706883$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
const $e4be14b5d2706883$var$MUTATION_APPROACH_ASYNC = "async";
const $e4be14b5d2706883$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
const $e4be14b5d2706883$var$PRODUCTION = (()=>{
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
})();
const $e4be14b5d2706883$var$FAMILIES = [
    $e4be14b5d2706883$var$a,
    $e4be14b5d2706883$var$r,
    $e4be14b5d2706883$var$o
];
function $e4be14b5d2706883$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get (target, prop) {
            return prop in target ? target[prop] : target[$e4be14b5d2706883$var$a];
        }
    });
}
const $e4be14b5d2706883$var$_PREFIX_TO_STYLE = {
    ...$e4be14b5d2706883$var$ho
};
$e4be14b5d2706883$var$_PREFIX_TO_STYLE[$e4be14b5d2706883$var$a] = {
    ...$e4be14b5d2706883$var$ho[$e4be14b5d2706883$var$a],
    ...$e4be14b5d2706883$var$bt["kit"],
    ...$e4be14b5d2706883$var$bt["kit-duotone"]
};
const $e4be14b5d2706883$var$PREFIX_TO_STYLE = $e4be14b5d2706883$var$familyProxy($e4be14b5d2706883$var$_PREFIX_TO_STYLE);
const $e4be14b5d2706883$var$_STYLE_TO_PREFIX = {
    ...$e4be14b5d2706883$var$fo
};
$e4be14b5d2706883$var$_STYLE_TO_PREFIX[$e4be14b5d2706883$var$a] = {
    ...$e4be14b5d2706883$var$_STYLE_TO_PREFIX[$e4be14b5d2706883$var$a],
    ...$e4be14b5d2706883$var$So["kit"],
    ...$e4be14b5d2706883$var$So["kit-duotone"]
};
const $e4be14b5d2706883$var$STYLE_TO_PREFIX = $e4be14b5d2706883$var$familyProxy($e4be14b5d2706883$var$_STYLE_TO_PREFIX);
const $e4be14b5d2706883$var$_PREFIX_TO_LONG_STYLE = {
    ...$e4be14b5d2706883$var$no
};
$e4be14b5d2706883$var$_PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$a] = {
    ...$e4be14b5d2706883$var$_PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$a],
    ...$e4be14b5d2706883$var$Fo["kit"]
};
const $e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE = $e4be14b5d2706883$var$familyProxy($e4be14b5d2706883$var$_PREFIX_TO_LONG_STYLE);
const $e4be14b5d2706883$var$_LONG_STYLE_TO_PREFIX = {
    ...$e4be14b5d2706883$var$lo
};
$e4be14b5d2706883$var$_LONG_STYLE_TO_PREFIX[$e4be14b5d2706883$var$a] = {
    ...$e4be14b5d2706883$var$_LONG_STYLE_TO_PREFIX[$e4be14b5d2706883$var$a],
    ...$e4be14b5d2706883$var$Io["kit"]
};
const $e4be14b5d2706883$var$LONG_STYLE_TO_PREFIX = $e4be14b5d2706883$var$familyProxy($e4be14b5d2706883$var$_LONG_STYLE_TO_PREFIX);
const $e4be14b5d2706883$var$ICON_SELECTION_SYNTAX_PATTERN = $e4be14b5d2706883$var$Dt; // eslint-disable-line no-useless-escape
const $e4be14b5d2706883$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
const $e4be14b5d2706883$var$FONT_FAMILY_PATTERN = $e4be14b5d2706883$var$Kt;
const $e4be14b5d2706883$var$_FONT_WEIGHT_TO_PREFIX = {
    ...$e4be14b5d2706883$var$et$1
};
const $e4be14b5d2706883$var$FONT_WEIGHT_TO_PREFIX = $e4be14b5d2706883$var$familyProxy($e4be14b5d2706883$var$_FONT_WEIGHT_TO_PREFIX);
const $e4be14b5d2706883$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
const $e4be14b5d2706883$var$DUOTONE_CLASSES = $e4be14b5d2706883$var$t$1;
const $e4be14b5d2706883$var$prefixes = new Set();
Object.keys($e4be14b5d2706883$var$STYLE_TO_PREFIX[$e4be14b5d2706883$var$a]).map($e4be14b5d2706883$var$prefixes.add.bind($e4be14b5d2706883$var$prefixes));
Object.keys($e4be14b5d2706883$var$STYLE_TO_PREFIX[$e4be14b5d2706883$var$r]).map($e4be14b5d2706883$var$prefixes.add.bind($e4be14b5d2706883$var$prefixes));
Object.keys($e4be14b5d2706883$var$STYLE_TO_PREFIX[$e4be14b5d2706883$var$o]).map($e4be14b5d2706883$var$prefixes.add.bind($e4be14b5d2706883$var$prefixes));
const $e4be14b5d2706883$var$RESERVED_CLASSES = [
    ...$e4be14b5d2706883$var$Ct,
    ...$e4be14b5d2706883$var$yo
];
const $e4be14b5d2706883$var$initial = $e4be14b5d2706883$var$WINDOW.FontAwesomeConfig || {};
function $e4be14b5d2706883$var$getAttrConfig(attr) {
    var element = $e4be14b5d2706883$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $e4be14b5d2706883$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($e4be14b5d2706883$var$DOCUMENT && typeof $e4be14b5d2706883$var$DOCUMENT.querySelector === "function") {
    const attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    attrs.forEach((_ref)=>{
        let [attr, key] = _ref;
        const val = $e4be14b5d2706883$var$coerce($e4be14b5d2706883$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $e4be14b5d2706883$var$initial[key] = val;
    });
}
const $e4be14b5d2706883$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $e4be14b5d2706883$var$DEFAULT_CSS_PREFIX,
    replacementClass: $e4be14b5d2706883$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($e4be14b5d2706883$var$initial.familyPrefix) $e4be14b5d2706883$var$initial.cssPrefix = $e4be14b5d2706883$var$initial.familyPrefix;
const $e4be14b5d2706883$var$_config = {
    ...$e4be14b5d2706883$var$_default,
    ...$e4be14b5d2706883$var$initial
};
if (!$e4be14b5d2706883$var$_config.autoReplaceSvg) $e4be14b5d2706883$var$_config.observeMutations = false;
const $e4be14b5d2706883$var$config = {};
Object.keys($e4be14b5d2706883$var$_default).forEach((key)=>{
    Object.defineProperty($e4be14b5d2706883$var$config, key, {
        enumerable: true,
        set: function(val) {
            $e4be14b5d2706883$var$_config[key] = val;
            $e4be14b5d2706883$var$_onChangeCb.forEach((cb)=>cb($e4be14b5d2706883$var$config));
        },
        get: function() {
            return $e4be14b5d2706883$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($e4be14b5d2706883$var$config, "familyPrefix", {
    enumerable: true,
    set: function(val) {
        $e4be14b5d2706883$var$_config.cssPrefix = val;
        $e4be14b5d2706883$var$_onChangeCb.forEach((cb)=>cb($e4be14b5d2706883$var$config));
    },
    get: function() {
        return $e4be14b5d2706883$var$_config.cssPrefix;
    }
});
$e4be14b5d2706883$var$WINDOW.FontAwesomeConfig = $e4be14b5d2706883$var$config;
const $e4be14b5d2706883$var$_onChangeCb = [];
function $e4be14b5d2706883$var$onChange(cb) {
    $e4be14b5d2706883$var$_onChangeCb.push(cb);
    return ()=>{
        $e4be14b5d2706883$var$_onChangeCb.splice($e4be14b5d2706883$var$_onChangeCb.indexOf(cb), 1);
    };
}
const $e4be14b5d2706883$var$d$2 = $e4be14b5d2706883$var$UNITS_IN_GRID;
const $e4be14b5d2706883$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $e4be14b5d2706883$var$insertCss(css) {
    if (!css || !$e4be14b5d2706883$var$IS_DOM) return;
    const style = $e4be14b5d2706883$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    const headChildren = $e4be14b5d2706883$var$DOCUMENT.head.childNodes;
    let beforeChild = null;
    for(let i = headChildren.length - 1; i > -1; i--){
        const child = headChildren[i];
        const tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $e4be14b5d2706883$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
const $e4be14b5d2706883$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $e4be14b5d2706883$var$nextUniqueId() {
    let size = 12;
    let id = "";
    while(size-- > 0)id += $e4be14b5d2706883$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $e4be14b5d2706883$var$toArray(obj) {
    const array = [];
    for(let i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $e4be14b5d2706883$var$classArray(node) {
    if (node.classList) return $e4be14b5d2706883$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter((i)=>i);
}
function $e4be14b5d2706883$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $e4be14b5d2706883$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce((acc, attributeName)=>{
        return acc + "".concat(attributeName, '="').concat($e4be14b5d2706883$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $e4be14b5d2706883$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce((acc, styleName)=>{
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $e4be14b5d2706883$var$transformIsMeaningful(transform) {
    return transform.size !== $e4be14b5d2706883$var$meaninglessTransform.size || transform.x !== $e4be14b5d2706883$var$meaninglessTransform.x || transform.y !== $e4be14b5d2706883$var$meaninglessTransform.y || transform.rotate !== $e4be14b5d2706883$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $e4be14b5d2706883$var$transformForSvg(_ref) {
    let { transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
    const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $e4be14b5d2706883$var$transformForCss(_ref2) {
    let { transform: transform, width: width = $e4be14b5d2706883$var$UNITS_IN_GRID, height: height = $e4be14b5d2706883$var$UNITS_IN_GRID, startCentered: startCentered = false } = _ref2;
    let val = "";
    if (startCentered && $e4be14b5d2706883$var$IS_IE) val += "translate(".concat(transform.x / $e4be14b5d2706883$var$d$2 - width / 2, "em, ").concat(transform.y / $e4be14b5d2706883$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $e4be14b5d2706883$var$d$2, "em), calc(-50% + ").concat(transform.y / $e4be14b5d2706883$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $e4be14b5d2706883$var$d$2, "em, ").concat(transform.y / $e4be14b5d2706883$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $e4be14b5d2706883$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $e4be14b5d2706883$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $e4be14b5d2706883$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $e4be14b5d2706883$var$css() {
    const dcp = $e4be14b5d2706883$var$DEFAULT_CSS_PREFIX;
    const drc = $e4be14b5d2706883$var$DEFAULT_REPLACEMENT_CLASS;
    const fp = $e4be14b5d2706883$var$config.cssPrefix;
    const rc = $e4be14b5d2706883$var$config.replacementClass;
    let s = $e4be14b5d2706883$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        const dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        const rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
let $e4be14b5d2706883$var$_cssInserted = false;
function $e4be14b5d2706883$var$ensureCss() {
    if ($e4be14b5d2706883$var$config.autoAddCss && !$e4be14b5d2706883$var$_cssInserted) {
        $e4be14b5d2706883$var$insertCss($e4be14b5d2706883$var$css());
        $e4be14b5d2706883$var$_cssInserted = true;
    }
}
var $e4be14b5d2706883$var$InjectCSS = {
    mixout () {
        return {
            dom: {
                css: $e4be14b5d2706883$var$css,
                insertCss: $e4be14b5d2706883$var$ensureCss
            }
        };
    },
    hooks () {
        return {
            beforeDOMElementCreation () {
                $e4be14b5d2706883$var$ensureCss();
            },
            beforeI2svg () {
                $e4be14b5d2706883$var$ensureCss();
            }
        };
    }
};
const $e4be14b5d2706883$var$w$1 = $e4be14b5d2706883$var$WINDOW || {};
if (!$e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER]) $e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER] = {};
if (!$e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER].styles) $e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER].hooks) $e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER].shims) $e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER].shims = [];
var $e4be14b5d2706883$var$namespace = $e4be14b5d2706883$var$w$1[$e4be14b5d2706883$var$NAMESPACE_IDENTIFIER];
const $e4be14b5d2706883$var$functions = [];
const $e4be14b5d2706883$var$listener = function() {
    $e4be14b5d2706883$var$DOCUMENT.removeEventListener("DOMContentLoaded", $e4be14b5d2706883$var$listener);
    $e4be14b5d2706883$var$loaded = 1;
    $e4be14b5d2706883$var$functions.map((fn)=>fn());
};
let $e4be14b5d2706883$var$loaded = false;
if ($e4be14b5d2706883$var$IS_DOM) {
    $e4be14b5d2706883$var$loaded = ($e4be14b5d2706883$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($e4be14b5d2706883$var$DOCUMENT.readyState);
    if (!$e4be14b5d2706883$var$loaded) $e4be14b5d2706883$var$DOCUMENT.addEventListener("DOMContentLoaded", $e4be14b5d2706883$var$listener);
}
function $e4be14b5d2706883$var$domready(fn) {
    if (!$e4be14b5d2706883$var$IS_DOM) return;
    $e4be14b5d2706883$var$loaded ? setTimeout(fn, 0) : $e4be14b5d2706883$var$functions.push(fn);
}
function $e4be14b5d2706883$var$toHtml(abstractNodes) {
    const { tag: tag, attributes: attributes = {}, children: children = [] } = abstractNodes;
    if (typeof abstractNodes === "string") return $e4be14b5d2706883$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($e4be14b5d2706883$var$joinAttributes(attributes), ">").concat(children.map($e4be14b5d2706883$var$toHtml).join(""), "</").concat(tag, ">");
}
function $e4be14b5d2706883$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $e4be14b5d2706883$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $e4be14b5d2706883$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $e4be14b5d2706883$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $e4be14b5d2706883$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $e4be14b5d2706883$var$toHex(unicode) {
    const decoded = $e4be14b5d2706883$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $e4be14b5d2706883$var$codePointAt(string, index) {
    const size = string.length;
    let first = string.charCodeAt(index);
    let second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $e4be14b5d2706883$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName)=>{
        const icon = icons[iconName];
        const expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $e4be14b5d2706883$var$defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { skipHooks: skipHooks = false } = params;
    const normalized = $e4be14b5d2706883$var$normalizeIcons(icons);
    if (typeof $e4be14b5d2706883$var$namespace.hooks.addPack === "function" && !skipHooks) $e4be14b5d2706883$var$namespace.hooks.addPack(prefix, $e4be14b5d2706883$var$normalizeIcons(icons));
    else $e4be14b5d2706883$var$namespace.styles[prefix] = {
        ...$e4be14b5d2706883$var$namespace.styles[prefix] || {},
        ...normalized
    };
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $e4be14b5d2706883$var$defineIcons("fa", icons);
}
const { styles: $e4be14b5d2706883$var$styles, shims: $e4be14b5d2706883$var$shims } = $e4be14b5d2706883$var$namespace;
const $e4be14b5d2706883$var$LONG_STYLE = {
    [$e4be14b5d2706883$var$a]: Object.values($e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$a]),
    [$e4be14b5d2706883$var$r]: Object.values($e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$r]),
    [$e4be14b5d2706883$var$o]: Object.values($e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$o])
};
let $e4be14b5d2706883$var$_defaultUsablePrefix = null;
let $e4be14b5d2706883$var$_byUnicode = {};
let $e4be14b5d2706883$var$_byLigature = {};
let $e4be14b5d2706883$var$_byOldName = {};
let $e4be14b5d2706883$var$_byOldUnicode = {};
let $e4be14b5d2706883$var$_byAlias = {};
const $e4be14b5d2706883$var$PREFIXES = {
    [$e4be14b5d2706883$var$a]: Object.keys($e4be14b5d2706883$var$PREFIX_TO_STYLE[$e4be14b5d2706883$var$a]),
    [$e4be14b5d2706883$var$r]: Object.keys($e4be14b5d2706883$var$PREFIX_TO_STYLE[$e4be14b5d2706883$var$r]),
    [$e4be14b5d2706883$var$o]: Object.keys($e4be14b5d2706883$var$PREFIX_TO_STYLE[$e4be14b5d2706883$var$o])
};
function $e4be14b5d2706883$var$isReserved(name) {
    return ~$e4be14b5d2706883$var$RESERVED_CLASSES.indexOf(name);
}
function $e4be14b5d2706883$var$getIconName(cssPrefix, cls) {
    const parts = cls.split("-");
    const prefix = parts[0];
    const iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$e4be14b5d2706883$var$isReserved(iconName)) return iconName;
    else return null;
}
const $e4be14b5d2706883$var$build = ()=>{
    const lookup = (reducer)=>{
        return $e4be14b5d2706883$var$reduce($e4be14b5d2706883$var$styles, (o$$1, style, prefix)=>{
            o$$1[prefix] = $e4be14b5d2706883$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $e4be14b5d2706883$var$_byUnicode = lookup((acc, icon, iconName)=>{
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === "number";
            });
            aliases.forEach((alias)=>{
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $e4be14b5d2706883$var$_byLigature = lookup((acc, icon, iconName)=>{
        acc[iconName] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === "string";
            });
            aliases.forEach((alias)=>{
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $e4be14b5d2706883$var$_byAlias = lookup((acc, icon, iconName)=>{
        const aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach((alias)=>{
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    const hasRegular = "far" in $e4be14b5d2706883$var$styles || $e4be14b5d2706883$var$config.autoFetchSvg;
    const shimLookups = $e4be14b5d2706883$var$reduce($e4be14b5d2706883$var$shims, (acc, shim)=>{
        const maybeNameMaybeUnicode = shim[0];
        let prefix = shim[1];
        const iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $e4be14b5d2706883$var$_byOldName = shimLookups.names;
    $e4be14b5d2706883$var$_byOldUnicode = shimLookups.unicodes;
    $e4be14b5d2706883$var$_defaultUsablePrefix = $e4be14b5d2706883$var$getCanonicalPrefix($e4be14b5d2706883$var$config.styleDefault, {
        family: $e4be14b5d2706883$var$config.familyDefault
    });
};
$e4be14b5d2706883$var$onChange((c$$1)=>{
    $e4be14b5d2706883$var$_defaultUsablePrefix = $e4be14b5d2706883$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $e4be14b5d2706883$var$config.familyDefault
    });
});
$e4be14b5d2706883$var$build();
function $e4be14b5d2706883$var$byUnicode(prefix, unicode) {
    return ($e4be14b5d2706883$var$_byUnicode[prefix] || {})[unicode];
}
function $e4be14b5d2706883$var$byLigature(prefix, ligature) {
    return ($e4be14b5d2706883$var$_byLigature[prefix] || {})[ligature];
}
function $e4be14b5d2706883$var$byAlias(prefix, alias) {
    return ($e4be14b5d2706883$var$_byAlias[prefix] || {})[alias];
}
function $e4be14b5d2706883$var$byOldName(name) {
    return $e4be14b5d2706883$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $e4be14b5d2706883$var$byOldUnicode(unicode) {
    const oldUnicode = $e4be14b5d2706883$var$_byOldUnicode[unicode];
    const newUnicode = $e4be14b5d2706883$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $e4be14b5d2706883$var$getDefaultUsablePrefix() {
    return $e4be14b5d2706883$var$_defaultUsablePrefix;
}
const $e4be14b5d2706883$var$emptyCanonicalIcon = ()=>{
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $e4be14b5d2706883$var$getCanonicalPrefix(styleOrPrefix) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { family: family = $e4be14b5d2706883$var$a } = params;
    const style = $e4be14b5d2706883$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    const prefix = $e4be14b5d2706883$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $e4be14b5d2706883$var$STYLE_TO_PREFIX[family][style];
    const defined = styleOrPrefix in $e4be14b5d2706883$var$namespace.styles ? styleOrPrefix : null;
    const result = prefix || defined || null;
    return result;
}
const $e4be14b5d2706883$var$PREFIXES_FOR_FAMILY = {
    [$e4be14b5d2706883$var$a]: Object.keys($e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$a]),
    [$e4be14b5d2706883$var$r]: Object.keys($e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$r]),
    [$e4be14b5d2706883$var$o]: Object.keys($e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$o])
};
function $e4be14b5d2706883$var$getCanonicalIcon(values) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { skipLookups: skipLookups = false } = params;
    const famProps = {
        [$e4be14b5d2706883$var$a]: "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat($e4be14b5d2706883$var$a),
        [$e4be14b5d2706883$var$r]: "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat($e4be14b5d2706883$var$r),
        [$e4be14b5d2706883$var$o]: "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat($e4be14b5d2706883$var$o)
    };
    let givenPrefix = null;
    let family = $e4be14b5d2706883$var$a;
    const nonDuotoneFamilyIds = $e4be14b5d2706883$var$c.filter((familyId)=>familyId !== $e4be14b5d2706883$var$t);
    nonDuotoneFamilyIds.forEach((familyId)=>{
        if (values.includes(famProps[familyId]) || values.some((v$$1)=>$e4be14b5d2706883$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) family = familyId;
    });
    const canonical = values.reduce((acc, cls)=>{
        const iconName = $e4be14b5d2706883$var$getIconName($e4be14b5d2706883$var$config.cssPrefix, cls);
        if ($e4be14b5d2706883$var$styles[cls]) {
            cls = $e4be14b5d2706883$var$LONG_STYLE[family].includes(cls) ? $e4be14b5d2706883$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($e4be14b5d2706883$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $e4be14b5d2706883$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $e4be14b5d2706883$var$config.replacementClass && !nonDuotoneFamilyIds.some((familyName)=>cls === famProps[familyName])) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            const shim = givenPrefix === "fa" ? $e4be14b5d2706883$var$byOldName(acc.iconName) : {};
            const aliasIconName = $e4be14b5d2706883$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$e4be14b5d2706883$var$styles["far"] && $e4be14b5d2706883$var$styles["fas"] && !$e4be14b5d2706883$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $e4be14b5d2706883$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $e4be14b5d2706883$var$r && ($e4be14b5d2706883$var$styles["fass"] || $e4be14b5d2706883$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $e4be14b5d2706883$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (!canonical.prefix && family === $e4be14b5d2706883$var$o && ($e4be14b5d2706883$var$styles["fasds"] || $e4be14b5d2706883$var$config.autoFetchSvg)) {
        canonical.prefix = "fasds";
        canonical.iconName = $e4be14b5d2706883$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $e4be14b5d2706883$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
class $e4be14b5d2706883$var$Library {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
        const additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach((key)=>{
            this.definitions[key] = {
                ...this.definitions[key] || {},
                ...additions[key]
            };
            $e4be14b5d2706883$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
            const longPrefix = $e4be14b5d2706883$var$PREFIX_TO_LONG_STYLE[$e4be14b5d2706883$var$a][key];
            if (longPrefix) $e4be14b5d2706883$var$defineIcons(longPrefix, additions[key]);
            $e4be14b5d2706883$var$build();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(additions, definition) {
        const normalized = definition.prefix && definition.iconName && definition.icon ? {
            0: definition
        } : definition;
        Object.keys(normalized).map((key)=>{
            const { prefix: prefix, iconName: iconName, icon: icon } = normalized[key];
            const aliases = icon[2];
            if (!additions[prefix]) additions[prefix] = {};
            if (aliases.length > 0) aliases.forEach((alias)=>{
                if (typeof alias === "string") additions[prefix][alias] = icon;
            });
            additions[prefix][iconName] = icon;
        });
        return additions;
    }
}
let $e4be14b5d2706883$var$_plugins = [];
let $e4be14b5d2706883$var$_hooks = {};
const $e4be14b5d2706883$var$providers = {};
const $e4be14b5d2706883$var$defaultProviderKeys = Object.keys($e4be14b5d2706883$var$providers);
function $e4be14b5d2706883$var$registerPlugins(nextPlugins, _ref) {
    let { mixoutsTo: obj } = _ref;
    $e4be14b5d2706883$var$_plugins = nextPlugins;
    $e4be14b5d2706883$var$_hooks = {};
    Object.keys($e4be14b5d2706883$var$providers).forEach((k)=>{
        if ($e4be14b5d2706883$var$defaultProviderKeys.indexOf(k) === -1) delete $e4be14b5d2706883$var$providers[k];
    });
    $e4be14b5d2706883$var$_plugins.forEach((plugin)=>{
        const mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach((tk)=>{
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if (typeof mixout[tk] === "object") Object.keys(mixout[tk]).forEach((sk)=>{
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            const hooks = plugin.hooks();
            Object.keys(hooks).forEach((hook)=>{
                if (!$e4be14b5d2706883$var$_hooks[hook]) $e4be14b5d2706883$var$_hooks[hook] = [];
                $e4be14b5d2706883$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($e4be14b5d2706883$var$providers);
    });
    return obj;
}
function $e4be14b5d2706883$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    const hookFns = $e4be14b5d2706883$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        accumulator = hookFn.apply(null, [
            accumulator,
            ...args
        ]); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $e4be14b5d2706883$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    const hookFns = $e4be14b5d2706883$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        hookFn.apply(null, args);
    });
    return undefined;
}
function $e4be14b5d2706883$var$callProvided() {
    const hook = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    return $e4be14b5d2706883$var$providers[hook] ? $e4be14b5d2706883$var$providers[hook].apply(null, args) : undefined;
}
function $e4be14b5d2706883$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    let { iconName: iconName } = iconLookup;
    const prefix = iconLookup.prefix || $e4be14b5d2706883$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $e4be14b5d2706883$var$byAlias(prefix, iconName) || iconName;
    return $e4be14b5d2706883$var$iconFromMapping($e4be14b5d2706883$var$library.definitions, prefix, iconName) || $e4be14b5d2706883$var$iconFromMapping($e4be14b5d2706883$var$namespace.styles, prefix, iconName);
}
const $e4be14b5d2706883$var$library = new $e4be14b5d2706883$var$Library();
const $e4be14b5d2706883$var$noAuto = ()=>{
    $e4be14b5d2706883$var$config.autoReplaceSvg = false;
    $e4be14b5d2706883$var$config.observeMutations = false;
    $e4be14b5d2706883$var$callHooks("noAuto");
};
const $e4be14b5d2706883$var$dom = {
    i2svg: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($e4be14b5d2706883$var$IS_DOM) {
            $e4be14b5d2706883$var$callHooks("beforeI2svg", params);
            $e4be14b5d2706883$var$callProvided("pseudoElements2svg", params);
            return $e4be14b5d2706883$var$callProvided("i2svg", params);
        } else return Promise.reject(new Error("Operation requires a DOM of some kind."));
    },
    watch: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { autoReplaceSvgRoot: autoReplaceSvgRoot } = params;
        if ($e4be14b5d2706883$var$config.autoReplaceSvg === false) $e4be14b5d2706883$var$config.autoReplaceSvg = true;
        $e4be14b5d2706883$var$config.observeMutations = true;
        $e4be14b5d2706883$var$domready(()=>{
            $e4be14b5d2706883$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $e4be14b5d2706883$var$callHooks("watch", params);
        });
    }
};
const $e4be14b5d2706883$var$parse = {
    icon: (icon)=>{
        if (icon === null) return null;
        if (typeof icon === "object" && icon.prefix && icon.iconName) return {
            prefix: icon.prefix,
            iconName: $e4be14b5d2706883$var$byAlias(icon.prefix, icon.iconName) || icon.iconName
        };
        if (Array.isArray(icon) && icon.length === 2) {
            const iconName = icon[1].indexOf("fa-") === 0 ? icon[1].slice(3) : icon[1];
            const prefix = $e4be14b5d2706883$var$getCanonicalPrefix(icon[0]);
            return {
                prefix: prefix,
                iconName: $e4be14b5d2706883$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof icon === "string" && (icon.indexOf("".concat($e4be14b5d2706883$var$config.cssPrefix, "-")) > -1 || icon.match($e4be14b5d2706883$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            const canonicalIcon = $e4be14b5d2706883$var$getCanonicalIcon(icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $e4be14b5d2706883$var$getDefaultUsablePrefix(),
                iconName: $e4be14b5d2706883$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof icon === "string") {
            const prefix = $e4be14b5d2706883$var$getDefaultUsablePrefix();
            return {
                prefix: prefix,
                iconName: $e4be14b5d2706883$var$byAlias(prefix, icon) || icon
            };
        }
    }
};
const $e4be14b5d2706883$export$644d8ea042df96a6 = {
    noAuto: $e4be14b5d2706883$var$noAuto,
    config: $e4be14b5d2706883$var$config,
    dom: $e4be14b5d2706883$var$dom,
    parse: $e4be14b5d2706883$var$parse,
    library: $e4be14b5d2706883$var$library,
    findIconDefinition: $e4be14b5d2706883$var$findIconDefinition,
    toHtml: $e4be14b5d2706883$var$toHtml
};
const $e4be14b5d2706883$var$autoReplace = function() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { autoReplaceSvgRoot: autoReplaceSvgRoot = $e4be14b5d2706883$var$DOCUMENT } = params;
    if ((Object.keys($e4be14b5d2706883$var$namespace.styles).length > 0 || $e4be14b5d2706883$var$config.autoFetchSvg) && $e4be14b5d2706883$var$IS_DOM && $e4be14b5d2706883$var$config.autoReplaceSvg) $e4be14b5d2706883$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $e4be14b5d2706883$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function() {
            return val.abstract.map((a)=>$e4be14b5d2706883$var$toHtml(a));
        }
    });
    Object.defineProperty(val, "node", {
        get: function() {
            if (!$e4be14b5d2706883$var$IS_DOM) return;
            const container = $e4be14b5d2706883$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $e4be14b5d2706883$var$asIcon(_ref) {
    let { children: children, main: main, mask: mask, attributes: attributes, styles: styles, transform: transform } = _ref;
    if ($e4be14b5d2706883$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        const { width: width, height: height } = main;
        const offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $e4be14b5d2706883$var$joinStyles({
            ...styles,
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        });
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $e4be14b5d2706883$var$asSymbol(_ref) {
    let { prefix: prefix, iconName: iconName, children: children, attributes: attributes, symbol: symbol } = _ref;
    const id = symbol === true ? "".concat(prefix, "-").concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: {
                        ...attributes,
                        id: id
                    },
                    children: children
                }
            ]
        }
    ];
}
function $e4be14b5d2706883$var$makeInlineSvgAbstract(params) {
    const { icons: { main: main, mask: mask }, prefix: prefix, iconName: iconName, transform: transform, symbol: symbol, title: title, maskId: maskId, titleId: titleId, extra: extra, watchable: watchable = false } = params;
    const { width: width, height: height } = mask.found ? mask : main;
    const isUploadedIcon = prefix === "fak";
    const attrClass = [
        $e4be14b5d2706883$var$config.replacementClass,
        iconName ? "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter((c)=>extra.classes.indexOf(c) === -1).filter((c)=>c !== "" || !!c).concat(extra.classes).join(" ");
    let content = {
        children: [],
        attributes: {
            ...extra.attributes,
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        }
    };
    const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$e4be14b5d2706883$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $e4be14b5d2706883$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    const args = {
        ...content,
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: {
            ...uploadedIconWidthStyle,
            ...extra.styles
        }
    };
    const { children: children, attributes: attributes } = mask.found && main.found ? $e4be14b5d2706883$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $e4be14b5d2706883$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    };
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $e4be14b5d2706883$var$asSymbol(args);
    else return $e4be14b5d2706883$var$asIcon(args);
}
function $e4be14b5d2706883$var$makeLayersTextAbstract(params) {
    const { content: content, width: width, height: height, transform: transform, title: title, extra: extra, watchable: watchable = false } = params;
    const attributes = {
        ...extra.attributes,
        ...title ? {
            "title": title
        } : {},
        "class": extra.classes.join(" ")
    };
    if (watchable) attributes[$e4be14b5d2706883$var$DATA_FA_I2SVG] = "";
    const styles = {
        ...extra.styles
    };
    if ($e4be14b5d2706883$var$transformIsMeaningful(transform)) {
        styles["transform"] = $e4be14b5d2706883$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    const styleString = $e4be14b5d2706883$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    const val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $e4be14b5d2706883$var$makeLayersCounterAbstract(params) {
    const { content: content, title: title, extra: extra } = params;
    const attributes = {
        ...extra.attributes,
        ...title ? {
            "title": title
        } : {},
        "class": extra.classes.join(" ")
    };
    const styleString = $e4be14b5d2706883$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    const val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
const { styles: $e4be14b5d2706883$var$styles$1 } = $e4be14b5d2706883$var$namespace;
function $e4be14b5d2706883$var$asFoundIcon(icon) {
    const width = icon[0];
    const height = icon[1];
    const [vectorData] = icon.slice(4);
    let element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat($e4be14b5d2706883$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat($e4be14b5d2706883$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($e4be14b5d2706883$var$config.cssPrefix, "-").concat($e4be14b5d2706883$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
const $e4be14b5d2706883$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $e4be14b5d2706883$var$maybeNotifyMissing(iconName, prefix) {
    if (!$e4be14b5d2706883$var$PRODUCTION && !$e4be14b5d2706883$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $e4be14b5d2706883$var$findIcon(iconName, prefix) {
    let givenPrefix = prefix;
    if (prefix === "fa" && $e4be14b5d2706883$var$config.styleDefault !== null) prefix = $e4be14b5d2706883$var$getDefaultUsablePrefix();
    return new Promise((resolve, reject)=>{
        if (givenPrefix === "fa") {
            const shim = $e4be14b5d2706883$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $e4be14b5d2706883$var$styles$1[prefix] && $e4be14b5d2706883$var$styles$1[prefix][iconName]) {
            const icon = $e4be14b5d2706883$var$styles$1[prefix][iconName];
            return resolve($e4be14b5d2706883$var$asFoundIcon(icon));
        }
        $e4be14b5d2706883$var$maybeNotifyMissing(iconName, prefix);
        resolve({
            ...$e4be14b5d2706883$var$missingIconResolutionMixin,
            icon: $e4be14b5d2706883$var$config.showMissingIcons && iconName ? $e4be14b5d2706883$var$callProvided("missingIconAbstract") || {} : {}
        });
    });
}
const $e4be14b5d2706883$var$noop$1 = ()=>{};
const $e4be14b5d2706883$var$p$2 = $e4be14b5d2706883$var$config.measurePerformance && $e4be14b5d2706883$var$PERFORMANCE && $e4be14b5d2706883$var$PERFORMANCE.mark && $e4be14b5d2706883$var$PERFORMANCE.measure ? $e4be14b5d2706883$var$PERFORMANCE : {
    mark: $e4be14b5d2706883$var$noop$1,
    measure: $e4be14b5d2706883$var$noop$1
};
const $e4be14b5d2706883$var$preamble = 'FA "6.6.0"';
const $e4be14b5d2706883$var$begin = (name)=>{
    $e4be14b5d2706883$var$p$2.mark("".concat($e4be14b5d2706883$var$preamble, " ").concat(name, " begins"));
    return ()=>$e4be14b5d2706883$var$end(name);
};
const $e4be14b5d2706883$var$end = (name)=>{
    $e4be14b5d2706883$var$p$2.mark("".concat($e4be14b5d2706883$var$preamble, " ").concat(name, " ends"));
    $e4be14b5d2706883$var$p$2.measure("".concat($e4be14b5d2706883$var$preamble, " ").concat(name), "".concat($e4be14b5d2706883$var$preamble, " ").concat(name, " begins"), "".concat($e4be14b5d2706883$var$preamble, " ").concat(name, " ends"));
};
var $e4be14b5d2706883$var$perf = {
    begin: $e4be14b5d2706883$var$begin,
    end: $e4be14b5d2706883$var$end
};
const $e4be14b5d2706883$var$noop$2 = ()=>{};
function $e4be14b5d2706883$var$isWatched(node) {
    const i2svg = node.getAttribute ? node.getAttribute($e4be14b5d2706883$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $e4be14b5d2706883$var$hasPrefixAndIcon(node) {
    const prefix = node.getAttribute ? node.getAttribute($e4be14b5d2706883$var$DATA_PREFIX) : null;
    const icon = node.getAttribute ? node.getAttribute($e4be14b5d2706883$var$DATA_ICON) : null;
    return prefix && icon;
}
function $e4be14b5d2706883$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($e4be14b5d2706883$var$config.replacementClass);
}
function $e4be14b5d2706883$var$getMutator() {
    if ($e4be14b5d2706883$var$config.autoReplaceSvg === true) return $e4be14b5d2706883$var$mutators.replace;
    const mutator = $e4be14b5d2706883$var$mutators[$e4be14b5d2706883$var$config.autoReplaceSvg];
    return mutator || $e4be14b5d2706883$var$mutators.replace;
}
function $e4be14b5d2706883$var$createElementNS(tag) {
    return $e4be14b5d2706883$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $e4be14b5d2706883$var$createElement(tag) {
    return $e4be14b5d2706883$var$DOCUMENT.createElement(tag);
}
function $e4be14b5d2706883$var$convertSVG(abstractObj) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { ceFn: ceFn = abstractObj.tag === "svg" ? $e4be14b5d2706883$var$createElementNS : $e4be14b5d2706883$var$createElement } = params;
    if (typeof abstractObj === "string") return $e4be14b5d2706883$var$DOCUMENT.createTextNode(abstractObj);
    const tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    const children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($e4be14b5d2706883$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $e4be14b5d2706883$var$nodeAsComment(node) {
    let comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
const $e4be14b5d2706883$var$mutators = {
    replace: function(mutation) {
        const node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach((abstract)=>{
                node.parentNode.insertBefore($e4be14b5d2706883$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($e4be14b5d2706883$var$DATA_FA_I2SVG) === null && $e4be14b5d2706883$var$config.keepOriginalSource) {
                let comment = $e4be14b5d2706883$var$DOCUMENT.createComment($e4be14b5d2706883$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function(mutation) {
        const node = mutation[0];
        const abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$e4be14b5d2706883$var$classArray(node).indexOf($e4be14b5d2706883$var$config.replacementClass)) return $e4be14b5d2706883$var$mutators.replace(mutation);
        const forSvg = new RegExp("".concat($e4be14b5d2706883$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            const splitClasses = abstract[0].attributes.class.split(" ").reduce((acc, cls)=>{
                if (cls === $e4be14b5d2706883$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        const newInnerHTML = abstract.map((a)=>$e4be14b5d2706883$var$toHtml(a)).join("\n");
        node.setAttribute($e4be14b5d2706883$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $e4be14b5d2706883$var$performOperationSync(op) {
    op();
}
function $e4be14b5d2706883$var$perform(mutations, callback) {
    const callbackFunction = typeof callback === "function" ? callback : $e4be14b5d2706883$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        let frame = $e4be14b5d2706883$var$performOperationSync;
        if ($e4be14b5d2706883$var$config.mutateApproach === $e4be14b5d2706883$var$MUTATION_APPROACH_ASYNC) frame = $e4be14b5d2706883$var$WINDOW.requestAnimationFrame || $e4be14b5d2706883$var$performOperationSync;
        frame(()=>{
            const mutator = $e4be14b5d2706883$var$getMutator();
            const mark = $e4be14b5d2706883$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
let $e4be14b5d2706883$var$disabled = false;
function $e4be14b5d2706883$var$disableObservation() {
    $e4be14b5d2706883$var$disabled = true;
}
function $e4be14b5d2706883$var$enableObservation() {
    $e4be14b5d2706883$var$disabled = false;
}
let $e4be14b5d2706883$var$mo$1 = null;
function $e4be14b5d2706883$var$observe(options) {
    if (!$e4be14b5d2706883$var$MUTATION_OBSERVER) return;
    if (!$e4be14b5d2706883$var$config.observeMutations) return;
    const { treeCallback: treeCallback = $e4be14b5d2706883$var$noop$2, nodeCallback: nodeCallback = $e4be14b5d2706883$var$noop$2, pseudoElementsCallback: pseudoElementsCallback = $e4be14b5d2706883$var$noop$2, observeMutationsRoot: observeMutationsRoot = $e4be14b5d2706883$var$DOCUMENT } = options;
    $e4be14b5d2706883$var$mo$1 = new $e4be14b5d2706883$var$MUTATION_OBSERVER((objects)=>{
        if ($e4be14b5d2706883$var$disabled) return;
        const defaultPrefix = $e4be14b5d2706883$var$getDefaultUsablePrefix();
        $e4be14b5d2706883$var$toArray(objects).forEach((mutationRecord)=>{
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$e4be14b5d2706883$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($e4be14b5d2706883$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $e4be14b5d2706883$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $e4be14b5d2706883$var$isWatched(mutationRecord.target) && ~$e4be14b5d2706883$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $e4be14b5d2706883$var$hasPrefixAndIcon(mutationRecord.target)) {
                    const { prefix: prefix, iconName: iconName } = $e4be14b5d2706883$var$getCanonicalIcon($e4be14b5d2706883$var$classArray(mutationRecord.target));
                    mutationRecord.target.setAttribute($e4be14b5d2706883$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($e4be14b5d2706883$var$DATA_ICON, iconName);
                } else if ($e4be14b5d2706883$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$e4be14b5d2706883$var$IS_DOM) return;
    $e4be14b5d2706883$var$mo$1.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $e4be14b5d2706883$var$disconnect() {
    if (!$e4be14b5d2706883$var$mo$1) return;
    $e4be14b5d2706883$var$mo$1.disconnect();
}
function $e4be14b5d2706883$var$styleParser(node) {
    const style = node.getAttribute("style");
    let val = [];
    if (style) val = style.split(";").reduce((acc, style)=>{
        const styles = style.split(":");
        const prop = styles[0];
        const value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $e4be14b5d2706883$var$classParser(node) {
    const existingPrefix = node.getAttribute("data-prefix");
    const existingIconName = node.getAttribute("data-icon");
    const innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    let val = $e4be14b5d2706883$var$getCanonicalIcon($e4be14b5d2706883$var$classArray(node));
    if (!val.prefix) val.prefix = $e4be14b5d2706883$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $e4be14b5d2706883$var$byLigature(val.prefix, node.innerText) || $e4be14b5d2706883$var$byUnicode(val.prefix, $e4be14b5d2706883$var$toHex(node.innerText));
    if (!val.iconName && $e4be14b5d2706883$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $e4be14b5d2706883$var$attributesParser(node) {
    const extraAttributes = $e4be14b5d2706883$var$toArray(node.attributes).reduce((acc, attr)=>{
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    const title = node.getAttribute("title");
    const titleId = node.getAttribute("data-fa-title-id");
    if ($e4be14b5d2706883$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($e4be14b5d2706883$var$config.replacementClass, "-title-").concat(titleId || $e4be14b5d2706883$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $e4be14b5d2706883$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $e4be14b5d2706883$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $e4be14b5d2706883$var$parseMeta(node) {
    let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    const { iconName: iconName, prefix: prefix, rest: extraClasses } = $e4be14b5d2706883$var$classParser(node);
    const extraAttributes = $e4be14b5d2706883$var$attributesParser(node);
    const pluginMeta = $e4be14b5d2706883$var$chainHooks("parseNodeAttributes", {}, node);
    let extraStyles = parser.styleParser ? $e4be14b5d2706883$var$styleParser(node) : [];
    return {
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $e4be14b5d2706883$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        },
        ...pluginMeta
    };
}
const { styles: $e4be14b5d2706883$var$styles$2 } = $e4be14b5d2706883$var$namespace;
function $e4be14b5d2706883$var$generateMutation(node) {
    const nodeMeta = $e4be14b5d2706883$var$config.autoReplaceSvg === "nest" ? $e4be14b5d2706883$var$parseMeta(node, {
        styleParser: false
    }) : $e4be14b5d2706883$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($e4be14b5d2706883$var$LAYERS_TEXT_CLASSNAME)) return $e4be14b5d2706883$var$callProvided("generateLayersText", node, nodeMeta);
    else return $e4be14b5d2706883$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
let $e4be14b5d2706883$var$knownPrefixes = new Set();
$e4be14b5d2706883$var$FAMILIES.map((family)=>{
    $e4be14b5d2706883$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($e4be14b5d2706883$var$PREFIX_TO_STYLE[$e4be14b5d2706883$var$a]).map($e4be14b5d2706883$var$knownPrefixes.add.bind($e4be14b5d2706883$var$knownPrefixes));
Object.keys($e4be14b5d2706883$var$PREFIX_TO_STYLE[$e4be14b5d2706883$var$r]).map($e4be14b5d2706883$var$knownPrefixes.add.bind($e4be14b5d2706883$var$knownPrefixes));
Object.keys($e4be14b5d2706883$var$PREFIX_TO_STYLE[$e4be14b5d2706883$var$o]).map($e4be14b5d2706883$var$knownPrefixes.add.bind($e4be14b5d2706883$var$knownPrefixes));
$e4be14b5d2706883$var$knownPrefixes = [
    ...$e4be14b5d2706883$var$knownPrefixes
];
function $e4be14b5d2706883$var$onTree(root) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$e4be14b5d2706883$var$IS_DOM) return Promise.resolve();
    const htmlClassList = $e4be14b5d2706883$var$DOCUMENT.documentElement.classList;
    const hclAdd = (suffix)=>htmlClassList.add("".concat($e4be14b5d2706883$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const hclRemove = (suffix)=>htmlClassList.remove("".concat($e4be14b5d2706883$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const prefixes = $e4be14b5d2706883$var$config.autoFetchSvg ? $e4be14b5d2706883$var$knownPrefixes : $e4be14b5d2706883$var$FAMILIES.map((f$$1)=>"fa-".concat(f$$1)).concat(Object.keys($e4be14b5d2706883$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    const prefixesDomQuery = [
        ".".concat($e4be14b5d2706883$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($e4be14b5d2706883$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map((p$$1)=>".".concat(p$$1, ":not([").concat($e4be14b5d2706883$var$DATA_FA_I2SVG, "])"))).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    let candidates = [];
    try {
        candidates = $e4be14b5d2706883$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    const mark = $e4be14b5d2706883$var$perf.begin("onTree");
    const mutations = candidates.reduce((acc, node)=>{
        try {
            const mutation = $e4be14b5d2706883$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$e4be14b5d2706883$var$PRODUCTION) {
                if (e$$1.name === "MissingIcon") console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise((resolve, reject)=>{
        Promise.all(mutations).then((resolvedMutations)=>{
            $e4be14b5d2706883$var$perform(resolvedMutations, ()=>{
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch((e$$1)=>{
            mark();
            reject(e$$1);
        });
    });
}
function $e4be14b5d2706883$var$onNode(node) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $e4be14b5d2706883$var$generateMutation(node).then((mutation)=>{
        if (mutation) $e4be14b5d2706883$var$perform([
            mutation
        ], callback);
    });
}
function $e4be14b5d2706883$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $e4be14b5d2706883$var$findIconDefinition(maybeIconDefinition || {});
        let { mask: mask } = params;
        if (mask) mask = (mask || {}).icon ? mask : $e4be14b5d2706883$var$findIconDefinition(mask || {});
        return next(iconDefinition, {
            ...params,
            mask: mask
        });
    };
}
const $e4be14b5d2706883$var$render = function(iconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { transform: transform = $e4be14b5d2706883$var$meaninglessTransform, symbol: symbol = false, mask: mask = null, maskId: maskId = null, title: title = null, titleId: titleId = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
    if (!iconDefinition) return;
    const { prefix: prefix, iconName: iconName, icon: icon } = iconDefinition;
    return $e4be14b5d2706883$var$domVariants({
        type: "icon",
        ...iconDefinition
    }, ()=>{
        $e4be14b5d2706883$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($e4be14b5d2706883$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($e4be14b5d2706883$var$config.replacementClass, "-title-").concat(titleId || $e4be14b5d2706883$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $e4be14b5d2706883$var$makeInlineSvgAbstract({
            icons: {
                main: $e4be14b5d2706883$var$asFoundIcon(icon),
                mask: mask ? $e4be14b5d2706883$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: {
                ...$e4be14b5d2706883$var$meaninglessTransform,
                ...transform
            },
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $e4be14b5d2706883$var$ReplaceElements = {
    mixout () {
        return {
            icon: $e4be14b5d2706883$var$resolveIcons($e4be14b5d2706883$var$render)
        };
    },
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.treeCallback = $e4be14b5d2706883$var$onTree;
                accumulator.nodeCallback = $e4be14b5d2706883$var$onNode;
                return accumulator;
            }
        };
    },
    provides (providers$$1) {
        providers$$1.i2svg = function(params) {
            const { node: node = $e4be14b5d2706883$var$DOCUMENT, callback: callback = ()=>{} } = params;
            return $e4be14b5d2706883$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            const { iconName: iconName, title: title, titleId: titleId, prefix: prefix, transform: transform, symbol: symbol, mask: mask, maskId: maskId, extra: extra } = nodeMeta;
            return new Promise((resolve, reject)=>{
                Promise.all([
                    $e4be14b5d2706883$var$findIcon(iconName, prefix),
                    mask.iconName ? $e4be14b5d2706883$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((_ref)=>{
                    let [main, mask] = _ref;
                    resolve([
                        node,
                        $e4be14b5d2706883$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref2) {
            let { children: children, attributes: attributes, main: main, transform: transform, styles: styles } = _ref2;
            const styleString = $e4be14b5d2706883$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            let nextChild;
            if ($e4be14b5d2706883$var$transformIsMeaningful(transform)) nextChild = $e4be14b5d2706883$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $e4be14b5d2706883$var$Layers = {
    mixout () {
        return {
            layer (assembler) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { classes: classes = [] } = params;
                return $e4be14b5d2706883$var$domVariants({
                    type: "layer"
                }, ()=>{
                    $e4be14b5d2706883$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    let children = [];
                    assembler((args)=>{
                        Array.isArray(args) ? args.map((a)=>{
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($e4be14b5d2706883$var$config.cssPrefix, "-layers"),
                                    ...classes
                                ].join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $e4be14b5d2706883$var$LayersCounter = {
    mixout () {
        return {
            counter (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $e4be14b5d2706883$var$domVariants({
                    type: "counter",
                    content: content
                }, ()=>{
                    $e4be14b5d2706883$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $e4be14b5d2706883$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($e4be14b5d2706883$var$config.cssPrefix, "-layers-counter"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    }
};
var $e4be14b5d2706883$var$LayersText = {
    mixout () {
        return {
            text (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { transform: transform = $e4be14b5d2706883$var$meaninglessTransform, title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $e4be14b5d2706883$var$domVariants({
                    type: "text",
                    content: content
                }, ()=>{
                    $e4be14b5d2706883$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $e4be14b5d2706883$var$makeLayersTextAbstract({
                        content: content,
                        transform: {
                            ...$e4be14b5d2706883$var$meaninglessTransform,
                            ...transform
                        },
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($e4be14b5d2706883$var$config.cssPrefix, "-layers-text"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    },
    provides (providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            const { title: title, transform: transform, extra: extra } = nodeMeta;
            let width = null;
            let height = null;
            if ($e4be14b5d2706883$var$IS_IE) {
                const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                const boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($e4be14b5d2706883$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $e4be14b5d2706883$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
const $e4be14b5d2706883$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
const $e4be14b5d2706883$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
const $e4be14b5d2706883$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = {
    FontAwesome: {
        normal: "fas",
        400: "fas"
    },
    ...$e4be14b5d2706883$var$eo,
    ...$e4be14b5d2706883$var$ao,
    ...$e4be14b5d2706883$var$mo
};
const $e4be14b5d2706883$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($e4be14b5d2706883$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key)=>{
    acc[key.toLowerCase()] = $e4be14b5d2706883$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
const $e4be14b5d2706883$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($e4be14b5d2706883$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily)=>{
    const weights = $e4be14b5d2706883$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || [
        ...Object.entries(weights)
    ][0][1];
    return acc;
}, {});
function $e4be14b5d2706883$var$hexValueFromContent(content) {
    const cleaned = content.replace($e4be14b5d2706883$var$CLEAN_CONTENT_PATTERN, "");
    const codePoint = $e4be14b5d2706883$var$codePointAt(cleaned, 0);
    const isPrependTen = codePoint >= $e4be14b5d2706883$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $e4be14b5d2706883$var$SECONDARY_UNICODE_RANGE[1];
    const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $e4be14b5d2706883$var$toHex(cleaned[0]) : $e4be14b5d2706883$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $e4be14b5d2706883$var$getPrefix(fontFamily, fontWeight) {
    const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, "").toLowerCase();
    const fontWeightInteger = parseInt(fontWeight);
    const fontWeightSanitized = isNaN(fontWeightInteger) ? "normal" : fontWeightInteger;
    return ($e4be14b5d2706883$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $e4be14b5d2706883$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $e4be14b5d2706883$var$replaceForPosition(node, position) {
    const pendingAttribute = "".concat($e4be14b5d2706883$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise((resolve, reject)=>{
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        const children = $e4be14b5d2706883$var$toArray(node.children);
        const alreadyProcessedPseudoElement = children.filter((c)=>c.getAttribute($e4be14b5d2706883$var$DATA_FA_PSEUDO_ELEMENT) === position)[0];
        const styles = $e4be14b5d2706883$var$WINDOW.getComputedStyle(node, position);
        const fontFamily = styles.getPropertyValue("font-family");
        const fontFamilyMatch = fontFamily.match($e4be14b5d2706883$var$FONT_FAMILY_PATTERN);
        const fontWeight = styles.getPropertyValue("font-weight");
        const content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== "none" && content !== "") {
            const content = styles.getPropertyValue("content");
            let prefix = $e4be14b5d2706883$var$getPrefix(fontFamily, fontWeight);
            const { value: hexValue, isSecondary: isSecondary } = $e4be14b5d2706883$var$hexValueFromContent(content);
            const isV4 = fontFamilyMatch[0].startsWith("FontAwesome");
            let iconName = $e4be14b5d2706883$var$byUnicode(prefix, hexValue);
            let iconIdentifier = iconName;
            if (isV4) {
                const iconName4 = $e4be14b5d2706883$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($e4be14b5d2706883$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($e4be14b5d2706883$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                const meta = $e4be14b5d2706883$var$blankMeta();
                const { extra: extra } = meta;
                extra.attributes[$e4be14b5d2706883$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $e4be14b5d2706883$var$findIcon(iconName, prefix).then((main)=>{
                    const abstract = $e4be14b5d2706883$var$makeInlineSvgAbstract({
                        ...meta,
                        icons: {
                            main: main,
                            mask: $e4be14b5d2706883$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    });
                    const element = $e4be14b5d2706883$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map((a)=>$e4be14b5d2706883$var$toHtml(a)).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $e4be14b5d2706883$var$replace(node) {
    return Promise.all([
        $e4be14b5d2706883$var$replaceForPosition(node, "::before"),
        $e4be14b5d2706883$var$replaceForPosition(node, "::after")
    ]);
}
function $e4be14b5d2706883$var$processable(node) {
    return node.parentNode !== document.head && !~$e4be14b5d2706883$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($e4be14b5d2706883$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $e4be14b5d2706883$var$searchPseudoElements(root) {
    if (!$e4be14b5d2706883$var$IS_DOM) return;
    return new Promise((resolve, reject)=>{
        const operations = $e4be14b5d2706883$var$toArray(root.querySelectorAll("*")).filter($e4be14b5d2706883$var$processable).map($e4be14b5d2706883$var$replace);
        const end = $e4be14b5d2706883$var$perf.begin("searchPseudoElements");
        $e4be14b5d2706883$var$disableObservation();
        Promise.all(operations).then(()=>{
            end();
            $e4be14b5d2706883$var$enableObservation();
            resolve();
        }).catch(()=>{
            end();
            $e4be14b5d2706883$var$enableObservation();
            reject();
        });
    });
}
var $e4be14b5d2706883$var$PseudoElements = {
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.pseudoElementsCallback = $e4be14b5d2706883$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.pseudoElements2svg = function(params) {
            const { node: node = $e4be14b5d2706883$var$DOCUMENT } = params;
            if ($e4be14b5d2706883$var$config.searchPseudoElements) $e4be14b5d2706883$var$searchPseudoElements(node);
        };
    }
};
let $e4be14b5d2706883$var$_unwatched = false;
var $e4be14b5d2706883$var$MutationObserver$1 = {
    mixout () {
        return {
            dom: {
                unwatch () {
                    $e4be14b5d2706883$var$disableObservation();
                    $e4be14b5d2706883$var$_unwatched = true;
                }
            }
        };
    },
    hooks () {
        return {
            bootstrap () {
                $e4be14b5d2706883$var$observe($e4be14b5d2706883$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto () {
                $e4be14b5d2706883$var$disconnect();
            },
            watch (params) {
                const { observeMutationsRoot: observeMutationsRoot } = params;
                if ($e4be14b5d2706883$var$_unwatched) $e4be14b5d2706883$var$enableObservation();
                else $e4be14b5d2706883$var$observe($e4be14b5d2706883$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
const $e4be14b5d2706883$var$parseTransformString = (transformString)=>{
    let transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce((acc, n)=>{
        const parts = n.toLowerCase().split("-");
        const first = parts[0];
        let rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $e4be14b5d2706883$var$PowerTransforms = {
    mixout () {
        return {
            parse: {
                transform: (transformString)=>{
                    return $e4be14b5d2706883$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $e4be14b5d2706883$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            let { main: main, transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
            const outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            const inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            const path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            const operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: {
                    ...operations.outer
                },
                children: [
                    {
                        tag: "g",
                        attributes: {
                            ...operations.inner
                        },
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: {
                                    ...main.icon.attributes,
                                    ...operations.path
                                }
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $e4be14b5d2706883$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $e4be14b5d2706883$var$fillBlack(abstract) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
    return abstract;
}
function $e4be14b5d2706883$var$deGroup(abstract) {
    if (abstract.tag === "g") return abstract.children;
    else return [
        abstract
    ];
}
var $e4be14b5d2706883$var$Masks = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const maskData = node.getAttribute("data-fa-mask");
                const mask = !maskData ? $e4be14b5d2706883$var$emptyCanonicalIcon() : $e4be14b5d2706883$var$getCanonicalIcon(maskData.split(" ").map((i)=>i.trim()));
                if (!mask.prefix) mask.prefix = $e4be14b5d2706883$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractMask = function(_ref) {
            let { children: children, attributes: attributes, main: main, mask: mask, maskId: explicitMaskId, transform: transform } = _ref;
            const { width: mainWidth, icon: mainPath } = main;
            const { width: maskWidth, icon: maskPath } = mask;
            const trans = $e4be14b5d2706883$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            const maskRect = {
                tag: "rect",
                attributes: {
                    ...$e4be14b5d2706883$var$ALL_SPACE,
                    fill: "white"
                }
            };
            const maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($e4be14b5d2706883$var$fillBlack)
            } : {};
            const maskInnerGroup = {
                tag: "g",
                attributes: {
                    ...trans.inner
                },
                children: [
                    $e4be14b5d2706883$var$fillBlack({
                        tag: mainPath.tag,
                        attributes: {
                            ...mainPath.attributes,
                            ...trans.path
                        },
                        ...maskInnerGroupChildrenMixin
                    })
                ]
            };
            const maskOuterGroup = {
                tag: "g",
                attributes: {
                    ...trans.outer
                },
                children: [
                    maskInnerGroup
                ]
            };
            const maskId = "mask-".concat(explicitMaskId || $e4be14b5d2706883$var$nextUniqueId());
            const clipId = "clip-".concat(explicitMaskId || $e4be14b5d2706883$var$nextUniqueId());
            const maskTag = {
                tag: "mask",
                attributes: {
                    ...$e4be14b5d2706883$var$ALL_SPACE,
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                },
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            const defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $e4be14b5d2706883$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: {
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")"),
                    ...$e4be14b5d2706883$var$ALL_SPACE
                }
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $e4be14b5d2706883$var$MissingIconIndicator = {
    provides (providers) {
        let reduceMotion = false;
        if ($e4be14b5d2706883$var$WINDOW.matchMedia) reduceMotion = $e4be14b5d2706883$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            const gChildren = [];
            const FILL = {
                fill: "currentColor"
            };
            const ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: {
                    ...FILL,
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                }
            });
            const OPACITY_ANIMATE = {
                ...ANIMATION_BASE,
                attributeName: "opacity"
            };
            const dot = {
                tag: "circle",
                attributes: {
                    ...FILL,
                    cx: "256",
                    cy: "364",
                    r: "28"
                },
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: {
                    ...ANIMATION_BASE,
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                }
            }, {
                tag: "animate",
                attributes: {
                    ...OPACITY_ANIMATE,
                    values: "1;0;1;1;0;1;"
                }
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: {
                    ...FILL,
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                },
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: {
                            ...OPACITY_ANIMATE,
                            values: "1;0;0;0;0;1;"
                        }
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: {
                    ...FILL,
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                },
                children: [
                    {
                        tag: "animate",
                        attributes: {
                            ...OPACITY_ANIMATE,
                            values: "0;0;1;1;0;0;"
                        }
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $e4be14b5d2706883$var$SvgSymbols = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const symbolData = node.getAttribute("data-fa-symbol");
                const symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $e4be14b5d2706883$var$plugins = [
    $e4be14b5d2706883$var$InjectCSS,
    $e4be14b5d2706883$var$ReplaceElements,
    $e4be14b5d2706883$var$Layers,
    $e4be14b5d2706883$var$LayersCounter,
    $e4be14b5d2706883$var$LayersText,
    $e4be14b5d2706883$var$PseudoElements,
    $e4be14b5d2706883$var$MutationObserver$1,
    $e4be14b5d2706883$var$PowerTransforms,
    $e4be14b5d2706883$var$Masks,
    $e4be14b5d2706883$var$MissingIconIndicator,
    $e4be14b5d2706883$var$SvgSymbols
];
$e4be14b5d2706883$var$registerPlugins($e4be14b5d2706883$var$plugins, {
    mixoutsTo: $e4be14b5d2706883$export$644d8ea042df96a6
});
const $e4be14b5d2706883$export$4f8e844b2782642c = $e4be14b5d2706883$export$644d8ea042df96a6.noAuto;
const $e4be14b5d2706883$export$e506a1d27d1eaa20 = $e4be14b5d2706883$export$644d8ea042df96a6.config;
const $e4be14b5d2706883$export$b839f963c7dc0e34 = $e4be14b5d2706883$export$644d8ea042df96a6.library;
const $e4be14b5d2706883$export$df3a06d6289f983e = $e4be14b5d2706883$export$644d8ea042df96a6.dom;
const $e4be14b5d2706883$export$98e6a39c04603d36 = $e4be14b5d2706883$export$644d8ea042df96a6.parse;
const $e4be14b5d2706883$export$221fed4a47f597a5 = $e4be14b5d2706883$export$644d8ea042df96a6.findIconDefinition;
const $e4be14b5d2706883$export$a10125c086a4df16 = $e4be14b5d2706883$export$644d8ea042df96a6.toHtml;
const $e4be14b5d2706883$export$1ca1ec8b29a4ce27 = $e4be14b5d2706883$export$644d8ea042df96a6.icon;
const $e4be14b5d2706883$export$50a222d9023da98b = $e4be14b5d2706883$export$644d8ea042df96a6.layer;
const $e4be14b5d2706883$export$6f093cfa640b7166 = $e4be14b5d2706883$export$644d8ea042df96a6.text;
const $e4be14b5d2706883$export$e575061ef2a070eb = $e4be14b5d2706883$export$644d8ea042df96a6.counter;



var $bh6RR = parcelRequire("bh6RR");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");
function $14970d24b533a85e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $14970d24b533a85e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $14970d24b533a85e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $14970d24b533a85e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $14970d24b533a85e$export$2e2bcd8739ae039 = $14970d24b533a85e$export$4f5d2d50c9deca37;



var $8BdII = parcelRequire("8BdII");

var $f9NmP = parcelRequire("f9NmP");
var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $5syur = parcelRequire("5syur");

var $8RAwN = parcelRequire("8RAwN");
const $c2c2dd16a68b0773$var$_excluded = [
    "sx"
];
const $c2c2dd16a68b0773$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $8RAwN.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c2c2dd16a68b0773$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $hCIyK.default)(props, $c2c2dd16a68b0773$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c2c2dd16a68b0773$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $5syur.isPlainObject)(result)) return systemProps;
        return (0, $4WYaH.default)({}, systemProps, result);
    };
    else finalSx = (0, $4WYaH.default)({}, systemProps, inSx);
    return (0, $4WYaH.default)({}, otherProps, {
        sx: finalSx
    });
}



var $dm6dP = parcelRequire("dm6dP");

var $ih19M = parcelRequire("ih19M");
"use client";
const $316fb1613a027ac6$var$_excluded = [
    "className",
    "component"
];
function $316fb1613a027ac6$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $8BdII.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $f9NmP.default));
    const Box = /*#__PURE__*/ $bh6RR.forwardRef(function Box(inProps, ref) {
        const theme = (0, $dm6dP.default)(defaultTheme);
        const _extendSxProp = (0, $c2c2dd16a68b0773$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $hCIyK.default)(_extendSxProp, $316fb1613a027ac6$var$_excluded);
        return /*#__PURE__*/ (0, $ih19M.jsx)(BoxRoot, (0, $4WYaH.default)({
            as: component,
            ref: ref,
            className: (0, $14970d24b533a85e$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $7tI36 = parcelRequire("7tI36");

var $gcMmG = parcelRequire("gcMmG");

var $wllwT = parcelRequire("wllwT");
"use client";
const $8f1c19533f0ca7a5$var$defaultTheme = (0, $gcMmG.default)();
const $8f1c19533f0ca7a5$var$Box = (0, $316fb1613a027ac6$export$2e2bcd8739ae039)({
    themeId: (0, $wllwT.default),
    defaultTheme: $8f1c19533f0ca7a5$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $7tI36.default).generate
});
var $8f1c19533f0ca7a5$export$2e2bcd8739ae039 = $8f1c19533f0ca7a5$var$Box;


/**
 * OnLoader é um componente para indicar um tempo de espera não especificado.
 */ var $b354edeb06442c79$export$2e2bcd8739ae039 = function(_a) {
    var _b = _a.allscreen, allscreen = _b === void 0 ? true : _b;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
        width: "100%",
        height: "100%",
        position: allscreen ? "fixed" : "absolute",
        sx: {
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            opacity: .6,
            top: 0,
            left: 0,
            zIndex: 500
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        position: allscreen ? "fixed" : "absolute",
        sx: {
            top: 0,
            left: 0,
            zIndex: 505
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("img", {
        src: "https://refereimages.blob.core.windows.net/images/refereloading.gif"
    }))));
};



var $bh6RR = parcelRequire("bh6RR");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $cNBED = parcelRequire("cNBED");

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $6SFe5 = parcelRequire("6SFe5");

var $dm6dP = parcelRequire("dm6dP");

var $ih19M = parcelRequire("ih19M");
"use client";
function $134c32104760d758$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $dm6dP.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6SFe5.default), {
        styles: globalStyles
    });
}
var $134c32104760d758$export$2e2bcd8739ae039 = $134c32104760d758$var$GlobalStyles;



var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");

var $ih19M = parcelRequire("ih19M");
"use client";
function $6bc59ad1fb4eb28d$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $134c32104760d758$export$2e2bcd8739ae039), (0, $4WYaH.default)({}, props, {
        defaultTheme: (0, $OFmxN.default),
        themeId: (0, $wllwT.default)
    }));
}
var $6bc59ad1fb4eb28d$export$2e2bcd8739ae039 = $6bc59ad1fb4eb28d$var$GlobalStyles;



var $ih19M = parcelRequire("ih19M");
"use client";
const $db4ccd4732c544e1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $4WYaH.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $db4ccd4732c544e1$export$32180ef41b15b513 = (theme)=>(0, $4WYaH.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $db4ccd4732c544e1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components, _theme$components$Mui;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $4WYaH.default)({
        html: $db4ccd4732c544e1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $4WYaH.default)({
            margin: 0
        }, $db4ccd4732c544e1$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $db4ccd4732c544e1$var$CssBaseline(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6bc59ad1fb4eb28d$export$2e2bcd8739ae039), {
                styles: (theme)=>$db4ccd4732c544e1$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $db4ccd4732c544e1$export$2e2bcd8739ae039 = $db4ccd4732c544e1$var$CssBaseline;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $96ZcP = parcelRequire("96ZcP");
var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b0bc520ed4d58057$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $5005a3e0d996687a$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $bh6RR.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $b0bc520ed4d58057$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $4WYaH = parcelRequire("4WYaH");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $89140338e0d83a08$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}


function $69f00fcefdfcbe82$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $89140338e0d83a08$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $4WYaH.default)({}, otherProps, {
        ownerState: (0, $4WYaH.default)({}, otherProps.ownerState, ownerState)
    });
}



var $4WYaH = parcelRequire("4WYaH");

var $1cdNx = parcelRequire("1cdNx");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f1d9dbe76af4afdb$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $fc95754d996e5d47$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $5ade9caa5bce179d$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $1cdNx.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $4WYaH.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $4WYaH.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f1d9dbe76af4afdb$export$2e2bcd8739ae039)((0, $4WYaH.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $fc95754d996e5d47$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $fc95754d996e5d47$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $1cdNx.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $4WYaH.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $4WYaH.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $37b3c2ce0c992b04$export$2e2bcd8739ae039(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $59f76f0115628c32$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $59f76f0115628c32$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $hCIyK.default)(parameters, $59f76f0115628c32$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $37b3c2ce0c992b04$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $5ade9caa5bce179d$export$2e2bcd8739ae039)((0, $4WYaH.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $69f00fcefdfcbe82$export$2e2bcd8739ae039)(elementType, (0, $4WYaH.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $bh6RR = parcelRequire("bh6RR");

function $65682eb7ee0e459a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $f1dfb8b2cafe41bb$var$useEnhancedEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $f1dfb8b2cafe41bb$export$2e2bcd8739ae039 = $f1dfb8b2cafe41bb$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $5e880324b7e05325$var$useEventCallback(fn) {
    const ref = $bh6RR.useRef(fn);
    (0, $f1dfb8b2cafe41bb$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $bh6RR.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $5e880324b7e05325$export$2e2bcd8739ae039 = $5e880324b7e05325$var$useEventCallback;



var $ih19M = parcelRequire("ih19M");
"use client";
function $1a226f09e382fa75$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $1a226f09e382fa75$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $1a226f09e382fa75$var$ClickAwayListener(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $bh6RR.useRef(false);
    const nodeRef = $bh6RR.useRef(null);
    const activatedRef = $bh6RR.useRef(false);
    const syntheticEventRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $5e880324b7e05325$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $1a226f09e382fa75$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $bh6RR.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $1a226f09e382fa75$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $bh6RR.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $1a226f09e382fa75$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps)
    });
}
var $1a226f09e382fa75$export$2e2bcd8739ae039 = $1a226f09e382fa75$var$ClickAwayListener;



var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


"use client";
function $92425eaecdf7cf40$export$2e2bcd8739ae039(parameters) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = $bh6RR.useRef();
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $5e880324b7e05325$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $5e880324b7e05325$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $bh6RR.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    };
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $bh6RR.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $bh6RR.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f1d9dbe76af4afdb$export$2e2bcd8739ae039)(parameters);
        const externalEventHandlers = (0, $4WYaH.default)({}, propsEventHandlers, otherHandlers);
        return (0, $4WYaH.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}



var $g4l1t = parcelRequire("g4l1t");
parcelRequire("bh6RR");

var $dm6dP = parcelRequire("dm6dP");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
function $604acdb59e07bb0a$export$2e2bcd8739ae039() {
    const theme = (0, $dm6dP.default)((0, $OFmxN.default));
    return theme[0, $wllwT.default] || theme;
}



var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");



var $hCIyK = parcelRequire("hCIyK");
function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}


function $c375c92967c25393$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, o);
}




var $bh6RR = parcelRequire("bh6RR");

var $2d4434ad62cd5cee$export$2e2bcd8739ae039 = {
    disabled: false
};




var $bh6RR = parcelRequire("bh6RR");
var $51a0807799a59896$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);


var $ecfd1cf4e45b6881$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $5875a5c0de10c551$export$bb38bb9a1161268 = "unmounted";
var $5875a5c0de10c551$export$84cbff306f539230 = "exited";
var $5875a5c0de10c551$export$df38205c966be359 = "entering";
var $5875a5c0de10c551$export$78e9e6e3e014d60a = "entered";
var $5875a5c0de10c551$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5875a5c0de10c551$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
                _this.appearStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else initialStatus = $5875a5c0de10c551$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5875a5c0de10c551$export$bb38bb9a1161268;
        else initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5875a5c0de10c551$export$bb38bb9a1161268) return {
            status: $5875a5c0de10c551$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5875a5c0de10c551$export$df38205c966be359 && status !== $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else if (status === $5875a5c0de10c551$export$df38205c966be359 || status === $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5875a5c0de10c551$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $ecfd1cf4e45b6881$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5875a5c0de10c551$export$84cbff306f539230) this.setState({
            status: $5875a5c0de10c551$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2d4434ad62cd5cee$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5875a5c0de10c551$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5875a5c0de10c551$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2d4434ad62cd5cee$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5875a5c0de10c551$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5875a5c0de10c551$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5875a5c0de10c551$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hCIyK.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $51a0807799a59896$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$5875a5c0de10c551$var$Transition.contextType = (0, $51a0807799a59896$export$2e2bcd8739ae039);
$5875a5c0de10c551$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5875a5c0de10c551$var$noop() {}
$5875a5c0de10c551$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5875a5c0de10c551$var$noop,
    onEntering: $5875a5c0de10c551$var$noop,
    onEntered: $5875a5c0de10c551$var$noop,
    onExit: $5875a5c0de10c551$var$noop,
    onExiting: $5875a5c0de10c551$var$noop,
    onExited: $5875a5c0de10c551$var$noop
};
$5875a5c0de10c551$var$Transition.UNMOUNTED = $5875a5c0de10c551$export$bb38bb9a1161268;
$5875a5c0de10c551$var$Transition.EXITED = $5875a5c0de10c551$export$84cbff306f539230;
$5875a5c0de10c551$var$Transition.ENTERING = $5875a5c0de10c551$export$df38205c966be359;
$5875a5c0de10c551$var$Transition.ENTERED = $5875a5c0de10c551$export$78e9e6e3e014d60a;
$5875a5c0de10c551$var$Transition.EXITING = $5875a5c0de10c551$export$4aacc83d4d59139f;
var $5875a5c0de10c551$export$2e2bcd8739ae039 = $5875a5c0de10c551$var$Transition;



const $502995b8d9f16242$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $502995b8d9f16242$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}



"use client";
var $a83fc3979212c585$export$2e2bcd8739ae039 = (0, $5005a3e0d996687a$export$2e2bcd8739ae039);



var $ih19M = parcelRequire("ih19M");
"use client";
const $8fe6ff9ee2f854fb$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $8fe6ff9ee2f854fb$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $8fe6ff9ee2f854fb$var$styles = {
    entering: {
        opacity: 1,
        transform: $8fe6ff9ee2f854fb$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $8fe6ff9ee2f854fb$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8fe6ff9ee2f854fb$var$Grow = /*#__PURE__*/ $bh6RR.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5875a5c0de10c551$export$2e2bcd8739ae039) } = props, other = (0, $hCIyK.default)(props, $8fe6ff9ee2f854fb$var$_excluded);
    const timer = $bh6RR.useRef();
    const autoTimeout = $bh6RR.useRef();
    const theme = (0, $604acdb59e07bb0a$export$2e2bcd8739ae039)();
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $a83fc3979212c585$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $502995b8d9f16242$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $502995b8d9f16242$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8fe6ff9ee2f854fb$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $502995b8d9f16242$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8fe6ff9ee2f854fb$var$isWebKit154 ? duration : duration * 0.666,
                delay: $8fe6ff9ee2f854fb$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $8fe6ff9ee2f854fb$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $bh6RR.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                style: (0, $4WYaH.default)({
                    opacity: 0,
                    transform: $8fe6ff9ee2f854fb$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $8fe6ff9ee2f854fb$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$8fe6ff9ee2f854fb$var$Grow.muiSupportAuto = true;
var $8fe6ff9ee2f854fb$export$2e2bcd8739ae039 = $8fe6ff9ee2f854fb$var$Grow;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $jS8gC = parcelRequire("jS8gC");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");


var $96ZcP = parcelRequire("96ZcP");

var $jS8gC = parcelRequire("jS8gC");

var $g4l1t = parcelRequire("g4l1t");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $5c972cf40eafc7df$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $5c972cf40eafc7df$export$2e2bcd8739ae039 = $5c972cf40eafc7df$var$getOverlayAlpha;



var $cNBED = parcelRequire("cNBED");


var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a46fb58ff80b1409$export$29cdb466b9b6f20b(slot) {
    return (0, $dmzXD.default)("MuiPaper", slot);
}
const $a46fb58ff80b1409$var$paperClasses = (0, $fYlYP.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $a46fb58ff80b1409$export$2e2bcd8739ae039 = $a46fb58ff80b1409$var$paperClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $dc1f965cf97b1820$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $dc1f965cf97b1820$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $a46fb58ff80b1409$export$29cdb466b9b6f20b), classes);
};
const $dc1f965cf97b1820$var$PaperRoot = (0, $g4l1t.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $4WYaH.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $4WYaH.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $jS8gC.alpha)("#fff", (0, $5c972cf40eafc7df$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $jS8gC.alpha)("#fff", (0, $5c972cf40eafc7df$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $dc1f965cf97b1820$var$Paper = /*#__PURE__*/ $bh6RR.forwardRef(function Paper(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $hCIyK.default)(props, $dc1f965cf97b1820$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $dc1f965cf97b1820$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($dc1f965cf97b1820$var$PaperRoot, (0, $4WYaH.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1cdNx.default)(classes.root, className),
        ref: ref
    }, other));
});
var $dc1f965cf97b1820$export$2e2bcd8739ae039 = $dc1f965cf97b1820$var$Paper;



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $6ddd018859a12cc3$export$def81488db1a3216(slot) {
    return (0, $dmzXD.default)("MuiSnackbarContent", slot);
}
const $6ddd018859a12cc3$var$snackbarContentClasses = (0, $fYlYP.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $6ddd018859a12cc3$export$2e2bcd8739ae039 = $6ddd018859a12cc3$var$snackbarContentClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $44d068f752203b9d$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $44d068f752203b9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6ddd018859a12cc3$export$def81488db1a3216), classes);
};
const $44d068f752203b9d$var$SnackbarContentRoot = (0, $g4l1t.default)((0, $dc1f965cf97b1820$export$2e2bcd8739ae039), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $jS8gC.emphasize)(theme.palette.background.default, emphasis);
    return (0, $4WYaH.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $44d068f752203b9d$var$SnackbarContentMessage = (0, $g4l1t.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $44d068f752203b9d$var$SnackbarContentAction = (0, $g4l1t.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $44d068f752203b9d$var$SnackbarContent = /*#__PURE__*/ $bh6RR.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $hCIyK.default)(props, $44d068f752203b9d$var$_excluded);
    const ownerState = props;
    const classes = $44d068f752203b9d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($44d068f752203b9d$var$SnackbarContentRoot, (0, $4WYaH.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $1cdNx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($44d068f752203b9d$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ih19M.jsx)($44d068f752203b9d$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $44d068f752203b9d$export$2e2bcd8739ae039 = $44d068f752203b9d$var$SnackbarContent;



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $3e76348ed9749f45$export$6cb096457f5926f4(slot) {
    return (0, $dmzXD.default)("MuiSnackbar", slot);
}
const $3e76348ed9749f45$var$snackbarClasses = (0, $fYlYP.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $3e76348ed9749f45$export$2e2bcd8739ae039 = $3e76348ed9749f45$var$snackbarClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $e0a5be5f1b0e6199$var$_excluded = [
    "onEnter",
    "onExited"
], $e0a5be5f1b0e6199$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $e0a5be5f1b0e6199$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $fGH8N.default)(anchorOrigin.vertical)}${(0, $fGH8N.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3e76348ed9749f45$export$6cb096457f5926f4), classes);
};
const $e0a5be5f1b0e6199$var$SnackbarRoot = (0, $g4l1t.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $fGH8N.default)(ownerState.anchorOrigin.vertical)}${(0, $fGH8N.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $4WYaH.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $4WYaH.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $e0a5be5f1b0e6199$var$Snackbar = /*#__PURE__*/ $bh6RR.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $604acdb59e07bb0a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $8fe6ff9ee2f854fb$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $hCIyK.default)(props.TransitionProps, $e0a5be5f1b0e6199$var$_excluded), other = (0, $hCIyK.default)(props, $e0a5be5f1b0e6199$var$_excluded2);
    const ownerState = (0, $4WYaH.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $e0a5be5f1b0e6199$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $92425eaecdf7cf40$export$2e2bcd8739ae039)((0, $4WYaH.default)({}, ownerState));
    const [exited, setExited] = $bh6RR.useState(true);
    const rootProps = (0, $59f76f0115628c32$export$2e2bcd8739ae039)({
        elementType: $e0a5be5f1b0e6199$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1a226f09e382fa75$export$2e2bcd8739ae039), (0, $4WYaH.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($e0a5be5f1b0e6199$var$SnackbarRoot, (0, $4WYaH.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ih19M.jsx)((0, $44d068f752203b9d$export$2e2bcd8739ae039), (0, $4WYaH.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $e0a5be5f1b0e6199$export$2e2bcd8739ae039 = $e0a5be5f1b0e6199$var$Snackbar;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $jS8gC = parcelRequire("jS8gC");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");


var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $3f9e69e4a5e37666$export$69aecd24bc2cf7e3(slot) {
    return (0, $dmzXD.default)("MuiAlert", slot);
}
const $3f9e69e4a5e37666$var$alertClasses = (0, $fYlYP.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $3f9e69e4a5e37666$export$2e2bcd8739ae039 = $3f9e69e4a5e37666$var$alertClasses;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");


var $96ZcP = parcelRequire("96ZcP");

var $jS8gC = parcelRequire("jS8gC");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");


var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");


"use client";
var $6638eb82ff2b4a1f$export$2e2bcd8739ae039 = (0, $5e880324b7e05325$export$2e2bcd8739ae039);



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $a595c6c315f57376$var$UNINITIALIZED = {};
function $a595c6c315f57376$export$2e2bcd8739ae039(init, initArg) {
    const ref = $bh6RR.useRef($a595c6c315f57376$var$UNINITIALIZED);
    if (ref.current === $a595c6c315f57376$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $e7f221d2eaddb322$var$EMPTY = [];
function $e7f221d2eaddb322$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $bh6RR.useEffect(fn, $e7f221d2eaddb322$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $8c6762aec7cc866c$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $8c6762aec7cc866c$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $8c6762aec7cc866c$export$2e2bcd8739ae039() {
    const timeout = (0, $a595c6c315f57376$export$2e2bcd8739ae039)($8c6762aec7cc866c$export$786b4da70f00938b.create).current;
    (0, $e7f221d2eaddb322$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $1119db5bc288513a$var$hadKeyboardEvent = true;
let $1119db5bc288513a$var$hadFocusVisibleRecently = false;
const $1119db5bc288513a$var$hadFocusVisibleRecentlyTimeout = new (0, $8c6762aec7cc866c$export$786b4da70f00938b)();
const $1119db5bc288513a$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $1119db5bc288513a$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $1119db5bc288513a$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $1119db5bc288513a$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $1119db5bc288513a$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $1119db5bc288513a$var$handlePointerDown() {
    $1119db5bc288513a$var$hadKeyboardEvent = false;
}
function $1119db5bc288513a$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($1119db5bc288513a$var$hadFocusVisibleRecently) $1119db5bc288513a$var$hadKeyboardEvent = true;
    }
}
function $1119db5bc288513a$var$prepare(doc) {
    doc.addEventListener("keydown", $1119db5bc288513a$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $1119db5bc288513a$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $1119db5bc288513a$var$handleVisibilityChange, true);
}
function $1119db5bc288513a$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $1119db5bc288513a$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $1119db5bc288513a$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $1119db5bc288513a$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $1119db5bc288513a$var$handleVisibilityChange, true);
}
function $1119db5bc288513a$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $1119db5bc288513a$var$hadKeyboardEvent || $1119db5bc288513a$var$focusTriggersKeyboardModality(target);
}
function $1119db5bc288513a$export$2e2bcd8739ae039() {
    const ref = $bh6RR.useCallback((node)=>{
        if (node != null) $1119db5bc288513a$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $bh6RR.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $1119db5bc288513a$var$hadFocusVisibleRecently = true;
            $1119db5bc288513a$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $1119db5bc288513a$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($1119db5bc288513a$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039 = (0, $1119db5bc288513a$export$2e2bcd8739ae039);



var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
function $acbbdecafa0b932b$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $bh6RR.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $bh6RR.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $acbbdecafa0b932b$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $acbbdecafa0b932b$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $acbbdecafa0b932b$export$fa71e2345c31d7a2(props, onExited) {
    return $acbbdecafa0b932b$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $acbbdecafa0b932b$var$getProp(child, "appear", props),
            enter: $acbbdecafa0b932b$var$getProp(child, "enter", props),
            exit: $acbbdecafa0b932b$var$getProp(child, "exit", props)
        });
    });
}
function $acbbdecafa0b932b$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $acbbdecafa0b932b$export$bbc8a025727ea824(nextProps.children);
    var children = $acbbdecafa0b932b$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $bh6RR.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $bh6RR.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $acbbdecafa0b932b$var$getProp(child, "exit", nextProps),
            enter: $acbbdecafa0b932b$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $bh6RR.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $acbbdecafa0b932b$var$getProp(child, "exit", nextProps),
            enter: $acbbdecafa0b932b$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $8442a8eba1100460$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8442a8eba1100460$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $8442a8eba1100460$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $acbbdecafa0b932b$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $acbbdecafa0b932b$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $acbbdecafa0b932b$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $4WYaH.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hCIyK.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $8442a8eba1100460$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $51a0807799a59896$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $51a0807799a59896$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$8442a8eba1100460$var$TransitionGroup.propTypes = {};
$8442a8eba1100460$var$TransitionGroup.defaultProps = $8442a8eba1100460$var$defaultProps;
var $8442a8eba1100460$export$2e2bcd8739ae039 = $8442a8eba1100460$var$TransitionGroup;



var $1cdNx = parcelRequire("1cdNx");

var $7hler = parcelRequire("7hler");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $ih19M = parcelRequire("ih19M");
"use client";
function $d806670e58944783$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $bh6RR.useState(false);
    const rippleClassName = (0, $1cdNx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $1cdNx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $bh6RR.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: childClassName
        })
    });
}
var $d806670e58944783$export$2e2bcd8739ae039 = $d806670e58944783$var$Ripple;



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $a484c5b1e92c0283$export$b464606f735ab902(slot) {
    return (0, $dmzXD.default)("MuiTouchRipple", slot);
}
const $a484c5b1e92c0283$var$touchRippleClasses = (0, $fYlYP.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $a484c5b1e92c0283$export$2e2bcd8739ae039 = $a484c5b1e92c0283$var$touchRippleClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $c619b0c04884f58c$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $c619b0c04884f58c$var$_ = (t)=>t, $c619b0c04884f58c$var$_t, $c619b0c04884f58c$var$_t2, $c619b0c04884f58c$var$_t3, $c619b0c04884f58c$var$_t4;
const $c619b0c04884f58c$var$DURATION = 550;
const $c619b0c04884f58c$export$95d0c9356b2231a3 = 80;
const $c619b0c04884f58c$var$enterKeyframe = (0, $7hler.keyframes)($c619b0c04884f58c$var$_t || ($c619b0c04884f58c$var$_t = $c619b0c04884f58c$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $c619b0c04884f58c$var$exitKeyframe = (0, $7hler.keyframes)($c619b0c04884f58c$var$_t2 || ($c619b0c04884f58c$var$_t2 = $c619b0c04884f58c$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $c619b0c04884f58c$var$pulsateKeyframe = (0, $7hler.keyframes)($c619b0c04884f58c$var$_t3 || ($c619b0c04884f58c$var$_t3 = $c619b0c04884f58c$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $c619b0c04884f58c$export$f6b7418508c72c25 = (0, $g4l1t.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $c619b0c04884f58c$export$676cfe7b12693c4b = (0, $g4l1t.default)((0, $d806670e58944783$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($c619b0c04884f58c$var$_t4 || ($c619b0c04884f58c$var$_t4 = $c619b0c04884f58c$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).rippleVisible, $c619b0c04884f58c$var$enterKeyframe, $c619b0c04884f58c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).child, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).childLeaving, $c619b0c04884f58c$var$exitKeyframe, $c619b0c04884f58c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).childPulsate, $c619b0c04884f58c$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c619b0c04884f58c$var$TouchRipple = /*#__PURE__*/ $bh6RR.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $hCIyK.default)(props, $c619b0c04884f58c$var$_excluded);
    const [ripples, setRipples] = $bh6RR.useState([]);
    const nextKey = $bh6RR.useRef(0);
    const rippleCallback = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $bh6RR.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $bh6RR.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $bh6RR.useRef(null);
    const container = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $bh6RR.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ih19M.jsx)($c619b0c04884f58c$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $1cdNx.default)(classes.ripple, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $1cdNx.default)(classes.rippleVisible, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $1cdNx.default)(classes.ripplePulsate, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $1cdNx.default)(classes.child, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $1cdNx.default)(classes.childLeaving, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $1cdNx.default)(classes.childPulsate, (0, $a484c5b1e92c0283$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $c619b0c04884f58c$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $bh6RR.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $c619b0c04884f58c$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $bh6RR.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $bh6RR.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $bh6RR.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($c619b0c04884f58c$export$f6b7418508c72c25, (0, $4WYaH.default)({
        className: (0, $1cdNx.default)((0, $a484c5b1e92c0283$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8442a8eba1100460$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $c619b0c04884f58c$export$2e2bcd8739ae039 = $c619b0c04884f58c$var$TouchRipple;



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $269bf8204c4a8a34$export$fccb0498dcd99783(slot) {
    return (0, $dmzXD.default)("MuiButtonBase", slot);
}
const $269bf8204c4a8a34$var$buttonBaseClasses = (0, $fYlYP.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $269bf8204c4a8a34$export$2e2bcd8739ae039 = $269bf8204c4a8a34$var$buttonBaseClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $7c10db4061610272$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $7c10db4061610272$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $269bf8204c4a8a34$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $7c10db4061610272$export$7ec0dcc5e3cdcd36 = (0, $g4l1t.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $269bf8204c4a8a34$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $7c10db4061610272$var$ButtonBase = /*#__PURE__*/ $bh6RR.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $hCIyK.default)(props, $7c10db4061610272$var$_excluded);
    const buttonRef = $bh6RR.useRef(null);
    const rippleRef = $bh6RR.useRef(null);
    const handleRippleRef = (0, $a83fc3979212c585$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $bh6RR.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $bh6RR.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $6638eb82ff2b4a1f$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $6638eb82ff2b4a1f$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $bh6RR.useRef(false);
    const handleKeyDown = (0, $6638eb82ff2b4a1f$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $6638eb82ff2b4a1f$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $a83fc3979212c585$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $4WYaH.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $7c10db4061610272$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($7c10db4061610272$export$7ec0dcc5e3cdcd36, (0, $4WYaH.default)({
        as: ComponentProp,
        className: (0, $1cdNx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ih19M.jsx)((0, $c619b0c04884f58c$export$2e2bcd8739ae039), (0, $4WYaH.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $7c10db4061610272$export$2e2bcd8739ae039 = $7c10db4061610272$var$ButtonBase;



var $fGH8N = parcelRequire("fGH8N");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $48f3847998426035$export$5e8702d71474f093(slot) {
    return (0, $dmzXD.default)("MuiIconButton", slot);
}
const $48f3847998426035$var$iconButtonClasses = (0, $fYlYP.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $48f3847998426035$export$2e2bcd8739ae039 = $48f3847998426035$var$iconButtonClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $78a1ecfdeb9afc7a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $78a1ecfdeb9afc7a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $fGH8N.default)(color)}`,
            edge && `edge${(0, $fGH8N.default)(edge)}`,
            `size${(0, $fGH8N.default)(size)}`
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $48f3847998426035$export$5e8702d71474f093), classes);
};
const $78a1ecfdeb9afc7a$var$IconButtonRoot = (0, $g4l1t.default)((0, $7c10db4061610272$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $fGH8N.default)(ownerState.edge)}`],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jS8gC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $4WYaH.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $4WYaH.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $4WYaH.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jS8gC.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $48f3847998426035$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $78a1ecfdeb9afc7a$var$IconButton = /*#__PURE__*/ $bh6RR.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $hCIyK.default)(props, $78a1ecfdeb9afc7a$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $78a1ecfdeb9afc7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($78a1ecfdeb9afc7a$var$IconButtonRoot, (0, $4WYaH.default)({
        className: (0, $1cdNx.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $78a1ecfdeb9afc7a$export$2e2bcd8739ae039 = $78a1ecfdeb9afc7a$var$IconButton;


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $69783730d64dd996$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f07270c865ae61ce$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f1c321308a0c1c67$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $67b53be57bfcc810$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $72233380a191cb0e$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $ih19M = parcelRequire("ih19M");
"use client";
const $8e112c98121a019d$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $8e112c98121a019d$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $fGH8N.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3f9e69e4a5e37666$export$69aecd24bc2cf7e3), classes);
};
const $8e112c98121a019d$var$AlertRoot = (0, $g4l1t.default)((0, $dc1f965cf97b1820$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $fGH8N.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $jS8gC.darken) : (0, $jS8gC.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $jS8gC.lighten) : (0, $jS8gC.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $4WYaH.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $3f9e69e4a5e37666$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "outlined" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $3f9e69e4a5e37666$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "filled" && (0, $4WYaH.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $8e112c98121a019d$var$AlertIcon = (0, $g4l1t.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $8e112c98121a019d$var$AlertMessage = (0, $g4l1t.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $8e112c98121a019d$var$AlertAction = (0, $g4l1t.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $8e112c98121a019d$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ih19M.jsx)((0, $69783730d64dd996$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f07270c865ae61ce$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f1c321308a0c1c67$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ih19M.jsx)((0, $67b53be57bfcc810$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $8e112c98121a019d$var$Alert = /*#__PURE__*/ $bh6RR.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $8e112c98121a019d$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $hCIyK.default)(props, $8e112c98121a019d$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $8e112c98121a019d$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $78a1ecfdeb9afc7a$export$2e2bcd8739ae039);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $72233380a191cb0e$export$2e2bcd8739ae039);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($8e112c98121a019d$var$AlertRoot, (0, $4WYaH.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $1cdNx.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $8e112c98121a019d$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(AlertCloseButton, (0, $4WYaH.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)(AlertCloseIcon, (0, $4WYaH.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $8e112c98121a019d$export$2e2bcd8739ae039 = $8e112c98121a019d$var$Alert;




var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $e0O1m = parcelRequire("e0O1m");

var $96ZcP = parcelRequire("96ZcP");

var $jS8gC = parcelRequire("jS8gC");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");


var $fGH8N = parcelRequire("fGH8N");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $425fd013c1fc393f$export$5a6f9035944c8119(slot) {
    return (0, $dmzXD.default)("MuiButton", slot);
}
const $425fd013c1fc393f$var$buttonClasses = (0, $fYlYP.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $425fd013c1fc393f$export$2e2bcd8739ae039 = $425fd013c1fc393f$var$buttonClasses;



var $bh6RR = parcelRequire("bh6RR");
/**
 * @ignore - internal component.
 */ const $fc990ecbb370c5c5$var$ButtonGroupContext = /*#__PURE__*/ $bh6RR.createContext({});
var $fc990ecbb370c5c5$export$2e2bcd8739ae039 = $fc990ecbb370c5c5$var$ButtonGroupContext;



var $ih19M = parcelRequire("ih19M");
"use client";
const $d43f206865e0cc7f$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $d43f206865e0cc7f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $fGH8N.default)(color)}`,
            `size${(0, $fGH8N.default)(size)}`,
            `${variant}Size${(0, $fGH8N.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $fGH8N.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $fGH8N.default)(size)}`
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $425fd013c1fc393f$export$5a6f9035944c8119), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $d43f206865e0cc7f$var$commonIconStyles = (ownerState)=>(0, $4WYaH.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $d43f206865e0cc7f$var$ButtonRoot = (0, $g4l1t.default)((0, $7c10db4061610272$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $fGH8N.default)(ownerState.color)}`],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $fGH8N.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $4WYaH.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $4WYaH.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jS8gC.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jS8gC.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jS8gC.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $4WYaH.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $425fd013c1fc393f$export$2e2bcd8739ae039).focusVisible}`]: (0, $4WYaH.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $425fd013c1fc393f$export$2e2bcd8739ae039).disabled}`]: (0, $4WYaH.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $jS8gC.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $425fd013c1fc393f$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $425fd013c1fc393f$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $d43f206865e0cc7f$var$ButtonStartIcon = (0, $g4l1t.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $d43f206865e0cc7f$var$commonIconStyles(ownerState)));
const $d43f206865e0cc7f$var$ButtonEndIcon = (0, $g4l1t.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $d43f206865e0cc7f$var$commonIconStyles(ownerState)));
const $d43f206865e0cc7f$var$Button = /*#__PURE__*/ $bh6RR.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $bh6RR.useContext((0, $fc990ecbb370c5c5$export$2e2bcd8739ae039));
    const resolvedProps = (0, $e0O1m.default)(contextProps, inProps);
    const props = (0, $cNBED.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $hCIyK.default)(props, $d43f206865e0cc7f$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $d43f206865e0cc7f$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ih19M.jsx)($d43f206865e0cc7f$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ih19M.jsx)($d43f206865e0cc7f$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($d43f206865e0cc7f$var$ButtonRoot, (0, $4WYaH.default)({
        ownerState: ownerState,
        className: (0, $1cdNx.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $1cdNx.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $d43f206865e0cc7f$export$2e2bcd8739ae039 = $d43f206865e0cc7f$var$Button;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $bh6RR = parcelRequire("bh6RR");
"use client";
let $9ee3035d4da2ac8a$var$globalId = 0;
function $9ee3035d4da2ac8a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $bh6RR.useState(idOverride);
    const id = idOverride || defaultId;
    $bh6RR.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $9ee3035d4da2ac8a$var$globalId += 1;
            setDefaultId(`mui-${$9ee3035d4da2ac8a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $9ee3035d4da2ac8a$var$maybeReactUseId = $bh6RR["useId".toString()];
function $9ee3035d4da2ac8a$export$2e2bcd8739ae039(idOverride) {
    if ($9ee3035d4da2ac8a$var$maybeReactUseId !== undefined) {
        const reactId = $9ee3035d4da2ac8a$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $9ee3035d4da2ac8a$var$useGlobalId(idOverride);
}



var $fGH8N = parcelRequire("fGH8N");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $41ed5ceec7b1d175$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



var $96ZcP = parcelRequire("96ZcP");

var $bh6RR = parcelRequire("bh6RR");




var $ih19M = parcelRequire("ih19M");
"use client";
function $6502a4d210ca8b64$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $6502a4d210ca8b64$var$Portal = /*#__PURE__*/ $bh6RR.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $bh6RR.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(/*#__PURE__*/ $bh6RR.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $f1dfb8b2cafe41bb$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($6502a4d210ca8b64$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $f1dfb8b2cafe41bb$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $b0bc520ed4d58057$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $b0bc520ed4d58057$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $bh6RR.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $bh6RR.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: mountNode ? /*#__PURE__*/ $47cfd4084854a574$exports.createPortal(children, mountNode) : mountNode
    });
});
var $6502a4d210ca8b64$export$2e2bcd8739ae039 = $6502a4d210ca8b64$var$Portal;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $864f0184c091e2b8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $35d9a659d383d10c$export$2e2bcd8739ae039(node) {
    const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $2701645a7a198dde$var$isOverflowing(container) {
    const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $35d9a659d383d10c$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $2701645a7a198dde$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $2701645a7a198dde$var$getPaddingRight(element) {
    return parseInt((0, $35d9a659d383d10c$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $2701645a7a198dde$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $2701645a7a198dde$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$2701645a7a198dde$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $2701645a7a198dde$export$e1bd0c6150f13d96(element, show);
    });
}
function $2701645a7a198dde$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $2701645a7a198dde$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($2701645a7a198dde$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $864f0184c091e2b8$export$2e2bcd8739ae039)((0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$2701645a7a198dde$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$2701645a7a198dde$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $35d9a659d383d10c$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $2701645a7a198dde$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $2701645a7a198dde$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $2701645a7a198dde$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $2701645a7a198dde$var$getHiddenSiblings(container);
        $2701645a7a198dde$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $2701645a7a198dde$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $2701645a7a198dde$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $2701645a7a198dde$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $2701645a7a198dde$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $2701645a7a198dde$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $2701645a7a198dde$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $2701645a7a198dde$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}



var $bh6RR = parcelRequire("bh6RR");



var $ih19M = parcelRequire("ih19M");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $e03a7628f42c24a8$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $e03a7628f42c24a8$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $e03a7628f42c24a8$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $e03a7628f42c24a8$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $e03a7628f42c24a8$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $e03a7628f42c24a8$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($e03a7628f42c24a8$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $e03a7628f42c24a8$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$e03a7628f42c24a8$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $e03a7628f42c24a8$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $e03a7628f42c24a8$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $e03a7628f42c24a8$var$defaultGetTabbable, isEnabled: isEnabled = $e03a7628f42c24a8$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $bh6RR.useRef(false);
    const sentinelStart = $bh6RR.useRef(null);
    const sentinelEnd = $bh6RR.useRef(null);
    const nodeToRestore = $bh6RR.useRef(null);
    const reactFocusEventTarget = $bh6RR.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $bh6RR.useRef(false);
    const rootRef = $bh6RR.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $bh6RR.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $e03a7628f42c24a8$export$2e2bcd8739ae039 = $e03a7628f42c24a8$var$FocusTrap;



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $09d7db5e6f6447fa$export$67960e22b12a638d(slot) {
    return (0, $dmzXD.default)("MuiModal", slot);
}
const $09d7db5e6f6447fa$var$modalClasses = (0, $fYlYP.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $09d7db5e6f6447fa$export$2e2bcd8739ae039 = $09d7db5e6f6447fa$var$modalClasses;




var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6ddb8dde432e6936$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6ddb8dde432e6936$var$ClassNameConfiguratorContext = /*#__PURE__*/ $bh6RR.createContext($6ddb8dde432e6936$var$defaultContextValue);
function $6ddb8dde432e6936$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $bh6RR.useContext($6ddb8dde432e6936$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $6ddb8dde432e6936$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $bh6RR.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6ddb8dde432e6936$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $ih19M = parcelRequire("ih19M");
"use client";
const $8adb2c8aac65a0c3$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $8adb2c8aac65a0c3$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6ddb8dde432e6936$export$b0f7603cd2f9ee15)((0, $09d7db5e6f6447fa$export$67960e22b12a638d)));
};
function $8adb2c8aac65a0c3$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $8adb2c8aac65a0c3$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $8adb2c8aac65a0c3$var$defaultManager = new (0, $2701645a7a198dde$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base-ui/react-modal/components-api/#modal)
 */ const $8adb2c8aac65a0c3$var$Modal = /*#__PURE__*/ $bh6RR.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children, closeAfterTransition: closeAfterTransition = false, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, // private
    manager: managerProp = $8adb2c8aac65a0c3$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hCIyK.default)(props, $8adb2c8aac65a0c3$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $bh6RR.useState(!open);
    const modal = $bh6RR.useRef({});
    const mountNodeRef = $bh6RR.useRef(null);
    const modalRef = $bh6RR.useRef(null);
    const handleRef = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(modalRef, forwardedRef);
    const hasTransition = $8adb2c8aac65a0c3$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $5e880324b7e05325$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $8adb2c8aac65a0c3$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $bh6RR.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $5e880324b7e05325$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $2701645a7a198dde$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $bh6RR.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $bh6RR.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $8adb2c8aac65a0c3$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $41ed5ceec7b1d175$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $41ed5ceec7b1d175$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $59f76f0115628c32$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $59f76f0115628c32$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6502a4d210ca8b64$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)(Root, (0, $4WYaH.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ih19M.jsx)(BackdropComponent, (0, $4WYaH.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $e03a7628f42c24a8$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $bh6RR.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $8adb2c8aac65a0c3$export$2e2bcd8739ae039 = $8adb2c8aac65a0c3$var$Modal;





var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");







var $ih19M = parcelRequire("ih19M");
"use client";
const $6db6a5e8cee46790$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $6db6a5e8cee46790$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6db6a5e8cee46790$var$Fade = /*#__PURE__*/ $bh6RR.forwardRef(function Fade(props, ref) {
    const theme = (0, $604acdb59e07bb0a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5875a5c0de10c551$export$2e2bcd8739ae039) } = props, other = (0, $hCIyK.default)(props, $6db6a5e8cee46790$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $a83fc3979212c585$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $502995b8d9f16242$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $502995b8d9f16242$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $502995b8d9f16242$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                style: (0, $4WYaH.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $6db6a5e8cee46790$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $6db6a5e8cee46790$export$2e2bcd8739ae039 = $6db6a5e8cee46790$var$Fade;



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $58d497618cd73966$export$9927a91fd93152bd(slot) {
    return (0, $dmzXD.default)("MuiBackdrop", slot);
}
const $58d497618cd73966$var$backdropClasses = (0, $fYlYP.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $58d497618cd73966$export$2e2bcd8739ae039 = $58d497618cd73966$var$backdropClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $52712e091ff6e80b$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $52712e091ff6e80b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $58d497618cd73966$export$9927a91fd93152bd), classes);
};
const $52712e091ff6e80b$var$BackdropRoot = (0, $g4l1t.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $52712e091ff6e80b$var$Backdrop = /*#__PURE__*/ $bh6RR.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $6db6a5e8cee46790$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $hCIyK.default)(props, $52712e091ff6e80b$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $52712e091ff6e80b$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($52712e091ff6e80b$var$BackdropRoot, (0, $4WYaH.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $1cdNx.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $4WYaH.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $52712e091ff6e80b$export$2e2bcd8739ae039 = $52712e091ff6e80b$var$Backdrop;



var $ih19M = parcelRequire("ih19M");
"use client";
const $96f10eeb79eab37c$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $96f10eeb79eab37c$export$eb211a494147b724 = (0, $09d7db5e6f6447fa$export$2e2bcd8739ae039);
const $96f10eeb79eab37c$var$ModalRoot = (0, $g4l1t.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $96f10eeb79eab37c$var$ModalBackdrop = (0, $g4l1t.default)((0, $52712e091ff6e80b$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $96f10eeb79eab37c$var$Modal = /*#__PURE__*/ $bh6RR.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $cNBED.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $96f10eeb79eab37c$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classes, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, open: open, slotProps: slotProps, slots: slots, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $hCIyK.default)(props, $96f10eeb79eab37c$var$_excluded);
    const [exited, setExited] = $bh6RR.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $4WYaH.default)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $96f10eeb79eab37c$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8adb2c8aac65a0c3$export$2e2bcd8739ae039), (0, $4WYaH.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $4WYaH.default)({}, (0, $37b3c2ce0c992b04$export$2e2bcd8739ae039)(rootSlotProps, ownerState), !(0, $89140338e0d83a08$export$2e2bcd8739ae039)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $1cdNx.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $4WYaH.default)({}, BackdropProps, (0, $37b3c2ce0c992b04$export$2e2bcd8739ae039)(backdropSlotProps, ownerState), {
                    className: (0, $1cdNx.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $96f10eeb79eab37c$export$2e2bcd8739ae039 = $96f10eeb79eab37c$var$Modal;





var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $4d4f7569a139d850$export$2177af0aa15c34c2(slot) {
    return (0, $dmzXD.default)("MuiDialog", slot);
}
const $4d4f7569a139d850$var$dialogClasses = (0, $fYlYP.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $4d4f7569a139d850$export$2e2bcd8739ae039 = $4d4f7569a139d850$var$dialogClasses;



var $bh6RR = parcelRequire("bh6RR");
const $8176ee30e609649d$var$DialogContext = /*#__PURE__*/ $bh6RR.createContext({});
var $8176ee30e609649d$export$2e2bcd8739ae039 = $8176ee30e609649d$var$DialogContext;





var $ih19M = parcelRequire("ih19M");
"use client";
const $561e9f5f7ec53bec$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $561e9f5f7ec53bec$var$DialogBackdrop = (0, $g4l1t.default)((0, $52712e091ff6e80b$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $561e9f5f7ec53bec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $fGH8N.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $fGH8N.default)(scroll)}`,
            `paperWidth${(0, $fGH8N.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $4d4f7569a139d850$export$2177af0aa15c34c2), classes);
};
const $561e9f5f7ec53bec$var$DialogRoot = (0, $g4l1t.default)((0, $96f10eeb79eab37c$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $561e9f5f7ec53bec$var$DialogContainer = (0, $g4l1t.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $fGH8N.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $561e9f5f7ec53bec$var$DialogPaper = (0, $g4l1t.default)((0, $dc1f965cf97b1820$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $fGH8N.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $fGH8N.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $4d4f7569a139d850$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $4d4f7569a139d850$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $4d4f7569a139d850$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $561e9f5f7ec53bec$var$Dialog = /*#__PURE__*/ $bh6RR.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $604acdb59e07bb0a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $dc1f965cf97b1820$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $6db6a5e8cee46790$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $561e9f5f7ec53bec$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $561e9f5f7ec53bec$var$useUtilityClasses(ownerState);
    const backdropClick = $bh6RR.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $9ee3035d4da2ac8a$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $bh6RR.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($561e9f5f7ec53bec$var$DialogRoot, (0, $4WYaH.default)({
        className: (0, $1cdNx.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $561e9f5f7ec53bec$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $4WYaH.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)($561e9f5f7ec53bec$var$DialogContainer, {
                className: (0, $1cdNx.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ih19M.jsx)($561e9f5f7ec53bec$var$DialogPaper, (0, $4WYaH.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $1cdNx.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8176ee30e609649d$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $561e9f5f7ec53bec$export$2e2bcd8739ae039 = $561e9f5f7ec53bec$var$Dialog;



var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");


var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $0778cea7da3e9252$export$24c1f8f60cbac79e(slot) {
    return (0, $dmzXD.default)("MuiTypography", slot);
}
const $0778cea7da3e9252$var$typographyClasses = (0, $fYlYP.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $0778cea7da3e9252$export$2e2bcd8739ae039 = $0778cea7da3e9252$var$typographyClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $77f26cb2b0fda3b7$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $77f26cb2b0fda3b7$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $fGH8N.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $0778cea7da3e9252$export$24c1f8f60cbac79e), classes);
};
const $77f26cb2b0fda3b7$export$140e2f5526d3cad8 = (0, $g4l1t.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $fGH8N.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $77f26cb2b0fda3b7$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $77f26cb2b0fda3b7$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $77f26cb2b0fda3b7$var$transformDeprecatedColors = (color)=>{
    return $77f26cb2b0fda3b7$var$colorTransformations[color] || color;
};
const $77f26cb2b0fda3b7$var$Typography = /*#__PURE__*/ $bh6RR.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $77f26cb2b0fda3b7$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $c2c2dd16a68b0773$export$2e2bcd8739ae039)((0, $4WYaH.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $77f26cb2b0fda3b7$var$defaultVariantMapping } = props, other = (0, $hCIyK.default)(props, $77f26cb2b0fda3b7$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $77f26cb2b0fda3b7$var$defaultVariantMapping[variant]) || "span";
    const classes = $77f26cb2b0fda3b7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($77f26cb2b0fda3b7$export$140e2f5526d3cad8, (0, $4WYaH.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $1cdNx.default)(classes.root, className)
    }, other));
});
var $77f26cb2b0fda3b7$export$2e2bcd8739ae039 = $77f26cb2b0fda3b7$var$Typography;



var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $0355495094662690$export$f5d2ec7e4c47e088(slot) {
    return (0, $dmzXD.default)("MuiDialogTitle", slot);
}
const $0355495094662690$var$dialogTitleClasses = (0, $fYlYP.default)("MuiDialogTitle", [
    "root"
]);
var $0355495094662690$export$2e2bcd8739ae039 = $0355495094662690$var$dialogTitleClasses;




var $ih19M = parcelRequire("ih19M");
"use client";
const $27da0db86b3f2a3b$var$_excluded = [
    "className",
    "id"
];
const $27da0db86b3f2a3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $0355495094662690$export$f5d2ec7e4c47e088), classes);
};
const $27da0db86b3f2a3b$var$DialogTitleRoot = (0, $g4l1t.default)((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $27da0db86b3f2a3b$var$DialogTitle = /*#__PURE__*/ $bh6RR.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $hCIyK.default)(props, $27da0db86b3f2a3b$var$_excluded);
    const ownerState = props;
    const classes = $27da0db86b3f2a3b$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $bh6RR.useContext((0, $8176ee30e609649d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ih19M.jsx)($27da0db86b3f2a3b$var$DialogTitleRoot, (0, $4WYaH.default)({
        component: "h2",
        className: (0, $1cdNx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $27da0db86b3f2a3b$export$2e2bcd8739ae039 = $27da0db86b3f2a3b$var$DialogTitle;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $b63d11b7eba28cf3$export$61b0ee1f05fb344e(slot) {
    return (0, $dmzXD.default)("MuiDialogContent", slot);
}
const $b63d11b7eba28cf3$var$dialogContentClasses = (0, $fYlYP.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $b63d11b7eba28cf3$export$2e2bcd8739ae039 = $b63d11b7eba28cf3$var$dialogContentClasses;




var $ih19M = parcelRequire("ih19M");
"use client";
const $64d008f25a771e76$var$_excluded = [
    "className",
    "dividers"
];
const $64d008f25a771e76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $b63d11b7eba28cf3$export$61b0ee1f05fb344e), classes);
};
const $64d008f25a771e76$var$DialogContentRoot = (0, $g4l1t.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $0355495094662690$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $64d008f25a771e76$var$DialogContent = /*#__PURE__*/ $bh6RR.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $hCIyK.default)(props, $64d008f25a771e76$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        dividers: dividers
    });
    const classes = $64d008f25a771e76$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($64d008f25a771e76$var$DialogContentRoot, (0, $4WYaH.default)({
        className: (0, $1cdNx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $64d008f25a771e76$export$2e2bcd8739ae039 = $64d008f25a771e76$var$DialogContent;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");


var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $debff1adc6f62c48$export$d9c6dc45f75b0e4f(slot) {
    return (0, $dmzXD.default)("MuiDialogContentText", slot);
}
const $debff1adc6f62c48$var$dialogContentTextClasses = (0, $fYlYP.default)("MuiDialogContentText", [
    "root"
]);
var $debff1adc6f62c48$export$2e2bcd8739ae039 = $debff1adc6f62c48$var$dialogContentTextClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $31543ddde024914d$var$_excluded = [
    "children",
    "className"
];
const $31543ddde024914d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $96ZcP.default)(slots, (0, $debff1adc6f62c48$export$d9c6dc45f75b0e4f), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $31543ddde024914d$var$DialogContentTextRoot = (0, $g4l1t.default)((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $31543ddde024914d$var$DialogContentText = /*#__PURE__*/ $bh6RR.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { className: className } = props, ownerState = (0, $hCIyK.default)(props, $31543ddde024914d$var$_excluded);
    const classes = $31543ddde024914d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($31543ddde024914d$var$DialogContentTextRoot, (0, $4WYaH.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $1cdNx.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $31543ddde024914d$export$2e2bcd8739ae039 = $31543ddde024914d$var$DialogContentText;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");

var $96ZcP = parcelRequire("96ZcP");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $3b6f140b30c0de0f$export$5e57a444791c63be(slot) {
    return (0, $dmzXD.default)("MuiDialogActions", slot);
}
const $3b6f140b30c0de0f$var$dialogActionsClasses = (0, $fYlYP.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $3b6f140b30c0de0f$export$2e2bcd8739ae039 = $3b6f140b30c0de0f$var$dialogActionsClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $b2aee6581442386f$var$_excluded = [
    "className",
    "disableSpacing"
];
const $b2aee6581442386f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $3b6f140b30c0de0f$export$5e57a444791c63be), classes);
};
const $b2aee6581442386f$var$DialogActionsRoot = (0, $g4l1t.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $b2aee6581442386f$var$DialogActions = /*#__PURE__*/ $bh6RR.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $hCIyK.default)(props, $b2aee6581442386f$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $b2aee6581442386f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($b2aee6581442386f$var$DialogActionsRoot, (0, $4WYaH.default)({
        className: (0, $1cdNx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b2aee6581442386f$export$2e2bcd8739ae039 = $b2aee6581442386f$var$DialogActions;





var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $1cdNx = parcelRequire("1cdNx");


var $96ZcP = parcelRequire("96ZcP");

var $jS8gC = parcelRequire("jS8gC");

var $g4l1t = parcelRequire("g4l1t");


var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");


var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;



function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $aae20dd24c8de568$export$2e2bcd8739ae039)());
}


function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(element) ? (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $af244778ac85956c$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node) || !(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(node)) return (0, $4b98a3172bacf8ec$export$2e2bcd8739ae039)(node);
    else return (0, $a4f89398deb81d5a$export$2e2bcd8739ae039)(node);
}


function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $856f97fdf7a31786$export$2e2bcd8739ae039)((0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element)).left + (0, $4b98a3172bacf8ec$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $202256889fb084f4$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $e3088d3b293d3951$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $01f698b37b56f293$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1d3e8317bca2b13b$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $0dee4f2dddb22277$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(node) && (0, $e3088d3b293d3951$export$2e2bcd8739ae039)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $7ead366da1fe435a$export$2e2bcd8739ae039)(node));
}





function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $f56a03bea423dc7d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $e3088d3b293d3951$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $7ead366da1fe435a$export$2e2bcd8739ae039)(target)));
}







function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element)) >= 0;
}




function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $202256889fb084f4$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $aae20dd24c8de568$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $aae20dd24c8de568$export$2e2bcd8739ae039)());
    if (isIE && (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $202256889fb084f4$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $7ead366da1fe435a$export$2e2bcd8739ae039)(element);
    if ((0, $0dee4f2dddb22277$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $202256889fb084f4$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $88967f4bf6e216d4$export$2e2bcd8739ae039)(offsetParent) && (0, $202256889fb084f4$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $202256889fb084f4$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}


var $3de679e4868fd918$export$1e95b668f3b82d = "top";
var $3de679e4868fd918$export$40e543e69a8b3fbb = "bottom";
var $3de679e4868fd918$export$79ffe56a765070d2 = "right";
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = "left";
var $3de679e4868fd918$export$dfb5619354ba860 = "auto";
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = "start";
var $3de679e4868fd918$export$bd5df0f255a350f8 = "end";
var $3de679e4868fd918$export$390fd549c5303b4d = "clippingParents";
var $3de679e4868fd918$export$d7b7311ec04a3e8f = "viewport";
var $3de679e4868fd918$export$ae5ab1c730825774 = "popper";
var $3de679e4868fd918$export$ca50aac9f3ba507f = "reference";
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = "beforeRead";
var $3de679e4868fd918$export$aafa59e2e03f2942 = "read";
var $3de679e4868fd918$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = "beforeMain";
var $3de679e4868fd918$export$f22da7240b7add18 = "main";
var $3de679e4868fd918$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = "beforeWrite";
var $3de679e4868fd918$export$68d8715fc104d294 = "write";
var $3de679e4868fd918$export$70a6e5159acce2e6 = "afterWrite";
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];


function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $3de679e4868fd918$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(reference) ? (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1fc6b88d850995f4$export$2e2bcd8739ae039)((0, $e334e679a8da4fd2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1f83a3590a58ca81$export$2e2bcd8739ae039)(reference, (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $563728a12da0f86b$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0ee7fe20308229e3$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};



function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $3de679e4868fd918$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $3de679e4868fd918$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $3de679e4868fd918$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $3de679e4868fd918$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $42c9e163adb38c23$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $3de679e4868fd918$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $3de679e4868fd918$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c7a335ce8d6c7e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};










var $2186ca614d1914c5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
    var sideY = (0, $3de679e4868fd918$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(popper);
            if ((0, $202256889fb084f4$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $3de679e4868fd918$export$1e95b668f3b82d) || (placement === (0, $3de679e4868fd918$export$eabcd2c8791e7bf4) || placement === (0, $3de679e4868fd918$export$79ffe56a765070d2)) && variation === (0, $3de679e4868fd918$export$bd5df0f255a350f8)) {
            sideY = (0, $3de679e4868fd918$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $3de679e4868fd918$export$eabcd2c8791e7bf4) || (placement === (0, $3de679e4868fd918$export$1e95b668f3b82d) || placement === (0, $3de679e4868fd918$export$40e543e69a8b3fbb)) && variation === (0, $3de679e4868fd918$export$bd5df0f255a350f8)) {
            sideX = (0, $3de679e4868fd918$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $763358296bc7f0da$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) || !(0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) || !(0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4),
        (0, $3de679e4868fd918$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4),
        (0, $3de679e4868fd918$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $3de679e4868fd918$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $a812a48e30738572$var$offset
};


var $10e68ca32d71e128$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}



var $2cb407a558844daa$var$hash = {
    start: "end",
    end: "start"
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}







function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element);
    var html = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $af244778ac85956c$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1d3e8317bca2b13b$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $4b98a3172bacf8ec$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1d3e8317bca2b13b$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $202256889fb084f4$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $9598a69d154bbd1e$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $0dee4f2dddb22277$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $3de679e4868fd918$export$d7b7311ec04a3e8f) ? (0, $e84261f8276e3310$export$2e2bcd8739ae039)((0, $2f53da607b3746be$export$2e2bcd8739ae039)(element, strategy)) : (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e84261f8276e3310$export$2e2bcd8739ae039)((0, $11e1e16d619599d0$export$2e2bcd8739ae039)((0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)((0, $7ead366da1fe435a$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $202256889fb084f4$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) ? (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(clippingParent) && (0, $e52f68d10ea05d88$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f0f7e8fd5f6df53a$export$2e2bcd8739ae039)(), paddingObject);
}


function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $3de679e4868fd918$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $3de679e4868fd918$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $3de679e4868fd918$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $8ec94e005bd060d7$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039)(padding, (0, $3de679e4868fd918$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $3de679e4868fd918$export$ae5ab1c730825774) ? (0, $3de679e4868fd918$export$ca50aac9f3ba507f) : (0, $3de679e4868fd918$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $d1e77b65493ae185$export$2e2bcd8739ae039)((0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c7a335ce8d6c7e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $e84261f8276e3310$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $3de679e4868fd918$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $3de679e4868fd918$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $3de679e4868fd918$export$79ffe56a765070d2),
                (0, $3de679e4868fd918$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $3de679e4868fd918$export$1e95b668f3b82d),
                (0, $3de679e4868fd918$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $3de679e4868fd918$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $3de679e4868fd918$export$368f9a87e87fa4e1) : (0, $3de679e4868fd918$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $3de679e4868fd918$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement) === (0, $3de679e4868fd918$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(placement);
    return [
        (0, $2cb407a558844daa$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $2cb407a558844daa$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement) === (0, $3de679e4868fd918$export$dfb5619354ba860) ? (0, $958040209c61c1c6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement) === (0, $3de679e4868fd918$export$b3571188c770cc5a);
        var isVertical = [
            (0, $3de679e4868fd918$export$1e95b668f3b82d),
            (0, $3de679e4868fd918$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $3de679e4868fd918$export$79ffe56a765070d2) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $9598a69d154bbd1e$export$8960430cfd85939f)(min, (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $763358296bc7f0da$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $42c9e163adb38c23$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $3de679e4868fd918$export$1e95b668f3b82d) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $3de679e4868fd918$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $3de679e4868fd918$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $563728a12da0f86b$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f0f7e8fd5f6df53a$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $0cd708593435dba4$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $0cd708593435dba4$export$f28d906d67a997f3)(tether ? (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9598a69d154bbd1e$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $3de679e4868fd918$export$1e95b668f3b82d) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $3de679e4868fd918$export$1e95b668f3b82d),
            (0, $3de679e4868fd918$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $0cd708593435dba4$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $0cd708593435dba4$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $8ec94e005bd060d7$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039)(padding, (0, $3de679e4868fd918$export$aec2ce47c367b8c3)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $42c9e163adb38c23$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4),
        (0, $3de679e4868fd918$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $563728a12da0f86b$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $3de679e4868fd918$export$1e95b668f3b82d) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $0cd708593435dba4$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $e52f68d10ea05d88$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $3de679e4868fd918$export$1e95b668f3b82d),
        (0, $3de679e4868fd918$export$79ffe56a765070d2),
        (0, $3de679e4868fd918$export$40e543e69a8b3fbb),
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $6b0f9068ca75a57d$var$hide
};




var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $524d12f5e3f410b7$export$2e2bcd8739ae039),
    (0, $32cfbe7d0e900a5d$export$2e2bcd8739ae039),
    (0, $2186ca614d1914c5$export$2e2bcd8739ae039),
    (0, $42eb8a49ca42db39$export$2e2bcd8739ae039),
    (0, $a812a48e30738572$export$2e2bcd8739ae039),
    (0, $4419d659c5aee896$export$2e2bcd8739ae039),
    (0, $b988b9b26e42e386$export$2e2bcd8739ae039),
    (0, $59c92c1fc46a893e$export$2e2bcd8739ae039),
    (0, $6b0f9068ca75a57d$export$2e2bcd8739ae039)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b92f073993d3fb52$export$ed5e13716264f202)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $96ZcP = parcelRequire("96ZcP");


var $dmzXD = parcelRequire("dmzXD");

var $fYlYP = parcelRequire("fYlYP");
function $c44cf8dd7a072fa6$export$1b69b6cd0fa638a1(slot) {
    return (0, $dmzXD.default)("MuiPopper", slot);
}
const $c44cf8dd7a072fa6$var$popperClasses = (0, $fYlYP.default)("MuiPopper", [
    "root"
]);
var $c44cf8dd7a072fa6$export$2e2bcd8739ae039 = $c44cf8dd7a072fa6$var$popperClasses;





var $ih19M = parcelRequire("ih19M");
"use client";
const $3481eff2a151f79e$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $3481eff2a151f79e$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $3481eff2a151f79e$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $3481eff2a151f79e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $3481eff2a151f79e$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $3481eff2a151f79e$var$isVirtualElement(element) {
    return !$3481eff2a151f79e$var$isHTMLElement(element);
}
const $3481eff2a151f79e$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $6ddb8dde432e6936$export$b0f7603cd2f9ee15)((0, $c44cf8dd7a072fa6$export$1b69b6cd0fa638a1)));
};
const $3481eff2a151f79e$var$defaultPopperOptions = {};
const $3481eff2a151f79e$var$PopperTooltip = /*#__PURE__*/ $bh6RR.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $3481eff2a151f79e$var$_excluded);
    const tooltipRef = $bh6RR.useRef(null);
    const ownRef = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $bh6RR.useRef(null);
    const handlePopperRef = (0, $5005a3e0d996687a$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $bh6RR.useRef(handlePopperRef);
    (0, $f1dfb8b2cafe41bb$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $bh6RR.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $3481eff2a151f79e$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $bh6RR.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $bh6RR.useState($3481eff2a151f79e$var$resolveAnchorEl(anchorEl));
    $bh6RR.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $bh6RR.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($3481eff2a151f79e$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $f1dfb8b2cafe41bb$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $4WYaH.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $3481eff2a151f79e$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $59f76f0115628c32$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(Root, (0, $4WYaH.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $3481eff2a151f79e$var$Popper = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $3481eff2a151f79e$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hCIyK.default)(props, $3481eff2a151f79e$var$_excluded2);
    const [exited, setExited] = $bh6RR.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $3481eff2a151f79e$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $3481eff2a151f79e$var$isHTMLElement(resolvedAnchorEl) ? (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $65682eb7ee0e459a$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6502a4d210ca8b64$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($3481eff2a151f79e$var$PopperTooltip, (0, $4WYaH.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $4WYaH.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $3481eff2a151f79e$export$2e2bcd8739ae039 = $3481eff2a151f79e$var$Popper;



var $hDooL = parcelRequire("hDooL");



var $bh6RR = parcelRequire("bh6RR");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6e755ffe50bec2db$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $6e755ffe50bec2db$var$PopperRoot = (0, $g4l1t.default)((0, $3481eff2a151f79e$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $6e755ffe50bec2db$var$Popper = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $hDooL.default)();
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $hCIyK.default)(props, $6e755ffe50bec2db$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $4WYaH.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6e755ffe50bec2db$var$PopperRoot, (0, $4WYaH.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $6e755ffe50bec2db$export$2e2bcd8739ae039 = $6e755ffe50bec2db$var$Popper;





"use client";
var $4438492ebbd53597$export$2e2bcd8739ae039 = (0, $9ee3035d4da2ac8a$export$2e2bcd8739ae039);




var $bh6RR = parcelRequire("bh6RR");
"use client";
function $97be9ca9a8d9ffc7$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $bh6RR.useRef(controlled !== undefined);
    const [valueState, setValue] = $bh6RR.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $bh6RR.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $5dbac85f8c597fa5$export$2e2bcd8739ae039 = (0, $97be9ca9a8d9ffc7$export$2e2bcd8739ae039);



var $fYlYP = parcelRequire("fYlYP");

var $dmzXD = parcelRequire("dmzXD");
function $70aa0907006accc9$export$837848f5f6cee923(slot) {
    return (0, $dmzXD.default)("MuiTooltip", slot);
}
const $70aa0907006accc9$var$tooltipClasses = (0, $fYlYP.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $70aa0907006accc9$export$2e2bcd8739ae039 = $70aa0907006accc9$var$tooltipClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $d53a5c2058f97940$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $d53a5c2058f97940$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $d53a5c2058f97940$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $fGH8N.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $96ZcP.default)(slots, (0, $70aa0907006accc9$export$837848f5f6cee923), classes);
};
const $d53a5c2058f97940$var$TooltipPopper = (0, $g4l1t.default)((0, $6e755ffe50bec2db$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $4WYaH.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: (0, $4WYaH.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: (0, $4WYaH.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $d53a5c2058f97940$var$TooltipTooltip = (0, $g4l1t.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $fGH8N.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $jS8gC.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$d53a5c2058f97940$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $4WYaH.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $4WYaH.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $4WYaH.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $4WYaH.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $4WYaH.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $4WYaH.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $4WYaH.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $4WYaH.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $d53a5c2058f97940$var$TooltipArrow = (0, $g4l1t.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $jS8gC.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $d53a5c2058f97940$var$hystersisOpen = false;
let $d53a5c2058f97940$var$hystersisTimer = null;
let $d53a5c2058f97940$var$cursorPosition = {
    x: 0,
    y: 0
};
function $d53a5c2058f97940$export$b9ee5a7ace0541f8() {
    $d53a5c2058f97940$var$hystersisOpen = false;
    clearTimeout($d53a5c2058f97940$var$hystersisTimer);
}
function $d53a5c2058f97940$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $d53a5c2058f97940$var$Tooltip = /*#__PURE__*/ $bh6RR.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $8fe6ff9ee2f854fb$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $d53a5c2058f97940$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $bh6RR.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $604acdb59e07bb0a$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $bh6RR.useState();
    const [arrowRef, setArrowRef] = $bh6RR.useState(null);
    const ignoreNonTouchEvents = $bh6RR.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $bh6RR.useRef();
    const enterTimer = $bh6RR.useRef();
    const leaveTimer = $bh6RR.useRef();
    const touchTimer = $bh6RR.useRef();
    const [openState, setOpenState] = (0, $5dbac85f8c597fa5$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $4438492ebbd53597$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $bh6RR.useRef();
    const stopTouchInteraction = $bh6RR.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $bh6RR.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($d53a5c2058f97940$var$hystersisTimer);
        $d53a5c2058f97940$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $6638eb82ff2b4a1f$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($d53a5c2058f97940$var$hystersisTimer);
        $d53a5c2058f97940$var$hystersisTimer = setTimeout(()=>{
            $d53a5c2058f97940$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $d53a5c2058f97940$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $d53a5c2058f97940$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $bh6RR.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $a83fc3979212c585$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $bh6RR.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $d53a5c2058f97940$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $4WYaH.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $1cdNx.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $d53a5c2058f97940$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $d53a5c2058f97940$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $d53a5c2058f97940$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $d53a5c2058f97940$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $bh6RR.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $4WYaH.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $d53a5c2058f97940$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $d53a5c2058f97940$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $8fe6ff9ee2f854fb$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $d53a5c2058f97940$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $d53a5c2058f97940$var$TooltipArrow;
    const popperProps = (0, $69f00fcefdfcbe82$export$2e2bcd8739ae039)(PopperComponent, (0, $4WYaH.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $1cdNx.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $69f00fcefdfcbe82$export$2e2bcd8739ae039)(TransitionComponent, (0, $4WYaH.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $69f00fcefdfcbe82$export$2e2bcd8739ae039)(TooltipComponent, (0, $4WYaH.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $1cdNx.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $69f00fcefdfcbe82$export$2e2bcd8739ae039)(ArrowComponent, (0, $4WYaH.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $1cdNx.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ih19M.jsx)(PopperComponent, (0, $4WYaH.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $6e755ffe50bec2db$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $d53a5c2058f97940$var$cursorPosition.y,
                            left: $d53a5c2058f97940$var$cursorPosition.x,
                            right: $d53a5c2058f97940$var$cursorPosition.x,
                            bottom: $d53a5c2058f97940$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)(TooltipComponent, (0, $4WYaH.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ih19M.jsx)(ArrowComponent, (0, $4WYaH.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $d53a5c2058f97940$export$2e2bcd8739ae039 = $d53a5c2058f97940$var$Tooltip;


var $12f73e2b92f051c2$exports = {};
"use strict";
"use client";
var $22d3d00379a62cb8$exports = {};
function $22d3d00379a62cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$22d3d00379a62cb8$exports = $22d3d00379a62cb8$var$_interopRequireDefault, $22d3d00379a62cb8$exports.__esModule = true, $22d3d00379a62cb8$exports["default"] = $22d3d00379a62cb8$exports;


Object.defineProperty($12f73e2b92f051c2$exports, "__esModule", {
    value: true
});
$12f73e2b92f051c2$exports.default = void 0;

var $12f73e2b92f051c2$var$_createSvgIcon = $22d3d00379a62cb8$exports((parcelRequire("Ee11v")));

var $ih19M = parcelRequire("ih19M");
var $12f73e2b92f051c2$var$_default = (0, $12f73e2b92f051c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
}), "ContentCopy");
$12f73e2b92f051c2$exports.default = $12f73e2b92f051c2$var$_default;


var $336ae532ee38d225$exports = {};
"use strict";
"use client";

Object.defineProperty($336ae532ee38d225$exports, "__esModule", {
    value: true
});
$336ae532ee38d225$exports.default = void 0;

var $336ae532ee38d225$var$_createSvgIcon = $22d3d00379a62cb8$exports((parcelRequire("Ee11v")));

var $ih19M = parcelRequire("ih19M");
var $336ae532ee38d225$var$_default = (0, $336ae532ee38d225$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
$336ae532ee38d225$exports.default = $336ae532ee38d225$var$_default;


var $70fba0e4cb153a33$exports = {};
"use strict";
"use client";

Object.defineProperty($70fba0e4cb153a33$exports, "__esModule", {
    value: true
});
$70fba0e4cb153a33$exports.default = void 0;

var $70fba0e4cb153a33$var$_createSvgIcon = $22d3d00379a62cb8$exports((parcelRequire("Ee11v")));

var $ih19M = parcelRequire("ih19M");
var $70fba0e4cb153a33$var$_default = (0, $70fba0e4cb153a33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
$70fba0e4cb153a33$exports.default = $70fba0e4cb153a33$var$_default;



var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");
parcelRequire("bh6RR");


var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
const $0fe9594a3f1c8c31$var$ThemeContext = /*#__PURE__*/ $bh6RR.createContext(null);
var $0fe9594a3f1c8c31$export$2e2bcd8739ae039 = $0fe9594a3f1c8c31$var$ThemeContext;



var $bh6RR = parcelRequire("bh6RR");

function $b4de8cc6d4bd6bc2$export$2e2bcd8739ae039() {
    const theme = $bh6RR.useContext((0, $0fe9594a3f1c8c31$export$2e2bcd8739ae039));
    return theme;
}


const $e59a393a76df9a0e$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $e59a393a76df9a0e$export$2e2bcd8739ae039 = $e59a393a76df9a0e$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $ih19M = parcelRequire("ih19M");
function $d05793fc0c5d61ec$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $d05793fc0c5d61ec$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b4de8cc6d4bd6bc2$export$2e2bcd8739ae039)();
    const theme = $bh6RR.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $d05793fc0c5d61ec$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $e59a393a76df9a0e$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $0fe9594a3f1c8c31$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $d05793fc0c5d61ec$export$2e2bcd8739ae039 = $d05793fc0c5d61ec$var$ThemeProvider;



parcelRequire("7hler");
var $iwq56 = parcelRequire("iwq56");

var $hDooL = parcelRequire("hDooL");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $ih19M = parcelRequire("ih19M");
const $789df1a5c5390f1a$var$_excluded = [
    "value"
];
const $789df1a5c5390f1a$var$RtlContext = /*#__PURE__*/ $bh6RR.createContext();
function $789df1a5c5390f1a$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $hCIyK.default)(_ref, $789df1a5c5390f1a$var$_excluded);
    return /*#__PURE__*/ (0, $ih19M.jsx)($789df1a5c5390f1a$var$RtlContext.Provider, (0, $4WYaH.default)({
        value: value != null ? value : true
    }, props));
}
const $789df1a5c5390f1a$export$b2dd014b6c321cb = ()=>{
    const value = $bh6RR.useContext($789df1a5c5390f1a$var$RtlContext);
    return value != null ? value : false;
};
var $789df1a5c5390f1a$export$2e2bcd8739ae039 = $789df1a5c5390f1a$var$RtlProvider;



var $bh6RR = parcelRequire("bh6RR");


var $e0O1m = parcelRequire("e0O1m");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c2f85c6276b95f84$var$PropsContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
function $c2f85c6276b95f84$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)($c2f85c6276b95f84$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $c2f85c6276b95f84$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e0O1m.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e0O1m.default)(config, props);
    return props;
}
function $c2f85c6276b95f84$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $bh6RR.useContext($c2f85c6276b95f84$var$PropsContext);
    return $c2f85c6276b95f84$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $c2f85c6276b95f84$export$2e2bcd8739ae039 = $c2f85c6276b95f84$var$DefaultPropsProvider;



var $ih19M = parcelRequire("ih19M");
"use client";
const $8071c4251b77a7d7$var$EMPTY_THEME = {};
function $8071c4251b77a7d7$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $bh6RR.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $4WYaH.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $4WYaH.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $4WYaH.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $8071c4251b77a7d7$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $hDooL.default)($8071c4251b77a7d7$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b4de8cc6d4bd6bc2$export$2e2bcd8739ae039)() || $8071c4251b77a7d7$var$EMPTY_THEME;
    const engineTheme = $8071c4251b77a7d7$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $8071c4251b77a7d7$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d05793fc0c5d61ec$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iwq56.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $789df1a5c5390f1a$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $c2f85c6276b95f84$export$2e2bcd8739ae039), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $8071c4251b77a7d7$export$2e2bcd8739ae039 = $8071c4251b77a7d7$var$ThemeProvider;



var $wllwT = parcelRequire("wllwT");

var $ih19M = parcelRequire("ih19M");
"use client";
const $82ee3221eaadbd63$var$_excluded = [
    "theme"
];
function $82ee3221eaadbd63$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $hCIyK.default)(_ref, $82ee3221eaadbd63$var$_excluded);
    const scopedTheme = themeInput[0, $wllwT.default];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8071c4251b77a7d7$export$2e2bcd8739ae039), (0, $4WYaH.default)({}, props, {
        themeId: scopedTheme ? (0, $wllwT.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}


function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}


function $4ff366e58c33ccee$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $8ff0dd17621a97b7$export$2e2bcd8739ae039(value) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $f741f874145d0154$export$2e2bcd8739ae039(argument) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $5663a6fd5511e169$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $8ff0dd17621a97b7$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $5fa2427dbbbb369e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $a62bf7cf7b9521d9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $8eaa0dace66c235b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a62bf7cf7b9521d9$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY = 86400000;
function $dc399780b2b0aec4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY) + 1;
}





function $869ba20767f1348a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $d81d25690b2c97ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $460a48298a6e483f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $d81d25690b2c97ba$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK = 604800000;
function $6e0c4858e45e9a69$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(date).getTime() - (0, $460a48298a6e483f$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK) + 1;
}







var $9eacf000ef47a2dd$var$defaultOptions = {};
function $9eacf000ef47a2dd$export$430a3269e24b912e() {
    return $9eacf000ef47a2dd$var$defaultOptions;
}
function $9eacf000ef47a2dd$export$95365be1b0704abc(newOptions) {
    $9eacf000ef47a2dd$var$defaultOptions = newOptions;
}


function $ddad3c02657f84fd$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $a33305f247e30adc$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $1dc77d031b6877e7$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $a33305f247e30adc$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK = 604800000;
function $8771fceed12cf89e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(date, options).getTime() - (0, $1dc77d031b6877e7$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK) + 1;
}



function $e6c856ebc9ae82ee$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $87a2011828c90e33$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $87a2011828c90e33$export$2e2bcd8739ae039 = $87a2011828c90e33$var$formatters;


var $281a2e82d409b287$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $281a2e82d409b287$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $a33305f247e30adc$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $d81d25690b2c97ba$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $87a2011828c90e33$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $8771fceed12cf89e$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $6e0c4858e45e9a69$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dc399780b2b0aec4$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $281a2e82d409b287$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(minutes, 2);
}
function $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter);
}
function $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $281a2e82d409b287$export$2e2bcd8739ae039 = $281a2e82d409b287$var$formatters;


var $9bb5cf506dd06653$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $9bb5cf506dd06653$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $9bb5cf506dd06653$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9bb5cf506dd06653$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $9bb5cf506dd06653$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $9bb5cf506dd06653$var$timeLongFormatter(timePattern, formatLong));
};
var $9bb5cf506dd06653$var$longFormatters = {
    p: $9bb5cf506dd06653$var$timeLongFormatter,
    P: $9bb5cf506dd06653$var$dateTimeLongFormatter
};
var $9bb5cf506dd06653$export$2e2bcd8739ae039 = $9bb5cf506dd06653$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $63dba254cf419de0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $065cceb4149e3fc5$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $065cceb4149e3fc5$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $065cceb4149e3fc5$export$c6cc36aa33304772(token) {
    return $065cceb4149e3fc5$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$c6b49d6dceb604a1(token) {
    return $065cceb4149e3fc5$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $8617db99f2cb39a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $8617db99f2cb39a3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8617db99f2cb39a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $8617db99f2cb39a3$export$2e2bcd8739ae039 = $8617db99f2cb39a3$var$formatDistance;


function $f6b7cff3d084a1cf$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $c8014f25de2be27f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $c8014f25de2be27f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $c8014f25de2be27f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $c8014f25de2be27f$var$formatLong = {
    date: (0, $f6b7cff3d084a1cf$export$2e2bcd8739ae039)({
        formats: $c8014f25de2be27f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $f6b7cff3d084a1cf$export$2e2bcd8739ae039)({
        formats: $c8014f25de2be27f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $f6b7cff3d084a1cf$export$2e2bcd8739ae039)({
        formats: $c8014f25de2be27f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $c8014f25de2be27f$export$2e2bcd8739ae039 = $c8014f25de2be27f$var$formatLong;


var $06efd8cc10c4bd73$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $06efd8cc10c4bd73$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $06efd8cc10c4bd73$var$formatRelativeLocale[token];
};
var $06efd8cc10c4bd73$export$2e2bcd8739ae039 = $06efd8cc10c4bd73$var$formatRelative;


function $e8d3841961a689fd$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $a6959687464919d6$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $a6959687464919d6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a6959687464919d6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $a6959687464919d6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $a6959687464919d6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $a6959687464919d6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $a6959687464919d6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $a6959687464919d6$var$localize = {
    ordinalNumber: $a6959687464919d6$var$ordinalNumber,
    era: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a6959687464919d6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a6959687464919d6$export$2e2bcd8739ae039 = $a6959687464919d6$var$localize;


function $bcb83626ff750417$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bcb83626ff750417$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bcb83626ff750417$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bcb83626ff750417$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bcb83626ff750417$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $03af782d2d1fcb5a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $6256b66dca390462$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6256b66dca390462$var$parseOrdinalNumberPattern = /\d+/i;
var $6256b66dca390462$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6256b66dca390462$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6256b66dca390462$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6256b66dca390462$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6256b66dca390462$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6256b66dca390462$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6256b66dca390462$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6256b66dca390462$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6256b66dca390462$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6256b66dca390462$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6256b66dca390462$var$match = {
    ordinalNumber: (0, $03af782d2d1fcb5a$export$2e2bcd8739ae039)({
        matchPattern: $6256b66dca390462$var$matchOrdinalNumberPattern,
        parsePattern: $6256b66dca390462$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6256b66dca390462$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6256b66dca390462$export$2e2bcd8739ae039 = $6256b66dca390462$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $aaf50d37016ddcb1$var$locale = {
    code: "en-US",
    formatDistance: (0, $8617db99f2cb39a3$export$2e2bcd8739ae039),
    formatLong: (0, $c8014f25de2be27f$export$2e2bcd8739ae039),
    formatRelative: (0, $06efd8cc10c4bd73$export$2e2bcd8739ae039),
    localize: (0, $a6959687464919d6$export$2e2bcd8739ae039),
    match: (0, $6256b66dca390462$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $aaf50d37016ddcb1$export$2e2bcd8739ae039 = $aaf50d37016ddcb1$var$locale;


var $b211592c26324d97$export$2e2bcd8739ae039 = (0, $aaf50d37016ddcb1$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e91dd50cc5cd7f0e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e91dd50cc5cd7f0e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e91dd50cc5cd7f0e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e91dd50cc5cd7f0e$var$doubleQuoteRegExp = /''/g;
var $e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e91dd50cc5cd7f0e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $b211592c26324d97$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $5663a6fd5511e169$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $63dba254cf419de0$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $8eaa0dace66c235b$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e91dd50cc5cd7f0e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $9bb5cf506dd06653$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e91dd50cc5cd7f0e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e91dd50cc5cd7f0e$var$cleanEscapedString(substring);
        var formatter = (0, $281a2e82d409b287$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $065cceb4149e3fc5$export$c6b49d6dceb604a1)(substring)) (0, $065cceb4149e3fc5$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $065cceb4149e3fc5$export$c6cc36aa33304772)(substring)) (0, $065cceb4149e3fc5$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $e91dd50cc5cd7f0e$var$cleanEscapedString(input) {
    var matched = input.match($e91dd50cc5cd7f0e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e91dd50cc5cd7f0e$var$doubleQuoteRegExp, "'");
}




function $1ff38398f48a5451$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4fd2c93311e78e29$export$dfd9b671c89acc8e = 7;
var $4fd2c93311e78e29$export$3913210603d8e9ae = 365.2425;
var $4fd2c93311e78e29$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4fd2c93311e78e29$export$91246f0b9bd9beff = 60000;
var $4fd2c93311e78e29$export$7f72910d6dfd237a = 3600000;
var $4fd2c93311e78e29$export$397c2d5776aa9055 = 1000;
var $4fd2c93311e78e29$export$4dec998e48f9c246 = -$4fd2c93311e78e29$export$81caae6e1cc7a622;
var $4fd2c93311e78e29$export$f2f5ae5a8e2d8f9f = 60;
var $4fd2c93311e78e29$export$3c58128db900d44e = 3;
var $4fd2c93311e78e29$export$80d7e435f744f319 = 12;
var $4fd2c93311e78e29$export$4db7641526e3241f = 4;
var $4fd2c93311e78e29$export$698aec755e92c695 = 3600;
var $4fd2c93311e78e29$export$a77c1a7ebebe2a5a = 60;
var $4fd2c93311e78e29$export$815a9362476d2fe3 = $4fd2c93311e78e29$export$698aec755e92c695 * 24;
var $4fd2c93311e78e29$export$34804a017b31e2fe = $4fd2c93311e78e29$export$815a9362476d2fe3 * 7;
var $4fd2c93311e78e29$export$7271e9e3478110d1 = $4fd2c93311e78e29$export$815a9362476d2fe3 * $4fd2c93311e78e29$export$3913210603d8e9ae;
var $4fd2c93311e78e29$export$8e6600bbdee7dabb = $4fd2c93311e78e29$export$7271e9e3478110d1 / 12;
var $4fd2c93311e78e29$export$be1dccf2de902d31 = $4fd2c93311e78e29$export$8e6600bbdee7dabb * 3;




function $1869277eefbd126c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $1869277eefbd126c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $1869277eefbd126c$var$parseYear(dateStrings.date, additionalDigits);
        date = $1869277eefbd126c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $1869277eefbd126c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $1869277eefbd126c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $1869277eefbd126c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $1869277eefbd126c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $1869277eefbd126c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $1869277eefbd126c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $1869277eefbd126c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($1869277eefbd126c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($1869277eefbd126c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($1869277eefbd126c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $1869277eefbd126c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1869277eefbd126c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $1869277eefbd126c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($1869277eefbd126c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $1869277eefbd126c$var$parseDateUnit(captures[1]);
    var month = $1869277eefbd126c$var$parseDateUnit(captures[2]) - 1;
    var day = $1869277eefbd126c$var$parseDateUnit(captures[3]);
    var week = $1869277eefbd126c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $1869277eefbd126c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$1869277eefbd126c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1869277eefbd126c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$1869277eefbd126c$var$validateDate(year, month, day) || !$1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $1869277eefbd126c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $1869277eefbd126c$var$parseTime(timeString) {
    var captures = timeString.match($1869277eefbd126c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $1869277eefbd126c$var$parseTimeUnit(captures[1]);
    var minutes = $1869277eefbd126c$var$parseTimeUnit(captures[2]);
    var seconds = $1869277eefbd126c$var$parseTimeUnit(captures[3]);
    if (!$1869277eefbd126c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $4fd2c93311e78e29$export$7f72910d6dfd237a) + minutes * (0, $4fd2c93311e78e29$export$91246f0b9bd9beff) + seconds * 1000;
}
function $1869277eefbd126c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $1869277eefbd126c$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($1869277eefbd126c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$1869277eefbd126c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $4fd2c93311e78e29$export$7f72910d6dfd237a) + minutes * (0, $4fd2c93311e78e29$export$91246f0b9bd9beff));
}
function $1869277eefbd126c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $1869277eefbd126c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1869277eefbd126c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1869277eefbd126c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($1869277eefbd126c$var$daysInMonths[month] || ($1869277eefbd126c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($1869277eefbd126c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $1869277eefbd126c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $1869277eefbd126c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $1869277eefbd126c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}



var $bh6RR = parcelRequire("bh6RR");
var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $fa93bfc840b773d3$var$extendStatics = function(d, b) {
    $fa93bfc840b773d3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fa93bfc840b773d3$var$extendStatics(d, b);
};
function $fa93bfc840b773d3$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fa93bfc840b773d3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fa93bfc840b773d3$var$__assign = function() {
    $fa93bfc840b773d3$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fa93bfc840b773d3$var$__assign.apply(this, arguments);
};
/**
 * Copied from fbjs is-shallow-equal
 */ var $fa93bfc840b773d3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $fa93bfc840b773d3$var$is(x, y) {
    // SameValue algorithm
    if (x === y) // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function $fa93bfc840b773d3$var$shallowEqual(objA, objB) {
    if ($fa93bfc840b773d3$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(var i = 0; i < keysA.length; i++){
        if (!$fa93bfc840b773d3$var$hasOwnProperty.call(objB, keysA[i]) || !$fa93bfc840b773d3$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
/**
 * Special symbol which might be used to delete properties
 * from an object calling [State.set](#set) or [State.merge](#merge).
 *
 * [Learn more...](https://hookstate.js.org/docs/nested-state#deleting-existing-element)
 */ var $fa93bfc840b773d3$export$f883a24d5edde77c = Symbol("none");
// type PickByType<T, U, B = false> = Pick<T, KeysOfType<T, U, B>>;
/**
 * A symbol which is used for type inference marking.
 *
 * @hidden
 * @ignore
 */ var $fa93bfc840b773d3$export$1309cde3af4b1033 = Symbol("__state");
function $fa93bfc840b773d3$export$4af2f85fc25cecbb(initial, extension) {
    var store = $fa93bfc840b773d3$var$createStore(initial);
    store.activate(extension);
    var methods = store.toMethods();
    return methods.self();
}
/**
 * A method to destroy a global state and resources allocated by the extensions
 */ function $fa93bfc840b773d3$export$b1fb4cac938035f7(state) {
    state[$fa93bfc840b773d3$var$self].deactivate();
}
/**
 * A method to check if a variable is an instance of Hookstate State
 */ function $fa93bfc840b773d3$export$27cad3862625b1ff(v) {
    return !!(v === null || v === void 0 ? void 0 : v[$fa93bfc840b773d3$var$self]);
}
/**
 * A method to check if a variable is an instance of traced (wrapped in a proxy) Hookstate Value
 */ function $fa93bfc840b773d3$export$21a38a31e960475d(v) {
    return !!(v === null || v === void 0 ? void 0 : v[$fa93bfc840b773d3$var$SelfMethodsID]);
}
/**
 * A function combines multiple extensions into one extension and returns it
 * Browse an example [here](https://hookstate.js.org/docs/extensions-snapshotable)
 */ function $fa93bfc840b773d3$export$8b58be045bf06082(e1, e2, e3, e4, e5) {
    function extended(extensions) {
        var exts = extensions.map(function(i) {
            return i();
        });
        var onInitCbs = exts.map(function(i) {
            return i.onInit;
        }).filter(function(i) {
            return i;
        });
        var onPremergeCbs = exts.map(function(i) {
            return i.onPremerge;
        }).filter(function(i) {
            return i;
        });
        var onPresetCbs = exts.map(function(i) {
            return i.onPreset;
        }).filter(function(i) {
            return i;
        });
        var onSetCbs = exts.map(function(i) {
            return i.onSet;
        }).filter(function(i) {
            return i;
        });
        var onDestroyCbs = exts.map(function(i) {
            return i.onDestroy;
        }).filter(function(i) {
            return i;
        });
        var result = {
            onCreate: function(instanceFactory, combinedMethods) {
                for(var _i = 0, exts_1 = exts; _i < exts_1.length; _i++){
                    var ext = exts_1[_i];
                    if (ext.onCreate) {
                        var extMethods = ext.onCreate(instanceFactory, combinedMethods);
                        Object.assign(combinedMethods, extMethods);
                    }
                }
                return combinedMethods;
            }
        };
        if (onInitCbs.length > 0) result.onInit = function(s, e) {
            for(var _i = 0, onInitCbs_1 = onInitCbs; _i < onInitCbs_1.length; _i++){
                var cb = onInitCbs_1[_i];
                cb(s, e);
            }
        };
        if (onPremergeCbs.length > 0) result.onPremerge = function(s, d, r) {
            for(var _i = 0, onPremergeCbs_1 = onPremergeCbs; _i < onPremergeCbs_1.length; _i++){
                var cb = onPremergeCbs_1[_i];
                cb(s, d, r);
            }
        };
        if (onPresetCbs.length > 0) result.onPreset = function(s, d, r) {
            for(var _i = 0, onPresetCbs_1 = onPresetCbs; _i < onPresetCbs_1.length; _i++){
                var cb = onPresetCbs_1[_i];
                cb(s, d, r);
            }
        };
        if (onSetCbs.length > 0) result.onSet = function(s, d, r) {
            for(var _i = 0, onSetCbs_1 = onSetCbs; _i < onSetCbs_1.length; _i++){
                var cb = onSetCbs_1[_i];
                cb(s, d, r);
            }
        };
        if (onDestroyCbs.length > 0) result.onDestroy = function(s) {
            for(var _i = 0, onDestroyCbs_1 = onDestroyCbs; _i < onDestroyCbs_1.length; _i++){
                var cb = onDestroyCbs_1[_i];
                cb(s);
            }
        };
        return result;
    }
    return function() {
        return extended([
            e1,
            e2,
            e3,
            e4,
            e5
        ].filter(function(i) {
            return i;
        }));
    };
}
function $fa93bfc840b773d3$export$7a18e83a30d41594(source, extension) {
    var parentMethods = Object(source) === source ? source[$fa93bfc840b773d3$var$self] : undefined;
    if (parentMethods) {
        if (parentMethods.isMounted) {
            // Scoped state mount
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var initializer = function() {
                // warning: this is called twice in react strict mode
                var store = parentMethods.store;
                var onSetUsedCallback = function() {
                    return setValue_1({
                        store: store,
                        state: state,
                        source: value_1.source // mutable, get the latest from value
                    });
                };
                var state = new $fa93bfc840b773d3$var$StateMethodsImpl(store, parentMethods.path, store.get(parentMethods.path), store.edition, onSetUsedCallback);
                return {
                    store: store,
                    state: state,
                    source: source
                };
            };
            var _a = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initializer), value_1 = _a[0], setValue_1 = _a[1];
            if (value_1.store !== parentMethods.store || !("source" in value_1)) throw new $fa93bfc840b773d3$var$StateInvalidUsageError(parentMethods.path, $fa93bfc840b773d3$var$ErrorId.InitStateStoreSwitchover);
            // TODO move to a class hide props on prototype level
            // hide props from development tools
            Object.defineProperty(value_1, "store", {
                enumerable: false
            });
            Object.defineProperty(value_1, "state", {
                enumerable: false
            });
            Object.defineProperty(value_1, "source", {
                enumerable: false
            });
            value_1.state.reconstruct(parentMethods.path, value_1.store.get(parentMethods.path), value_1.store.edition, // parent state object has changed its reference object
            // so the scopped state should change too
            value_1.source !== source);
            value_1.source = source;
            // need to subscribe in sync mode, because
            // safari delays calling the effect giving priority to timeouts and network events,
            // which can cause the state update
            parentMethods.subscribe(value_1.state); // no-op if already subscribed
            $fa93bfc840b773d3$var$useIsomorphicLayoutEffect(function() {
                // warning: in strict mode, effect is called twice
                // so need to restore subscription and reconstruct the extension
                // after the first effect unmount callback
                value_1.state.onMount(); // no-op if already mounted
                parentMethods.subscribe(value_1.state); // no-op if already subscribed
                return function() {
                    value_1.state.onUnmount();
                    parentMethods.unsubscribe(value_1.state);
                };
            }, []);
            var state = value_1.state.self();
            // expose property in development tools
            value_1["[hookstate(scoped)]"] = state; // TODO use label here, add core extension to label states
            return state;
        } else {
            // Global state mount or destroyed link
            // eslint-disable-next-line react-hooks/rules-of-hooks
            var initializer = function() {
                // warning: this is called twice in react strict mode
                var store = parentMethods.store;
                var onSetUsedCallback = function() {
                    return setValue_2({
                        store: store,
                        state: state,
                        source: value_2.source // mutable, get the latest from value
                    });
                };
                var state = new $fa93bfc840b773d3$var$StateMethodsImpl(store, $fa93bfc840b773d3$var$RootPath, store.get($fa93bfc840b773d3$var$RootPath), store.edition, onSetUsedCallback);
                return {
                    store: store,
                    state: state,
                    source: source
                };
            };
            var _b = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initializer), value_2 = _b[0], setValue_2 = _b[1];
            if (value_2.store !== parentMethods.store || !("source" in value_2)) throw new $fa93bfc840b773d3$var$StateInvalidUsageError(parentMethods.path, $fa93bfc840b773d3$var$ErrorId.InitStateStoreSwitchover);
            // hide props from development tools
            Object.defineProperty(value_2, "store", {
                enumerable: false
            });
            Object.defineProperty(value_2, "state", {
                enumerable: false
            });
            Object.defineProperty(value_2, "source", {
                enumerable: false
            });
            value_2.state.reconstruct($fa93bfc840b773d3$var$RootPath, value_2.store.get($fa93bfc840b773d3$var$RootPath), value_2.store.edition, // parent state object has changed its reference object
            // so the scopped state should change too
            value_2.source !== source);
            value_2.source = source;
            // need to subscribe in sync mode, because
            // safari delays calling the effect giving priority to timeouts and network events,
            // which can cause the state update
            value_2.store.subscribe(value_2.state); // no-op if already subscribed
            $fa93bfc840b773d3$var$useIsomorphicLayoutEffect(function() {
                // warning: in strict mode, effect is called twice
                // so need to restore subscription and reconstruct the extension
                // after the first effect unmount callback
                value_2.state.onMount(); // no-op if already mounted
                value_2.store.subscribe(value_2.state); // no-op if already subscribed
                return function() {
                    value_2.state.onUnmount();
                    value_2.store.unsubscribe(value_2.state);
                };
            }, []);
            var state = value_2.state.self();
            for(var ind = 0; ind < parentMethods.path.length; ind += 1)state = state.nested(parentMethods.path[ind]);
            // expose property in development tools
            value_2["[hookstate(global)]"] = state; // TODO use label here, add core extension to label states
            return state;
        }
    } else {
        // Local state mount
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var initializer = function() {
            // warning: this is called twice in react strict mode
            var store = $fa93bfc840b773d3$var$createStore(source);
            var onSetUsedCallback = function() {
                return setValue_3({
                    store: store,
                    state: state
                });
            };
            var state = new $fa93bfc840b773d3$var$StateMethodsImpl(store, $fa93bfc840b773d3$var$RootPath, store.get($fa93bfc840b773d3$var$RootPath), store.edition, onSetUsedCallback);
            return {
                store: store,
                state: state
            };
        };
        var _c = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(initializer), value_3 = _c[0], setValue_3 = _c[1];
        if ("source" in value_3) throw new $fa93bfc840b773d3$var$StateInvalidUsageError($fa93bfc840b773d3$var$RootPath, $fa93bfc840b773d3$var$ErrorId.InitStateStoreSwitchover);
        // hide props from development tools
        Object.defineProperty(value_3, "store", {
            enumerable: false
        });
        Object.defineProperty(value_3, "state", {
            enumerable: false
        });
        value_3.state.reconstruct($fa93bfc840b773d3$var$RootPath, value_3.store.get($fa93bfc840b773d3$var$RootPath), value_3.store.edition, false);
        // need to subscribe in sync mode, because
        // safari delays calling the effect giving priority to timeouts and network events,
        // which can cause the state update
        value_3.store.subscribe(value_3.state); // no-op if already subscribed
        // need to attach the extension straight away
        // because extension methods are used in render function
        // and we can not defer it to the effect callback
        value_3.store.activate(extension); // no-op if already attached
        $fa93bfc840b773d3$var$useIsomorphicLayoutEffect(function() {
            // warning: in strict mode, effect is called twice
            // so need to restore subscription and reconstruct the extension
            // after the first effect unmount callback
            value_3.state.onMount(); // no-op if already mounted
            value_3.store.subscribe(value_3.state); // no-op if already subscribed
            value_3.store.activate(extension); // no-op if already attached
            return function() {
                value_3.state.onUnmount();
                value_3.store.unsubscribe(value_3.state);
                value_3.store.deactivate(); // this will destroy the extensions
            };
        }, []);
        var state = value_3.state.self();
        // expose property in development tools
        value_3["[hookstate(local)]"] = state; // TODO use label here, add core extension to label states
        return state;
    }
}
function $fa93bfc840b773d3$export$e8ecf3edd313f618(props) {
    var scoped = $fa93bfc840b773d3$export$7a18e83a30d41594(props.state, props.extension);
    return props.suspend && $fa93bfc840b773d3$export$a1428c8f7ba796e8(scoped) || props.children(scoped);
}
/**
 * If state is promised, then it returns a component which integrates with React 18 Suspend feature automatically.
 * Note, that React 18 Suspend support for data loading is still experimental,
 * but it worked as per our experiments and testing.
 */ function $fa93bfc840b773d3$export$a1428c8f7ba796e8(state) {
    var p = state.promise;
    return p && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(function() {
        return p;
    }));
}
///
/// INTERNAL SYMBOLS (LIBRARY IMPLEMENTATION)
///
var $fa93bfc840b773d3$var$self = Symbol("self");
var $fa93bfc840b773d3$var$ErrorId;
(function(ErrorId) {
    ErrorId[ErrorId["StateUsedInDependencyList"] = 100] = "StateUsedInDependencyList";
    ErrorId[ErrorId["InitStateToValueFromState"] = 101] = "InitStateToValueFromState";
    ErrorId[ErrorId["SetStateToValueFromState"] = 102] = "SetStateToValueFromState";
    ErrorId[ErrorId["GetStateWhenPromised"] = 103] = "GetStateWhenPromised";
    ErrorId[ErrorId["SetStateWhenPromised"] = 104] = "SetStateWhenPromised";
    ErrorId[ErrorId["SetStateNestedToPromised"] = 105] = "SetStateNestedToPromised";
    ErrorId[ErrorId["SetStateWhenDestroyed"] = 106] = "SetStateWhenDestroyed";
    ErrorId[ErrorId["ToJson_Value"] = 108] = "ToJson_Value";
    ErrorId[ErrorId["ToJson_State"] = 109] = "ToJson_State";
    ErrorId[ErrorId["GetProperty_Function"] = 110] = "GetProperty_Function";
    ErrorId[ErrorId["InitStateStoreSwitchover"] = 111] = "InitStateStoreSwitchover";
    ErrorId[ErrorId["GetUnknownPlugin"] = 120] = "GetUnknownPlugin";
    ErrorId[ErrorId["SetProperty_State"] = 201] = "SetProperty_State";
    ErrorId[ErrorId["SetProperty_Value"] = 202] = "SetProperty_Value";
    ErrorId[ErrorId["SetPrototypeOf_State"] = 203] = "SetPrototypeOf_State";
    ErrorId[ErrorId["SetPrototypeOf_Value"] = 204] = "SetPrototypeOf_Value";
    ErrorId[ErrorId["PreventExtensions_State"] = 205] = "PreventExtensions_State";
    ErrorId[ErrorId["PreventExtensions_Value"] = 206] = "PreventExtensions_Value";
    ErrorId[ErrorId["DefineProperty_State"] = 207] = "DefineProperty_State";
    ErrorId[ErrorId["DefineProperty_Value"] = 208] = "DefineProperty_Value";
    ErrorId[ErrorId["DeleteProperty_State"] = 209] = "DeleteProperty_State";
    ErrorId[ErrorId["DeleteProperty_Value"] = 210] = "DeleteProperty_Value";
    ErrorId[ErrorId["Construct_State"] = 211] = "Construct_State";
    ErrorId[ErrorId["Construct_Value"] = 212] = "Construct_Value";
    ErrorId[ErrorId["Apply_State"] = 213] = "Apply_State";
    ErrorId[ErrorId["Apply_Value"] = 214] = "Apply_Value";
})($fa93bfc840b773d3$var$ErrorId || ($fa93bfc840b773d3$var$ErrorId = {}));
var $fa93bfc840b773d3$var$StateInvalidUsageError = /** @class */ function(_super) {
    $fa93bfc840b773d3$var$__extends(StateInvalidUsageError, _super);
    function StateInvalidUsageError(path, id, details) {
        return _super.call(this, "Error: HOOKSTATE-".concat(id, " [path: /").concat(path.join("/")).concat(details ? ", details: ".concat(details) : "", "]. ") + "See https://hookstate.js.org/docs/exceptions#hookstate-".concat(id)) || this;
    }
    return StateInvalidUsageError;
}(Error);
var $fa93bfc840b773d3$var$SelfMethodsID = Symbol("ProxyMarker");
var $fa93bfc840b773d3$var$RootPath = [];
var $fa93bfc840b773d3$var$Store = /** @class */ function() {
    function Store(_value) {
        var _this = this;
        this._value = _value;
        // > 0 means active store, < 0 means destroyed
        // please note, in react strict mode and hot reload cases
        // state can be reused, so we should support store resurection
        this.edition = 1;
        this._subscribers = new Set();
        if (Object(_value) === _value && $fa93bfc840b773d3$var$configuration.promiseDetector(_value)) this.setPromised(_value);
        else if (_value === $fa93bfc840b773d3$export$f883a24d5edde77c) this.setPromised(undefined);
        var onSetUsedStoreStateMethods = function() {
            _this._stateMethods.reconstruct($fa93bfc840b773d3$var$RootPath, _this.get($fa93bfc840b773d3$var$RootPath), _this.edition, false);
        };
        onSetUsedStoreStateMethods[$fa93bfc840b773d3$var$IsUnmounted] = true;
        this._stateMethods = new $fa93bfc840b773d3$var$StateMethodsImpl(this, $fa93bfc840b773d3$var$RootPath, this.get($fa93bfc840b773d3$var$RootPath), this.edition, onSetUsedStoreStateMethods);
        this.subscribe(this._stateMethods);
    }
    Store.prototype.setPromised = function(promise) {
        var _this = this;
        this._value = $fa93bfc840b773d3$export$f883a24d5edde77c;
        this._promiseError = undefined;
        this._promiseResolver = undefined;
        if (!promise) {
            this._promise = new Promise(function(resolve) {
                _this._promiseResolver = resolve;
            });
            return;
        }
        promise = promise.then(function(r) {
            if (_this._promise === promise) {
                _this._promise = undefined;
                _this._promiseError = undefined;
                _this._promiseResolver;
                _this.update(_this._stateMethods.self(), _this.set($fa93bfc840b773d3$var$RootPath, r));
            }
        }).catch(function(err) {
            if (_this._promise === promise) {
                _this._promise = undefined;
                _this._promiseResolver = undefined;
                _this._promiseError = err;
                _this.edition += 1;
                var ad = {
                    path: $fa93bfc840b773d3$var$RootPath
                };
                _this.update(_this._stateMethods.self(), ad);
            }
        });
        this._promise = promise;
    };
    Store.prototype.activate = function(extensionFactory) {
        var _a, _b, _c, _d;
        if (this.edition < 0) this.edition = -this.edition;
        if (this._extension === undefined) {
            this._extension = extensionFactory === null || extensionFactory === void 0 ? void 0 : extensionFactory();
            this._extensionMethods = (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onCreate) === null || _b === void 0 ? void 0 : _b.call(_a, this._stateMethods.self(), {});
            // this is invoked with all extension methods activated on the state
            (_d = (_c = this._extension) === null || _c === void 0 ? void 0 : _c.onInit) === null || _d === void 0 || _d.call(_c, this._stateMethods.self(), this._extensionMethods || {});
        }
    };
    Store.prototype.deactivate = function() {
        var _a, _b;
        if (this._extension) {
            (_b = (_a = this._extension).onDestroy) === null || _b === void 0 || _b.call(_a, this._stateMethods.self());
            delete this._extension;
            delete this._extensionMethods;
        }
        if (this.edition > 0) this.edition = -this.edition;
    };
    Object.defineProperty(Store.prototype, "extension", {
        get: function() {
            return this._extensionMethods;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "promiseError", {
        get: function() {
            return this._promiseError;
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.get = function(path) {
        var result = this._value;
        if (result === $fa93bfc840b773d3$export$f883a24d5edde77c) return result;
        path.forEach(function(p) {
            result = result[p];
        });
        return result;
    };
    Store.prototype.set = function(path, value) {
        var _a, _b;
        if (this.edition < 0) // TODO convert to console log
        throw new $fa93bfc840b773d3$var$StateInvalidUsageError(path, $fa93bfc840b773d3$var$ErrorId.SetStateWhenDestroyed);
        if (path.length === 0) {
            // Root value UPDATE case,
            if (value === $fa93bfc840b773d3$export$f883a24d5edde77c) this.setPromised(undefined);
            else if (Object(value) === value && $fa93bfc840b773d3$var$configuration.promiseDetector(value)) {
                this.setPromised(value);
                value = $fa93bfc840b773d3$export$f883a24d5edde77c;
            } else if (this._promise && !this._promiseResolver) throw new $fa93bfc840b773d3$var$StateInvalidUsageError(path, $fa93bfc840b773d3$var$ErrorId.SetStateWhenPromised);
            else this._promiseError = undefined;
            var prevValue = this._value;
            this._value = value;
            this.afterSet();
            if (prevValue === $fa93bfc840b773d3$export$f883a24d5edde77c && this._value !== $fa93bfc840b773d3$export$f883a24d5edde77c && this._promiseResolver) {
                this._promise = undefined;
                this._promiseError = undefined;
                var resolver = this._promiseResolver;
                this._promiseResolver;
                resolver(this._value);
            }
            return {
                path: path
            };
        }
        if (Object(value) === value && $fa93bfc840b773d3$var$configuration.promiseDetector(value)) // TODO this one still can get into the state as nested property, need to check on read instead
        throw new $fa93bfc840b773d3$var$StateInvalidUsageError(path, $fa93bfc840b773d3$var$ErrorId.SetStateNestedToPromised);
        var target = this._value;
        for(var i = 0; i < path.length - 1; i += 1)target = target[path[i]];
        var p = path[path.length - 1];
        if (p in target) {
            if (value !== $fa93bfc840b773d3$export$f883a24d5edde77c) {
                // Property UPDATE case
                target[p] = value;
                this.afterSet();
                return {
                    path: path
                };
            } else {
                // Property DELETE case
                if (Array.isArray(target) && typeof p === "number") target.splice(p, 1);
                else delete target[p];
                this.afterSet();
                // if an array of objects is about to loose existing property
                // we consider it is the whole object is changed
                // which is identified by upper path
                return {
                    path: path.slice(0, -1),
                    actions: (_a = {}, _a[p] = "D", _a)
                };
            }
        }
        if (value !== $fa93bfc840b773d3$export$f883a24d5edde77c) {
            // Property INSERT case
            target[p] = value;
            this.afterSet();
            // if an array of objects is about to be extended by new property
            // we consider it is the whole object is changed
            // which is identified by upper path
            return {
                path: path.slice(0, -1),
                actions: (_b = {}, _b[p] = "I", _b)
            };
        }
        // Non-existing property DELETE case
        // no-op
        return {
            path: path
        };
    };
    Store.prototype.preset = function(state, value) {
        var _a, _b;
        (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onPreset) === null || _b === void 0 || _b.call(_a, state, value, this._stateMethods.self());
    };
    Store.prototype.premerge = function(state, value) {
        var _a, _b;
        (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onPremerge) === null || _b === void 0 || _b.call(_a, state, value, this._stateMethods.self());
    };
    Store.prototype.update = function(state, ad) {
        var _this = this;
        var _a, _b;
        (_b = (_a = this._extension) === null || _a === void 0 ? void 0 : _a.onSet) === null || _b === void 0 || _b.call(_a, state, ad, this._stateMethods.self());
        var actions = new Set();
        // check if actions descriptor can be unfolded into a number of individual update actions
        // this is the case when merge call swaps to properties for example
        // so we optimize rerendering only these properties
        if (ad.actions && Object.values(ad.actions).findIndex(function(i) {
            return i !== "U";
        }) === -1) // all actions are update actions
        Object.keys(ad.actions).forEach(function(key) {
            _this._subscribers.forEach(function(s) {
                return s.onSet({
                    path: ad.path.concat(key)
                }, actions);
            });
        });
        else this._subscribers.forEach(function(s) {
            return s.onSet(ad, actions);
        });
        actions.forEach(function(a) {
            return a();
        });
    };
    Store.prototype.afterSet = function() {
        if (this.edition > 0) this.edition += 1;
        if (this.edition < 0) this.edition -= 1;
    };
    Store.prototype.toMethods = function() {
        return this._stateMethods;
    };
    Store.prototype.subscribe = function(l) {
        this._subscribers.add(l);
    };
    Store.prototype.unsubscribe = function(l) {
        this._subscribers.delete(l);
    };
    Store.prototype.toJSON = function() {
        throw new $fa93bfc840b773d3$var$StateInvalidUsageError($fa93bfc840b773d3$var$RootPath, $fa93bfc840b773d3$var$ErrorId.ToJson_Value);
    };
    return Store;
}();
// use symbol property to allow for easier reference finding
var $fa93bfc840b773d3$var$UnusedValue = Symbol("UnusedValue");
// use symbol to mark that a function has no effect anymore
var $fa93bfc840b773d3$var$IsUnmounted = Symbol("IsUnmounted");
var $fa93bfc840b773d3$var$StateMethodsImpl = /** @class */ function() {
    function StateMethodsImpl(store, path, valueSource, valueEdition, onSetUsed) {
        this.store = store;
        this.path = path;
        this.valueSource = valueSource;
        this.valueEdition = valueEdition;
        this.onSetUsed = onSetUsed;
        this.valueUsed = $fa93bfc840b773d3$var$UnusedValue;
    }
    Object.defineProperty(StateMethodsImpl.prototype, $fa93bfc840b773d3$export$1309cde3af4b1033, {
        get: function() {
            return [
                this.get(),
                this.self()
            ];
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.reconstruct = function(path, valueSource, valueEdition, reset) {
        this.path = path;
        this.valueSource = valueSource;
        this.valueEdition = valueEdition;
        this.valueUsed = $fa93bfc840b773d3$var$UnusedValue;
        if (reset) {
            delete this.selfUsed;
            delete this.childrenCreated;
            delete this.childrenUsedPrevious;
        } else {
            this.valueUsedNoProxyPrevious = this.valueUsedNoProxy;
            this.childrenUsedPrevious = this.childrenUsed;
        }
        delete this.valueUsedNoProxy;
        delete this.childrenUsed;
    // We should not delete subscribers as these are self cleaned up when unmounted
    // Theoretically it is possible to reconnect subscribers like we done it for 
    // children, but it is easier and more efficient to leave subscribers to have independent lifecycle
    // If we delete subscribers here, scoped states wrapped in React.memo
    // will lose state change propagation and rerendering for scopped states
    // delete this.subscribers;
    };
    StateMethodsImpl.prototype.reconnect = function() {
        // Mark it's as used, because it is used in a dependency list
        // (we are making it's value used implicitly, so rerender is triggered).
        // Otherwise, no rerender => no effects running, even when a value is changed.
        // This is marking the state used a bit more than it might be really used
        // in the effect callback. More optimized / precise implementation would be
        // to remember useSelf as previous (similar to childrenUsed),
        // but it is a lot more complicated and the benefit is not worth the complexity.
        // So, mark it used.
        // We also using it without proxy if it wass used without proxy during the
        // previous render, because otherwise children usage might be not traced completely
        // and so will not result in renreder if children are updated.
        // This is covered by some tests, but there are so many possible corner cases...
        this.get({
            __internalAllowPromised: true,
            noproxy: this.valueUsedNoProxyPrevious
        });
        this.childrenUsed = $fa93bfc840b773d3$var$__assign($fa93bfc840b773d3$var$__assign({}, this.childrenUsedPrevious), this.childrenUsed);
    };
    StateMethodsImpl.prototype.getUntracked = function(__internalAllowPromised) {
        if (this.valueEdition !== this.store.edition) {
            this.valueSource = this.store.get(this.path);
            this.valueEdition = this.store.edition;
            if (this.valueUsed !== $fa93bfc840b773d3$var$UnusedValue) {
                this.valueUsed = $fa93bfc840b773d3$var$UnusedValue;
                this.get({
                    __internalAllowPromised: true
                }); // renew cache to keep it marked used
            }
        }
        if (__internalAllowPromised) return this.valueSource;
        if (this.store.promiseError) throw this.store.promiseError;
        if (this.store.promise) throw new $fa93bfc840b773d3$var$StateInvalidUsageError(this.path, $fa93bfc840b773d3$var$ErrorId.GetStateWhenPromised);
        return this.valueSource;
    };
    StateMethodsImpl.prototype.get = function(options) {
        var _a;
        var valueSource = this.getUntracked(options === null || options === void 0 ? void 0 : options.__internalAllowPromised);
        if (options === null || options === void 0 ? void 0 : options.stealth) return valueSource;
        if (this.valueUsed === $fa93bfc840b773d3$var$UnusedValue) {
            if (Array.isArray(valueSource)) this.valueUsed = this.valueArrayImpl(valueSource);
            else if (Object(valueSource) === valueSource) {
                if (((_a = valueSource.constructor) === null || _a === void 0 ? void 0 : _a.name) === "Object") this.valueUsed = this.valueObjectImpl(valueSource);
                else {
                    // any other object except Object, for example Date
                    this.valueUsedNoProxy = true;
                    this.valueUsed = valueSource;
                }
            } else this.valueUsed = valueSource;
        }
        if (options === null || options === void 0 ? void 0 : options.noproxy) {
            this.valueUsedNoProxy = true;
            return valueSource;
        }
        return this.valueUsed;
    };
    Object.defineProperty(StateMethodsImpl.prototype, "value", {
        get: function() {
            // various tools, including react dev tools and webpack import
            // inspect an object and it's properties
            // so these should not throw
            // return this.get({ __internalAllowPromised: true })
            return this.get();
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.setUntrackedV4 = function(newValue) {
        if (typeof newValue === "function") newValue = newValue(this.getUntracked());
        this.store.preset(this.self(), newValue);
        if (Object(newValue) === newValue && newValue[$fa93bfc840b773d3$var$SelfMethodsID]) // TODO check on read instead as it might escape as nested on set anyway
        throw new $fa93bfc840b773d3$var$StateInvalidUsageError(this.path, $fa93bfc840b773d3$var$ErrorId.SetStateToValueFromState);
        if (newValue !== Object(newValue) && newValue === this.getUntracked(true)) // this is primitive value and has not changed
        // so skip this set call as it does not make an effect
        return null;
        return this.store.set(this.path, newValue);
    };
    StateMethodsImpl.prototype.set = function(newValue) {
        var ad = this.setUntrackedV4(newValue);
        if (ad) this.store.update(this.self(), ad);
    };
    StateMethodsImpl.prototype.mergeUntracked = function(sourceValue) {
        var r = this.mergeUntrackedV4(sourceValue);
        if (r) return [
            r.path
        ];
        return [];
    };
    StateMethodsImpl.prototype.mergeUntrackedV4 = function(sourceValue) {
        var currentValue = this.getUntracked();
        if (typeof sourceValue === "function") sourceValue = sourceValue(currentValue);
        this.store.premerge(this.self(), sourceValue);
        if (Array.isArray(currentValue)) {
            if (Array.isArray(sourceValue)) {
                var ad_1 = {
                    path: this.path,
                    actions: {}
                };
                sourceValue.forEach(function(e, i) {
                    ad_1.actions[currentValue.push(e) - 1] = "I";
                });
                if (Object.keys(ad_1.actions).length > 0) {
                    this.setUntrackedV4(currentValue);
                    return ad_1;
                }
                return null;
            } else {
                var ad_2 = {
                    path: this.path,
                    actions: {}
                };
                var deletedIndexes_1 = [];
                Object.keys(sourceValue).map(function(i) {
                    return Number(i);
                }).sort(function(a, b) {
                    return a - b;
                }).forEach(function(i) {
                    var index = Number(i);
                    var newPropValue = sourceValue[index];
                    if (newPropValue === $fa93bfc840b773d3$export$f883a24d5edde77c) {
                        ad_2.actions[index] = "D";
                        deletedIndexes_1.push(index);
                    } else {
                        if (index in currentValue) ad_2.actions[index] = "U";
                        else ad_2.actions[index] = "I";
                        currentValue[index] = newPropValue;
                    }
                });
                // indexes are ascending sorted as per above
                // so, delete one by one from the end
                // this way index positions do not change
                deletedIndexes_1.reverse().forEach(function(p) {
                    currentValue.splice(p, 1);
                });
                if (Object.keys(ad_2.actions).length > 0) {
                    this.setUntrackedV4(currentValue);
                    return ad_2;
                }
                return null;
            }
        } else if (Object(currentValue) === currentValue) {
            var ad_3 = {
                path: this.path,
                actions: {}
            };
            Object.keys(sourceValue).forEach(function(key) {
                var newPropValue = sourceValue[key];
                if (newPropValue === $fa93bfc840b773d3$export$f883a24d5edde77c) {
                    ad_3.actions[key] = "D";
                    delete currentValue[key];
                } else {
                    if (key in currentValue) ad_3.actions[key] = "U";
                    else ad_3.actions[key] = "I";
                    currentValue[key] = newPropValue;
                }
            });
            if (Object.keys(ad_3.actions).length > 0) {
                this.setUntrackedV4(currentValue);
                return ad_3;
            }
            return null;
        } else if (typeof currentValue === "string") return this.setUntrackedV4(currentValue + String(sourceValue));
        else return this.setUntrackedV4(sourceValue);
    };
    StateMethodsImpl.prototype.merge = function(sourceValue) {
        var r = this.mergeUntrackedV4(sourceValue);
        if (r) this.store.update(this.self(), r);
    };
    StateMethodsImpl.prototype.nested = function(key) {
        return this.child(key).self();
    };
    StateMethodsImpl.prototype.rerender = function(paths) {
        for(var _i = 0, paths_1 = paths; _i < paths_1.length; _i++){
            var path = paths_1[_i];
            this.store.update(this.self(), {
                path: path
            });
        }
    };
    StateMethodsImpl.prototype.activate = function(extensionFactory) {
        this.store.activate(extensionFactory);
    };
    StateMethodsImpl.prototype.deactivate = function() {
        this.store.deactivate();
    };
    StateMethodsImpl.prototype.subscribe = function(l) {
        if (this.subscribers === undefined) this.subscribers = new Set();
        this.subscribers.add(l);
    };
    StateMethodsImpl.prototype.unsubscribe = function(l) {
        if (this.subscribers) this.subscribers.delete(l);
    };
    Object.defineProperty(StateMethodsImpl.prototype, "isMounted", {
        get: function() {
            return !this.onSetUsed[$fa93bfc840b773d3$var$IsUnmounted];
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.onMount = function() {
        delete this.onSetUsed[$fa93bfc840b773d3$var$IsUnmounted];
    };
    StateMethodsImpl.prototype.onUnmount = function() {
        this.onSetUsed[$fa93bfc840b773d3$var$IsUnmounted] = true;
    };
    StateMethodsImpl.prototype.onSet = function(ad, actions) {
        var _this = this;
        var update = function() {
            var _a;
            var isAffected = false;
            if (_this.valueUsedNoProxy && _this.valueUsed !== $fa93bfc840b773d3$var$UnusedValue) {
                actions.add(_this.onSetUsed);
                delete _this.selfUsed;
                isAffected = true;
            }
            var path = ad.path;
            var nextChildKey = path[_this.path.length];
            if (nextChildKey === undefined) // There is no next child to dive into
            // So it is this one which was updated
            {
                if (_this.valueUsed !== $fa93bfc840b773d3$var$UnusedValue) {
                    actions.add(_this.onSetUsed);
                    delete _this.selfUsed;
                    delete _this.childrenUsed;
                    if (ad.actions && _this.childrenCreated) {
                        // TODO add automated unit tests for this part
                        if (Array.isArray(_this.valueSource) && Object.values(ad.actions).includes("D")) {
                            // this is an array and some elements were removed
                            // so invalidate cache for all children after the first deleted
                            var firstDeletedIndex = Object.keys(ad.actions).map(function(i) {
                                return Number(i);
                            }).sort(function(a, b) {
                                return a - b;
                            }).find(function(i) {
                                var _a;
                                return ((_a = ad.actions) === null || _a === void 0 ? void 0 : _a[i]) === "D";
                            });
                            for(var childKey in _this.childrenCreated)if (Number(childKey) >= firstDeletedIndex || childKey in ad.actions) delete _this.childrenCreated[childKey];
                        } else for(var childKey in ad.actions)delete _this.childrenCreated[childKey];
                    } else delete _this.childrenCreated;
                    return true;
                }
            } else {
                var nextChild = (_a = _this.childrenUsed) === null || _a === void 0 ? void 0 : _a[nextChildKey];
                if (nextChild && nextChild.onSet(ad, actions)) {
                    delete _this.selfUsed;
                    return true;
                }
            }
            return isAffected;
        };
        var updated = update();
        if (!updated && this.subscribers !== undefined) this.subscribers.forEach(function(s) {
            if (s.onSet(ad, actions)) delete _this.selfUsed;
        });
        return updated;
    };
    Object.defineProperty(StateMethodsImpl.prototype, "keys", {
        get: function() {
            var value = this.get();
            if (Array.isArray(value)) return Object.keys(value).map(function(i) {
                return Number(i);
            }).filter(function(i) {
                return Number.isInteger(i);
            });
            if (Object(value) === value) return Object.keys(value);
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    StateMethodsImpl.prototype.child = function(key) {
        this.childrenUsed = this.childrenUsed || {};
        var cachedChild = this.childrenUsed.hasOwnProperty(key) && this.childrenUsed[key];
        if (cachedChild) return cachedChild;
        var valueSource = this.valueSource[key];
        if (typeof valueSource === "function") // hitting a method of a custom type, should be no-op
        throw new $fa93bfc840b773d3$var$StateInvalidUsageError(this.path, $fa93bfc840b773d3$var$ErrorId.GetProperty_Function);
        this.childrenCreated = this.childrenCreated || {};
        var child = this.childrenCreated[key];
        var r;
        if (child) {
            child.reconstruct(this.path.concat(key), valueSource, this.valueEdition, false);
            r = child;
        } else {
            r = new StateMethodsImpl(this.store, this.path.concat(key), valueSource, this.valueEdition, this.onSetUsed);
            this.childrenCreated[key] = r;
        }
        if (this.valueUsedNoProxy) // TODO this is redundant when Downgraded plugin is deleted
        r.valueUsedNoProxy = true;
        this.childrenUsed[key] = r;
        return r;
    };
    StateMethodsImpl.prototype.valueArrayImpl = function(currentValue) {
        var _this = this;
        return $fa93bfc840b773d3$var$proxyWrap(this.path, currentValue, function() {
            return currentValue;
        }, function(target, key) {
            if (key === "length") return target.length;
            if (key in Array.prototype) return Array.prototype[key];
            if (key === $fa93bfc840b773d3$var$SelfMethodsID) return _this;
            if (typeof key === "symbol") // allow clients to associate hidden cache with state values
            return target[key];
            var index = Number(key);
            if (!Number.isInteger(index)) return undefined;
            return _this.child(index).get();
        }, function(target, key, value) {
            if (typeof key === "symbol") {
                // allow clients to associate hidden cache with state values
                target[key] = value;
                return true;
            }
            throw new $fa93bfc840b773d3$var$StateInvalidUsageError(_this.path, $fa93bfc840b773d3$var$ErrorId.SetProperty_Value);
        }, true);
    };
    StateMethodsImpl.prototype.valueObjectImpl = function(currentValue) {
        var _this = this;
        return $fa93bfc840b773d3$var$proxyWrap(this.path, currentValue, function() {
            return currentValue;
        }, function(target, key) {
            if (key in Object.prototype) return Object.prototype[key];
            if (key === $fa93bfc840b773d3$var$SelfMethodsID) return _this;
            if (typeof key === "symbol") // allow clients to associate hidden cache with state values
            return target[key];
            return _this.child(key).get();
        }, function(target, key, value) {
            if (typeof key === "symbol") {
                // allow clients to associate hidden cache with state values
                target[key] = value;
                return true;
            }
            throw new $fa93bfc840b773d3$var$StateInvalidUsageError(_this.path, $fa93bfc840b773d3$var$ErrorId.SetProperty_Value);
        }, true);
    };
    StateMethodsImpl.prototype.self = function() {
        var _this = this;
        if (this.selfUsed) return this.selfUsed;
        var getter = function(_, key) {
            if (key === $fa93bfc840b773d3$var$self) return _this;
            if (typeof key === "symbol") return undefined;
            if (key === "toJSON") throw new $fa93bfc840b773d3$var$StateInvalidUsageError(_this.path, $fa93bfc840b773d3$var$ErrorId.ToJson_State);
            var nestedGetter = function(prop) {
                var currentValue = _this.get({
                    __internalAllowPromised: prop === "$$typeof" || prop === "constructor"
                });
                if (prop in Object.prototype) // Mark it used entirely, so changes to the value
                // invalidate and rerender results for Object.prototype.toString(),
                // for example.
                // We check for Object prototype functions
                // even for primitive values, because primitive values still
                // can have object methods.
                return Object.prototype[prop];
                if (Object(currentValue) !== currentValue && // if promised, it will be none
                currentValue !== $fa93bfc840b773d3$export$f883a24d5edde77c) // This was an error case, but various tools like webpack bundler
                // and react dev tools attempt to get props out of non-null object,
                // so this was changed to return just undefined for any property request
                // as there is no way to fix 3rd party tools.
                // Logging a warning to console is also not an option
                // as it pollutes console for legitimate apps on app start app.
                // Ref: https://github.com/avkonst/hookstate/issues/125
                return undefined;
                if (Array.isArray(currentValue)) {
                    if (prop === "length") return currentValue.length;
                    if (prop in Array.prototype) return Array.prototype[prop];
                    var index = Number(prop);
                    if (!Number.isInteger(index)) return undefined;
                    return _this.nested(index);
                }
                return _this.nested(prop.toString());
            };
            switch(key){
                case "path":
                    return _this.path;
                case "keys":
                    return _this.keys;
                case "value":
                    return _this.value;
                case "ornull":
                    return _this.ornull;
                case "promised":
                    return _this.promised;
                case "promise":
                    return _this.promise;
                case "error":
                    return _this.error;
                case "get":
                    return function(opts) {
                        return _this.get(opts);
                    };
                case "set":
                    return function(p) {
                        return _this.set(p);
                    };
                case "merge":
                    return function(p) {
                        return _this.merge(p);
                    };
                case "nested":
                    return function(p) {
                        return nestedGetter(p);
                    };
                default:
                    // check if extension method
                    var ext = _this.store.extension;
                    if (ext && key in ext) return ext[key](_this.self());
                    // otherwise nested child
                    return nestedGetter(key);
            }
        };
        this.selfUsed = $fa93bfc840b773d3$var$proxyWrap(this.path, this.valueSource, function(opts) {
            return _this.get({
                __internalAllowPromised: true,
                stealth: opts === null || opts === void 0 ? void 0 : opts.stealth
            });
        }, getter, function(_, key, value) {
            throw new $fa93bfc840b773d3$var$StateInvalidUsageError(_this.path, $fa93bfc840b773d3$var$ErrorId.SetProperty_State);
        }, false);
        return this.selfUsed;
    };
    Object.defineProperty(StateMethodsImpl.prototype, "promised", {
        get: function() {
            this.get({
                __internalAllowPromised: true
            }); // marks used
            return !!this.store.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateMethodsImpl.prototype, "promise", {
        get: function() {
            var _this = this;
            var _a;
            this.get({
                __internalAllowPromised: true
            }); // marks used
            return (_a = this.store.promise) === null || _a === void 0 ? void 0 : _a.then(function(_) {
                return _this.self();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateMethodsImpl.prototype, "error", {
        get: function() {
            this.get({
                __internalAllowPromised: !!this.store.promiseError
            }); // marks used
            return this.store.promiseError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateMethodsImpl.prototype, "ornull", {
        get: function() {
            var value = this.get();
            if (value === null || value === undefined) return value;
            return this.self();
        },
        enumerable: false,
        configurable: true
    });
    return StateMethodsImpl;
}();
function $fa93bfc840b773d3$var$proxyWrap(path, // tslint:disable-next-line: no-any
targetBootstrap, // tslint:disable-next-line: no-any
targetGetter, // tslint:disable-next-line: no-any
propertyGetter, // tslint:disable-next-line: no-any
propertySetter, isValueProxy) {
    var onInvalidUsage = function(op) {
        throw new $fa93bfc840b773d3$var$StateInvalidUsageError(path, op);
    };
    if (Object(targetBootstrap) !== targetBootstrap) targetBootstrap = {};
    return new Proxy(targetBootstrap, {
        getPrototypeOf: function(_target) {
            // should satisfy the invariants:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/getPrototypeOf#Invariants
            var targetReal = targetGetter();
            if (targetReal === undefined || targetReal === null) return null;
            if (targetReal === $fa93bfc840b773d3$export$f883a24d5edde77c) return Object.getPrototypeOf(new Promise(function() {}));
            return Object.getPrototypeOf(targetReal);
        },
        setPrototypeOf: function(_target, v) {
            return onInvalidUsage(isValueProxy ? $fa93bfc840b773d3$var$ErrorId.SetPrototypeOf_State : $fa93bfc840b773d3$var$ErrorId.SetPrototypeOf_Value);
        },
        isExtensible: function(_target) {
            // should satisfy the invariants:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/isExtensible#Invariants
            return true; // required to satisfy the invariants of the getPrototypeOf
        // return Object.isExtensible(target);
        },
        preventExtensions: function(_target) {
            return onInvalidUsage(isValueProxy ? $fa93bfc840b773d3$var$ErrorId.PreventExtensions_State : $fa93bfc840b773d3$var$ErrorId.PreventExtensions_Value);
        },
        getOwnPropertyDescriptor: function(_target, p) {
            var targetReal = targetGetter();
            if (Object(targetReal) === targetReal) {
                var origin_1 = Object.getOwnPropertyDescriptor(targetReal, p);
                if (Array.isArray(targetReal) && p in Array.prototype) return origin_1;
                return origin_1 && {
                    // should be configurable as may not exist on proxy target
                    configurable: true,
                    enumerable: origin_1.enumerable,
                    get: function() {
                        return propertyGetter(targetReal, p);
                    },
                    set: undefined
                };
            }
            if (isValueProxy || targetReal === $fa93bfc840b773d3$export$f883a24d5edde77c) return undefined;
            if (p === "value") return {
                // should be configurable as does not exist on proxy target
                configurable: true,
                enumerable: true,
                get: function() {
                    return targetGetter({
                        stealth: true
                    });
                },
                set: undefined
            };
            if (p === "path") return {
                // should be configurable as does not exist on proxy target
                configurable: true,
                enumerable: true,
                get: function() {
                    return path;
                },
                set: undefined
            };
            return undefined;
        },
        has: function(_target, p) {
            if (typeof p === "symbol") return false;
            var targetReal = targetGetter();
            if (Object(targetReal) === targetReal) return p in targetReal;
            if (isValueProxy || targetReal === $fa93bfc840b773d3$export$f883a24d5edde77c) return false;
            return p === "value" || p === "path";
        },
        get: propertyGetter,
        set: propertySetter,
        deleteProperty: function(_target, p) {
            return onInvalidUsage(isValueProxy ? $fa93bfc840b773d3$var$ErrorId.DeleteProperty_State : $fa93bfc840b773d3$var$ErrorId.DeleteProperty_Value);
        },
        defineProperty: function(_target, p, attributes) {
            return onInvalidUsage(isValueProxy ? $fa93bfc840b773d3$var$ErrorId.DefineProperty_State : $fa93bfc840b773d3$var$ErrorId.DefineProperty_Value);
        },
        ownKeys: function(_target) {
            var targetReal = targetGetter();
            if (Array.isArray(targetReal)) {
                if (_target.length === undefined) // an object turned into an array now
                // inject length property now as it is defined on the array
                // to enable getOwnPropertyDescriptor for length not throw
                Object.defineProperty(targetBootstrap, "length", {
                    value: 0,
                    writable: true,
                    enumerable: false,
                    configurable: false
                });
            }
            if (Object(targetReal) === targetReal) return Object.getOwnPropertyNames(targetReal);
            if (isValueProxy || targetReal === $fa93bfc840b773d3$export$f883a24d5edde77c) return [];
            return [
                "value",
                "path"
            ];
        },
        apply: function(_target, thisArg, argArray) {
            return onInvalidUsage(isValueProxy ? $fa93bfc840b773d3$var$ErrorId.Apply_State : $fa93bfc840b773d3$var$ErrorId.Apply_Value);
        },
        construct: function(_target, argArray, newTarget) {
            return onInvalidUsage(isValueProxy ? $fa93bfc840b773d3$var$ErrorId.Construct_State : $fa93bfc840b773d3$var$ErrorId.Construct_Value);
        }
    });
}
function $fa93bfc840b773d3$var$createStore(initial) {
    var initialValue = initial;
    if (typeof initial === "function") initialValue = initial();
    if (Object(initialValue) === initialValue && initialValue[$fa93bfc840b773d3$var$SelfMethodsID]) throw new $fa93bfc840b773d3$var$StateInvalidUsageError($fa93bfc840b773d3$var$RootPath, $fa93bfc840b773d3$var$ErrorId.InitStateToValueFromState);
    return new $fa93bfc840b773d3$var$Store(initialValue);
}
var $fa93bfc840b773d3$var$configuration = {
    interceptDependencyListsMode: "always",
    isDevelopmentMode: typeof $391299e0893a3dfa$exports === "object" && typeof $391299e0893a3dfa$exports.env === "object" && false,
    promiseDetector: function(p) {
        return Promise.resolve(p) === p;
    },
    hiddenInterceptDependencyListsModeDebug: false
};
/**
 * Configures Hookstate behavior globally. This is for special cases only, when default
 * heuristics fail to work in a specific environment.
 *
 * @param config
 */ function $fa93bfc840b773d3$export$8d21e34596265fa2(config) {
    var _a, _b, _c;
    $fa93bfc840b773d3$var$configuration = {
        interceptDependencyListsMode: (_a = config.interceptDependencyListsMode) !== null && _a !== void 0 ? _a : $fa93bfc840b773d3$var$configuration.interceptDependencyListsMode,
        isDevelopmentMode: (_b = config.isDevelopmentMode) !== null && _b !== void 0 ? _b : $fa93bfc840b773d3$var$configuration.isDevelopmentMode,
        promiseDetector: (_c = config.promiseDetector) !== null && _c !== void 0 ? _c : $fa93bfc840b773d3$var$configuration.promiseDetector,
        hiddenInterceptDependencyListsModeDebug: false
    };
    $fa93bfc840b773d3$var$interceptReactHooks(); // not really required, but for safety
    if ($fa93bfc840b773d3$var$configuration.interceptDependencyListsMode === "never") {
        $fa93bfc840b773d3$var$configuration.hiddenInterceptDependencyListsModeDebug = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"] && $fa93bfc840b773d3$var$useEffectOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"] && $fa93bfc840b773d3$var$useLayoutEffectOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useInsertionEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useInsertionEffect"] && $fa93bfc840b773d3$var$useInsertionEffectOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"] && $fa93bfc840b773d3$var$useImperativeHandleOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"] && $fa93bfc840b773d3$var$useMemoOrigin;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"] && $fa93bfc840b773d3$var$useCallbackOrigin;
        // the following does not make an effect as memo calls happen on module load
        // so it is always set to memoIntercept
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"] && $fa93bfc840b773d3$var$memoOrigin;
    } else {
        // do not intercept if a hook is not defined in React
        // otherwise, it will enable 3rd party libs thinking the react runs at version 18
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"] && $fa93bfc840b773d3$var$useEffectIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"] && $fa93bfc840b773d3$var$useLayoutEffectIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useInsertionEffect"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"] && $fa93bfc840b773d3$var$useInsertionEffectIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"] && $fa93bfc840b773d3$var$useImperativeHandleIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"] && $fa93bfc840b773d3$var$useMemoIntercept;
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"] && $fa93bfc840b773d3$var$useCallbackIntercept;
        // the following does not make an effect as memo calls happen on module load
        // so it is always set to memoIntercept
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"] && $fa93bfc840b773d3$var$memoIntercept;
        if ($fa93bfc840b773d3$var$configuration.interceptDependencyListsMode === "development" && $fa93bfc840b773d3$var$configuration.isDevelopmentMode) $fa93bfc840b773d3$var$configuration.hiddenInterceptDependencyListsModeDebug = true;
    }
}
function $fa93bfc840b773d3$var$reconnectDependencies(deps, fromIntercept) {
    for(var _i = 0, _a = deps || []; _i < _a.length; _i++){
        var i = _a[_i];
        if (i === Object(i)) {
            var state = i[$fa93bfc840b773d3$var$self];
            if (state) {
                if (fromIntercept && $fa93bfc840b773d3$var$configuration.hiddenInterceptDependencyListsModeDebug) throw new $fa93bfc840b773d3$var$StateInvalidUsageError(state.path, $fa93bfc840b773d3$var$ErrorId.StateUsedInDependencyList);
                state.reconnect();
            }
        }
    }
    return deps;
}
var $fa93bfc840b773d3$var$useEffectOrigin;
function $fa93bfc840b773d3$export$ed0ca0300c01832c(effect, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps);
    return $fa93bfc840b773d3$var$useEffectOrigin(effect, deps);
}
function $fa93bfc840b773d3$var$useEffectIntercept(effect, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps, true);
    return $fa93bfc840b773d3$var$useEffectOrigin(effect, deps);
}
var $fa93bfc840b773d3$var$useLayoutEffectOrigin;
function $fa93bfc840b773d3$export$91c8b18630ff876a(effect, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps);
    return $fa93bfc840b773d3$var$useLayoutEffectOrigin(effect, deps);
}
function $fa93bfc840b773d3$var$useLayoutEffectIntercept(effect, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps, true);
    return $fa93bfc840b773d3$var$useLayoutEffectOrigin(effect, deps);
}
var $fa93bfc840b773d3$var$useInsertionEffectOrigin;
function $fa93bfc840b773d3$export$6cee15fa149a0c33(effect, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps);
    return $fa93bfc840b773d3$var$useInsertionEffectOrigin(effect, deps);
}
function $fa93bfc840b773d3$var$useInsertionEffectIntercept(effect, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps, true);
    return $fa93bfc840b773d3$var$useInsertionEffectOrigin(effect, deps);
}
var $fa93bfc840b773d3$var$useImperativeHandleOrigin;
function $fa93bfc840b773d3$export$f64bd6548cd8cffc(ref, init, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps);
    return $fa93bfc840b773d3$var$useImperativeHandleOrigin(ref, init, deps);
}
function $fa93bfc840b773d3$var$useImperativeHandleIntercept(ref, init, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps, true);
    return $fa93bfc840b773d3$var$useImperativeHandleOrigin(ref, init, deps);
}
var $fa93bfc840b773d3$var$useMemoOrigin;
function $fa93bfc840b773d3$export$ec4b572a0b86ee2f(factory, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps);
    return $fa93bfc840b773d3$var$useMemoOrigin(factory, deps);
}
function $fa93bfc840b773d3$var$useMemoIntercept(factory, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps, true);
    return $fa93bfc840b773d3$var$useMemoOrigin(factory, deps);
}
var $fa93bfc840b773d3$var$useCallbackOrigin;
function $fa93bfc840b773d3$export$6867ae797ad2b7d9(callback, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps);
    return $fa93bfc840b773d3$var$useCallbackOrigin(callback, deps);
}
function $fa93bfc840b773d3$var$useCallbackIntercept(callback, deps) {
    $fa93bfc840b773d3$var$reconnectDependencies(deps, true);
    return $fa93bfc840b773d3$var$useCallbackOrigin(callback, deps);
}
var $fa93bfc840b773d3$var$memoOrigin;
function $fa93bfc840b773d3$export$6e172cde3cfe6d74(Component, propsAreEqual) {
    return $fa93bfc840b773d3$var$memoOrigin(Component, function(prevProps, nextProps) {
        $fa93bfc840b773d3$var$reconnectDependencies(Object.keys(nextProps).map(function(i) {
            return nextProps[i];
        }));
        return (propsAreEqual || $fa93bfc840b773d3$var$shallowEqual)(prevProps, nextProps);
    });
}
function $fa93bfc840b773d3$var$memoIntercept(Component, propsAreEqual) {
    return $fa93bfc840b773d3$var$memoOrigin(Component, function(prevProps, nextProps) {
        $fa93bfc840b773d3$var$reconnectDependencies(Object.keys(nextProps).map(function(i) {
            return nextProps[i];
        }), true);
        return (propsAreEqual || $fa93bfc840b773d3$var$shallowEqual)(prevProps, nextProps);
    });
}
function $fa93bfc840b773d3$var$interceptReactHooks() {
    if (!$fa93bfc840b773d3$var$useEffectOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"]) {
        $fa93bfc840b773d3$var$useEffectOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useEffect"] = $fa93bfc840b773d3$var$useEffectIntercept;
    }
    if (!$fa93bfc840b773d3$var$useLayoutEffectOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"]) {
        $fa93bfc840b773d3$var$useLayoutEffectOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useLayoutEffect"] = $fa93bfc840b773d3$var$useLayoutEffectIntercept;
    }
    if (!$fa93bfc840b773d3$var$useInsertionEffectOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useInsertionEffect"]) {
        $fa93bfc840b773d3$var$useInsertionEffectOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useInsertionEffect"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useInsertionEffect"] = $fa93bfc840b773d3$var$useInsertionEffectIntercept;
    }
    if (!$fa93bfc840b773d3$var$useImperativeHandleOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"]) {
        $fa93bfc840b773d3$var$useImperativeHandleOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useImperativeHandle"] = $fa93bfc840b773d3$var$useImperativeHandleIntercept;
    }
    if (!$fa93bfc840b773d3$var$useMemoOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"]) {
        $fa93bfc840b773d3$var$useMemoOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useMemo"] = $fa93bfc840b773d3$var$useMemoIntercept;
    }
    if (!$fa93bfc840b773d3$var$useCallbackOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"]) {
        $fa93bfc840b773d3$var$useCallbackOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["useCallback"] = $fa93bfc840b773d3$var$useCallbackIntercept;
    }
    if (!$fa93bfc840b773d3$var$memoOrigin && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"]) {
        $fa93bfc840b773d3$var$memoOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"];
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))["memo"] = $fa93bfc840b773d3$var$memoIntercept;
    }
}
$fa93bfc840b773d3$var$interceptReactHooks(); // TODO defer invoking it until state is created, so the configure had a chance to set it up first
// Do not try to use useLayoutEffect if DOM not available (SSR)
var $fa93bfc840b773d3$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $fa93bfc840b773d3$var$useLayoutEffectOrigin : $fa93bfc840b773d3$var$useEffectOrigin;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $c884fcbacf432c14$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c884fcbacf432c14$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c884fcbacf432c14$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * OnLoader é um componente para indicar um tempo de espera não especificado.
 */ var $c884fcbacf432c14$var$OnLoader = function(_a) {
    var _b = _a.allscreen, allscreen = _b === void 0 ? true : _b;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
        width: "100%",
        height: "100%",
        position: allscreen ? "fixed" : "absolute",
        sx: {
            backgroundColor: function(theme) {
                return theme.palette.background.default;
            },
            opacity: .6,
            top: 0,
            left: 0,
            zIndex: 500
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        position: allscreen ? "fixed" : "absolute",
        sx: {
            top: 0,
            left: 0,
            zIndex: 505
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("img", {
        src: "https://refereimages.blob.core.windows.net/images/refereloading.gif"
    }))));
};
/**
 * Mostra data em Formato ISO em formato de data brasileiro
 * @param value Data em formato ISO
 * @param formatPadrao Opcional. Formato padrão para ser usado. O valor default é dd/MM/yyyy.
 * @param valueIfDtFalsy Opcional. Valor que será retornado caso o value enviado seja falsy(undefined/null). O valor default é "Dt não definida".
 * Segue as regras do método format do date-fns
 * @see {@link https://date-fns.org/docs/format|format} do date-fns
 */ var $c884fcbacf432c14$var$mostraDeDateISOparaDataPtBr = function(value, formatPadrao, valueIfDtFalsy) {
    if (formatPadrao === void 0) formatPadrao = "dd/MM/yyyy";
    if (valueIfDtFalsy === void 0) valueIfDtFalsy = "Dt n\xe3o definida";
    if (!value) return valueIfDtFalsy;
    return (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)((0, $1869277eefbd126c$export$2e2bcd8739ae039)(value), formatPadrao);
};
var $c884fcbacf432c14$var$globalSnackBarState = (0, $fa93bfc840b773d3$export$4af2f85fc25cecbb)({
    message: "",
    type: "info",
    autoHideDuration: 4000,
    isOpen: false
});
/**
 * Hook utilizado para mostrar/fechar/acessar dados do GlobalSnackBar ao fazer uso do AppRoot
 * @returns Funcionalidades do hook
 */ function $c884fcbacf432c14$export$f244c9988dfd0734() {
    var _globalSnackBarState = (0, $fa93bfc840b773d3$export$7a18e83a30d41594)($c884fcbacf432c14$var$globalSnackBarState);
    return {
        showAlertSnackBar: function(message, type, autoHideDuration) {
            if (autoHideDuration === void 0) autoHideDuration = 4000;
            _globalSnackBarState.merge({
                message: message,
                type: type,
                autoHideDuration: autoHideDuration,
                isOpen: true
            });
        },
        closeGlobalSnackBar: function() {
            return _globalSnackBarState.isOpen.set(false);
        },
        globalSnackBarData: _globalSnackBarState.get({
            noproxy: true
        })
    };
}
/**
 * Componente para ser usado como raiz em aplicações Modulares
 * @param param0
 * @returns
 */ var $c884fcbacf432c14$export$2e2bcd8739ae039 = function(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var children = _a.children, _l = _a.isLoading, isLoading = _l === void 0 ? true : _l, setFetchErrorCallBack = _a.setFetchErrorCallBack, _m = _a.onModalFetchError, onModalFetchError = _m === void 0 ? function() {
        return null;
    } : _m, onFetchError = _a.onFetchError, theme = _a.theme;
    var _o = $c884fcbacf432c14$var$__read((0, $bh6RR.useState)(null), 2), modalFetchError = _o[0], setModalFetchError = _o[1];
    var _p = $c884fcbacf432c14$var$__read((0, $bh6RR.useState)(false), 2), showDetailsMessage = _p[0], setShowDetailsMessage = _p[1];
    var _q = $c884fcbacf432c14$var$__read((0, $bh6RR.useState)(false), 2), transactionUrlCopied = _q[0], setTransactionUrlCopied = _q[1];
    var _r = $c884fcbacf432c14$export$f244c9988dfd0734(), closeGlobalSnackBar = _r.closeGlobalSnackBar, globalSnackBarData = _r.globalSnackBarData;
    var handleCloseSnackBar = function(event, reason) {
        if (reason === "clickaway") return;
        closeGlobalSnackBar();
    };
    (0, $bh6RR.useEffect)(function() {
        setFetchErrorCallBack(setModalFetchError);
        if (onFetchError) {
            // Adiciona a detecção de exceções/erros em funções assíncronas para chamar o handler
            window.addEventListener("unhandledrejection", onFetchError);
            return function() {
                // Remove a detecção quando o componente desmonta, evitando acúmulo de listeners
                window.removeEventListener("unhandledrejection", onFetchError);
            };
        }
    }, []);
    (0, $bh6RR.useEffect)(function() {
        setShowDetailsMessage(false);
        setTransactionUrlCopied(false);
        if (modalFetchError) onModalFetchError(modalFetchError);
    }, [
        modalFetchError
    ]);
    var handleCloseModal = function() {
        return setModalFetchError(null);
    };
    var modalFetchUrlLogTransactionId = (_c = (_b = modalFetchError === null || modalFetchError === void 0 ? void 0 : modalFetchError.exception) === null || _b === void 0 ? void 0 : _b.urlLogsException) !== null && _c !== void 0 ? _c : (_d = modalFetchError === null || modalFetchError === void 0 ? void 0 : modalFetchError.businessError) === null || _d === void 0 ? void 0 : _d.urlExceptionLogs;
    var modalFecthLogTransactionId = (_f = (_e = modalFetchError === null || modalFetchError === void 0 ? void 0 : modalFetchError.exception) === null || _e === void 0 ? void 0 : _e.logTransactionId) !== null && _f !== void 0 ? _f : (_g = modalFetchError === null || modalFetchError === void 0 ? void 0 : modalFetchError.businessError) === null || _g === void 0 ? void 0 : _g["log-transaction-id"];
    var modalForceToShowMessage = (_j = (_h = modalFetchError === null || modalFetchError === void 0 ? void 0 : modalFetchError.exception) === null || _h === void 0 ? void 0 : _h.forceToShowMessage) !== null && _j !== void 0 ? _j : false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $82ee3221eaadbd63$export$2e2bcd8739ae039), {
        theme: theme
    }, isLoading && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($c884fcbacf432c14$var$OnLoader, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $db4ccd4732c544e1$export$2e2bcd8739ae039), null), modalFetchError && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $561e9f5f7ec53bec$export$2e2bcd8739ae039), {
        open: modalFetchError !== null,
        onClose: handleCloseModal,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27da0db86b3f2a3b$export$2e2bcd8739ae039), {
        id: "alert-dialog-title"
    }, "Falha ao processar a solicita\xe7\xe3o.", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("br", null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        fontSize: 12,
        variant: "subtitle1",
        component: "span"
    }, $c884fcbacf432c14$var$mostraDeDateISOparaDataPtBr((0, $1ff38398f48a5451$export$2e2bcd8739ae039)(new Date()), "dd/MM/yyyy HH:mm:ss")), modalFetchUrlLogTransactionId && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        mr: 1,
        width: "300px",
        display: "block",
        fontSize: 12,
        variant: "subtitle1",
        component: "span",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }, modalFetchUrlLogTransactionId), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d53a5c2058f97940$export$2e2bcd8739ae039), {
        title: transactionUrlCopied ? "Url do Log copiada para a \xe1rea de transfer\xeancia. Clique para copiar novamente." : "Copiar Url do Log",
        arrow: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $78a1ecfdeb9afc7a$export$2e2bcd8739ae039), {
        size: "small",
        color: transactionUrlCopied ? "success" : "default",
        onClick: function() {
            return $c884fcbacf432c14$var$__awaiter(void 0, void 0, void 0, function() {
                return $c884fcbacf432c14$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                navigator.clipboard.writeText(modalFetchUrlLogTransactionId)
                            ];
                        case 1:
                            _a.sent();
                            setTransactionUrlCopied(true);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    }, transactionUrlCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($336ae532ee38d225$exports))), {
        fontSize: "inherit"
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($12f73e2b92f051c2$exports))), {
        fontSize: "inherit"
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $78a1ecfdeb9afc7a$export$2e2bcd8739ae039), {
        "aria-label": "close",
        onClick: handleCloseModal,
        sx: {
            position: "absolute",
            right: 8,
            top: 8,
            color: function(theme) {
                return theme.palette.grey[500];
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($70fba0e4cb153a33$exports))), null))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $64d008f25a771e76$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $31543ddde024914d$export$2e2bcd8739ae039), {
        id: "alert-dialog-description"
    }, modalFetchError.exception ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        variant: "body1",
        mb: 2,
        component: "span"
    }, modalForceToShowMessage ? (_k = modalFetchError === null || modalFetchError === void 0 ? void 0 : modalFetchError.exception) === null || _k === void 0 ? void 0 : _k.message : modalFetchUrlLogTransactionId ? "Esta ocorr\xeancia ser\xe1 avaliada pela equipe t\xe9cnica. Para abertura de atendimento, por favor, informe o log-transaction-id \u201C".concat(modalFecthLogTransactionId, "\u201D.") : "Aten\xe7\xe3o! N\xe3o foi poss\xedvel seguir com esta solicita\xe7\xe3o. Contate a corretora!"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d43f206865e0cc7f$export$2e2bcd8739ae039), {
        size: "small",
        color: "secondary",
        sx: {
            fontSize: "70%",
            display: "block",
            mt: 1
        },
        onClick: function() {
            return setShowDetailsMessage(!showDetailsMessage);
        }
    }, !showDetailsMessage ? "Mais Detalhes" : "Menos Detalhes"), showDetailsMessage && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        variant: "body2",
        sx: {
            fontSize: "70%"
        },
        component: "span"
    }, modalFetchError.exception.message)) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        variant: "body1",
        mb: 2,
        component: "span"
    }, "Ocorreu um erro de valida\xe7\xe3o de neg\xf3cio.", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("br", null), Object.keys(modalFetchError.businessError.errors).map(function(k, idx) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bh6RR.Fragment), {
            key: idx
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, k), ": ", modalFetchError.businessError.errors[k]);
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("br", null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        variant: "body2",
        sx: {
            fontSize: "80%"
        },
        mt: 2,
        component: "span"
    }, "Para abertura de atendimento, por favor, informe o log-transaction-id \u201C", modalFecthLogTransactionId, "\u201D."))))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b2aee6581442386f$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d43f206865e0cc7f$export$2e2bcd8739ae039), {
        autoFocus: true,
        disabled: true
    }, "Suporte"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d43f206865e0cc7f$export$2e2bcd8739ae039), {
        onClick: function() {
            return window.open(modalFetchUrlLogTransactionId, "_blank").focus();
        },
        disabled: (modalFetchUrlLogTransactionId !== null && modalFetchUrlLogTransactionId !== void 0 ? modalFetchUrlLogTransactionId : "").length === 0
    }, "Ver Logs"))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e0a5be5f1b0e6199$export$2e2bcd8739ae039), {
        open: globalSnackBarData.isOpen,
        autoHideDuration: globalSnackBarData.autoHideDuration,
        onClose: handleCloseSnackBar,
        anchorOrigin: {
            horizontal: "center",
            vertical: "top"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8e112c98121a019d$export$2e2bcd8739ae039), {
        onClose: handleCloseSnackBar,
        severity: globalSnackBarData.type,
        variant: "filled",
        sx: {
            width: "100%"
        }
    }, globalSnackBarData.message)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), null, children));
};



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

var $lGIi0 = parcelRequire("lGIi0");
var $hDooL = parcelRequire("hDooL");

"use client";
var $dcae9259d56f58e7$export$2e2bcd8739ae039 = (0, $f1dfb8b2cafe41bb$export$2e2bcd8739ae039);


"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $cb6e65f4fdd325d8$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $bh6RR.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $dcae9259d56f58e7$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $cb6e65f4fdd325d8$var$maybeReactUseSyncExternalStore = $bh6RR.useSyncExternalStore;
function $cb6e65f4fdd325d8$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $bh6RR.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $bh6RR.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $bh6RR.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $cb6e65f4fdd325d8$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $cb6e65f4fdd325d8$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $hDooL.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $lGIi0.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $cb6e65f4fdd325d8$var$maybeReactUseSyncExternalStore !== undefined ? $cb6e65f4fdd325d8$var$useMediaQueryNew : $cb6e65f4fdd325d8$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $bh6RR = parcelRequire("bh6RR");




/**
 * Obtém o dia de Hoje, com horário fixo de 00:00:00
 */ var $2be18d44cc1d296c$var$getHoje = function() {
    var dtAtual = new Date();
    return new Date(dtAtual.getFullYear(), dtAtual.getMonth(), dtAtual.getDate());
};
var $2be18d44cc1d296c$var$hoje = $2be18d44cc1d296c$var$getHoje();
/**
 * Footer é usado para exibir um rodapé na tela.
 */ var $2be18d44cc1d296c$export$2e2bcd8739ae039 = function(_a) {
    var nomeCorretora = _a.nomeCorretora, nomeSistema = _a.nomeSistema;
    var match660 = (0, $cb6e65f4fdd325d8$export$2e2bcd8739ae039)("(max-width: 660px)");
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: match660 ? "column" : "row"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        fontSize: "12px"
    }, "SIGAS - ", nomeSistema, " \xa9 ", (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)($2be18d44cc1d296c$var$hoje, "yyyy"), " ", " ", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("a", {
        href: "https://www.refere.com.br/",
        target: "_blank",
        style: {
            textDecoration: "none",
            color: "black"
        },
        rel: "noopener noreferrer"
    }, "Refere Tecnologia"))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
        fontSize: "12px"
    }, "Licenciado para ", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        style: {
            textTransform: "uppercase"
        }
    }, nomeCorretora)));
};



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



const $e5e3739fa1d01a34$var$globalState = (0, $fa93bfc840b773d3$export$4af2f85fc25cecbb)({
    isLoading: true
});
var $e5e3739fa1d01a34$export$2e2bcd8739ae039 = $e5e3739fa1d01a34$var$globalState;



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $24ebe8b71781ac87$var$__assign = function() {
    $24ebe8b71781ac87$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $24ebe8b71781ac87$var$__assign.apply(this, arguments);
};
function $24ebe8b71781ac87$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $24ebe8b71781ac87$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
var $24ebe8b71781ac87$var$_errorCB = null;
/**
 * Seta o método a ser chamado quando ocorre um erro no Fetch
 * @param {ErrorCallBack} errorCB Método a ser chamado quando ocorre um erro no Fetch
 */ var $24ebe8b71781ac87$export$554a3e2a5460d45b = function(errorCB) {
    $24ebe8b71781ac87$var$_errorCB = errorCB;
};
var $24ebe8b71781ac87$export$66280c31a921dd30 = {};
/**
 * Cancela o fetch com o id repassado
 * @param id Id do fetch
 * @returns Promessa para o cancelamento do fetch
 */ var $24ebe8b71781ac87$export$8b75c04acf2d789d = function(id) {
    return new Promise(function() {
        var _a;
        if (((_a = $24ebe8b71781ac87$export$66280c31a921dd30[id]) !== null && _a !== void 0 ? _a : []).length > 0) {
            $24ebe8b71781ac87$export$66280c31a921dd30[id][0].abort();
            $24ebe8b71781ac87$export$66280c31a921dd30[id].shift();
        }
    });
};
/**
 * Realiza um fetch, cancelando um fetch anterior com o mesmo id, com suporte a tratamento de erro vindo do backend, em formato específico
 * @param id Id do fetch
 * @param input input do fetch
 * @param init init do fetch
 * @param options Opções para Custom Fecths
 * @returns retorno do fetch
 */ function $24ebe8b71781ac87$export$a35d702993330b6c(id, input, init, options) {
    return new Promise(function(resolve) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $24ebe8b71781ac87$export$8b75c04acf2d789d(id);
        var _newfetchToAbort = new AbortController();
        if (((_a = $24ebe8b71781ac87$export$66280c31a921dd30[id]) !== null && _a !== void 0 ? _a : []).length === 0) $24ebe8b71781ac87$export$66280c31a921dd30[id] = [];
        $24ebe8b71781ac87$export$66280c31a921dd30[id].push(_newfetchToAbort);
        resolve($24ebe8b71781ac87$export$1512182a095696a1(input, $24ebe8b71781ac87$var$__assign($24ebe8b71781ac87$var$__assign({}, init), {
            signal: _newfetchToAbort.signal
        }), options));
    });
}
var $24ebe8b71781ac87$var$_customFetchOptions = {
    usingModularAuthentication: true,
    usingCORS: false,
    isToUseCache: false,
    isDownloadFile: false,
    isToReturnBlob: false,
    returnRawText: false
};
/**
 * Seta opções defaults para custom fetchs
 * @param customFetchOptions Opções defaults para custom fetchs
 */ function $24ebe8b71781ac87$export$8e7b5affc2cf1c0a(customFetchOptions) {
    $24ebe8b71781ac87$var$_customFetchOptions = $24ebe8b71781ac87$var$__assign($24ebe8b71781ac87$var$__assign({}, $24ebe8b71781ac87$var$_customFetchCache), customFetchOptions);
}
var $24ebe8b71781ac87$var$_customFetchCache = {};
/**
 * Realiza um fetch, com suporte a tratamento de erro vindo do backend, em formato específico
 * @param input input do fetch
 * @param init init do fetch
 * @param options Opções para Custom Fecths
 * @returns retorno do fetch
 */ function $24ebe8b71781ac87$export$1512182a095696a1(input, init, options) {
    var _this = this;
    var _a = $24ebe8b71781ac87$var$__assign($24ebe8b71781ac87$var$__assign({}, $24ebe8b71781ac87$var$_customFetchOptions), options), usingModularAuthentication = _a.usingModularAuthentication, usingCORS = _a.usingCORS, isToUseCache = _a.isToUseCache, isDownloadFile = _a.isDownloadFile, isToReturnBlob = _a.isToReturnBlob, returnRawText = _a.returnRawText;
    var _init = init !== null && init !== void 0 ? init : {};
    var headers = $24ebe8b71781ac87$var$__assign({}, _init.headers);
    if (!_init.credentials) {
        if (usingModularAuthentication) _init["credentials"] = "same-origin";
        if (usingCORS) _init["credentials"] = "include";
    }
    if (usingModularAuthentication && sessionStorage.getItem("cache")) headers["x-client-token"] = sessionStorage.getItem("cache");
    return new Promise(function(resolve) {
        if (isToUseCache) {
            var inCache = $24ebe8b71781ac87$var$_customFetchCache[input.toString()];
            if (inCache !== undefined) {
                resolve(inCache);
                return;
            }
        }
        var responseStatus = 200;
        var filename = null;
        return fetch(input, $24ebe8b71781ac87$var$__assign($24ebe8b71781ac87$var$__assign({}, _init), {
            headers: headers
        })).then(function(r) {
            return $24ebe8b71781ac87$var$__awaiter(_this, void 0, void 0, function() {
                var token, content, success, hasException, parsedContent;
                return $24ebe8b71781ac87$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            token = r.headers.get("x-client-token");
                            if (token) sessionStorage.setItem("cache", token);
                            responseStatus = r.status;
                            if (!(isDownloadFile && responseStatus >= 200 && responseStatus <= 299)) return [
                                3 /*break*/ ,
                                1
                            ];
                            filename = r.headers.get("content-disposition");
                            filename = filename.split(";")[1].replace(" filename=", "");
                            return [
                                2 /*return*/ ,
                                r.blob()
                            ];
                        case 1:
                            if (!(isToReturnBlob && responseStatus >= 200 && responseStatus <= 299)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                2 /*return*/ ,
                                r.blob()
                            ];
                        case 2:
                            return [
                                4 /*yield*/ ,
                                r.text()
                            ];
                        case 3:
                            content = _a.sent();
                            success = [
                                204,
                                200,
                                201
                            ].indexOf(r.status) > -1;
                            if (success && !content) return [
                                2 /*return*/ ,
                                {
                                    success: true
                                }
                            ];
                            if (success && returnRawText) return [
                                2 /*return*/ ,
                                {
                                    text: content
                                }
                            ];
                            if (responseStatus >= 400 && responseStatus !== 422) {
                                hasException = false;
                                try {
                                    parsedContent = JSON.parse(content);
                                    if (parsedContent["exception"]) hasException = true;
                                // eslint-disable-next-line no-empty
                                } catch (error) {}
                                if (!hasException) return [
                                    2 /*return*/ ,
                                    {
                                        exception: {
                                            message: content
                                        }
                                    }
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                Promise.resolve(JSON.parse(content))
                            ];
                    }
                });
            });
        }).then(function(r) {
            if (r === null || r === void 0 ? void 0 : r.exception) {
                console.log(r);
                if ($24ebe8b71781ac87$var$_errorCB) $24ebe8b71781ac87$var$_errorCB({
                    exception: r.exception
                });
                resolve($24ebe8b71781ac87$var$__assign($24ebe8b71781ac87$var$__assign({}, r), {
                    failed: true
                }));
            } else if (responseStatus === 422) {
                var response = {
                    businessError: r
                };
                if ($24ebe8b71781ac87$var$_errorCB) $24ebe8b71781ac87$var$_errorCB(response);
                resolve($24ebe8b71781ac87$var$__assign($24ebe8b71781ac87$var$__assign({}, response), {
                    failed: true
                }));
            } else if (isDownloadFile) {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(r);
                a.setAttribute("download", filename);
                a.click();
                resolve({
                    success: true
                });
            } else if (isToReturnBlob) resolve(r);
            else {
                if (isToUseCache) $24ebe8b71781ac87$var$_customFetchCache[input.toString()] = r;
                resolve(r);
            }
        }).catch(function(reason) {
            var _a;
            console.log(reason);
            if (reason["name"] !== "AbortError") // o erro AbortError é gerado quando uma consulta a api é cancelada
            //   Este cenário acontece quando o fetch é cancelável
            // não é considerado um erro
            $24ebe8b71781ac87$var$_errorCB({
                exception: {
                    message: (_a = reason["message"]) !== null && _a !== void 0 ? _a : reason.toString()
                }
            });
        });
    });
}
/**
 * Trata o erro para o promise passado
 * @param fetch Promise com o fetch a ser executado
 * @param resultOnError Resultado se der erro. Opcional, valor default é null
 * @returns Retorno do fetch em caso de sucesso ou resulOnError em caso de falha
 */ function $24ebe8b71781ac87$export$228274539535d19(fetch1, resultOnError) {
    var _this = this;
    if (resultOnError === void 0) resultOnError = null;
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(function(resolve) {
        return $24ebe8b71781ac87$var$__awaiter(_this, void 0, void 0, function() {
            var response;
            return $24ebe8b71781ac87$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch1
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response["failed"]) resolve(resultOnError);
                        else resolve(response);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    });
}
/**
 * Empacota a chamada para fetch, usando o customFetch.
 * - Ele dispara erro de javascript em caso de erro vindo no fetch, especialmente útil para tratamento de erros por alguma ferramentas, como swr
 * @param input
 * @param init
 * @param options
 * @returns
 */ function $24ebe8b71781ac87$export$847eb6960bee011f(input, init, options) {
    return $24ebe8b71781ac87$var$__awaiter(this, void 0, void 0, function() {
        var response, errorMessage, error;
        var _a, _b;
        return $24ebe8b71781ac87$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $24ebe8b71781ac87$export$1512182a095696a1(input, init, options)
                    ];
                case 1:
                    response = _c.sent();
                    if (response["failed"]) {
                        errorMessage = ((_a = response.exception) === null || _a === void 0 ? void 0 : _a.message) || ((_b = response.businessError) === null || _b === void 0 ? void 0 : _b.detail);
                        error = new Error(errorMessage);
                        error.cause = response;
                        throw error;
                    }
                    return [
                        2 /*return*/ ,
                        response
                    ];
            }
        });
    });
}


async function $761d92917786e027$export$482ff399fd242da7(input, init, options) {
    const _init = {
        method: "GET",
        ...init ?? {}
    };
    // Se o método for PUT ou POST é necessário um header de conteúdo
    if (_init.method === "PUT" || _init.method === "POST") _init.headers = {
        "Content-type": "application/json; charset=UTF-8",
        ...init.headers ?? {}
    };
    return (0, $24ebe8b71781ac87$export$847eb6960bee011f)(input, _init, options);
}



const $19cef8fee6e269a4$export$f76cfcb5319e89a0 = ()=>(0, $761d92917786e027$export$482ff399fd242da7)("/api/Lead");
const $19cef8fee6e269a4$export$dd945f3dae54a8f8 = (leadId, numeroProposta, valorProposta, parcelas, periodicidade)=>(0, $761d92917786e027$export$482ff399fd242da7)("/api/Lead/Save", {
        method: "POST",
        body: JSON.stringify({
            leadId: leadId,
            numeroProposta: numeroProposta,
            valorProposta: valorProposta,
            parcelas: parcelas,
            periodicidade: periodicidade
        })
    });
const $19cef8fee6e269a4$export$64c0467802e9a776 = async (numeroProposta, valorProposta, parcelas, periodicidade)=>{
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).isLoading.set(true);
    const leadId = (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).leadState.leadId.get();
    await $19cef8fee6e269a4$export$dd945f3dae54a8f8(leadId, numeroProposta, valorProposta, parcelas, periodicidade);
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).leadState.hasNumeroProposta.set(true);
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).isLoading.set(false);
};
const $19cef8fee6e269a4$export$49c0d29fa262aac4 = async ()=>{
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).isLoading.set(true);
    const response = await $19cef8fee6e269a4$export$f76cfcb5319e89a0();
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).leadState.set(response);
    await (0, $16e924f086a574be$export$5375cda95f0b0eb4).navigate("/lead", {
        replace: true
    });
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).isLoading.set(false);
};



const $4a1891c94df691fd$var$Lead = ()=>{
    const leadState = (0, $fa93bfc840b773d3$export$7a18e83a30d41594)((0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).leadState);
    const { showAlertSnackBar: showAlertSnackBar } = (0, $c884fcbacf432c14$export$f244c9988dfd0734)();
    const handleProposalConfirmed = async (event)=>{
        const strUrl = leadState.url.get();
        if (!strUrl) return;
        const url = new URL(strUrl);
        // Verificar a origem da mensagem para garantir segurança
        if (event.origin !== url.origin) {
            const errorMessage = `Origem da mensagem n\xe3o autorizada: ${event.origin}. A Proposta N\xc3O foi efetivada no Modular/Sigas.`;
            showAlertSnackBar(errorMessage, "error");
            throw errorMessage;
        } else {
            const hasProposta = leadState.hasNumeroProposta.get();
            // Se a simulação já tiver proposta não salva no banco nem faz efetivação
            // Isso garante que não salve proposta de outra simulação nela,
            // nem tente efetivar no sigas uma proposta que já tenha sido efetivada
            if (hasProposta) return;
            const data = event.data;
            const valor = Number.parseFloat(data.contributionValue);
            const parcelas = Number.parseInt(data.installment);
            await (0, $19cef8fee6e269a4$export$64c0467802e9a776)(data.proposalNumber, valor, parcelas, data.frequency);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        window.addEventListener("message", handleProposalConfirmed);
        return ()=>{
            window.removeEventListener("message", handleProposalConfirmed);
        };
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (leadState.mensagemDeErro.get()) showAlertSnackBar(leadState.mensagemDeErro.get(), "info");
    }, [
        leadState
    ]);
    return leadState.get() && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dc1f965cf97b1820$export$2e2bcd8739ae039), {
            sx: {
                mb: 1
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)("iframe", {
                src: leadState.url.get(),
                width: "100%",
                height: "650",
                style: {
                    border: "none"
                }
            })
        })
    });
};
var $4a1891c94df691fd$export$2e2bcd8739ae039 = $4a1891c94df691fd$var$Lead;



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");





/**
 * Mostra um valor formatado em Reais
 * @param value valor nunmérico
 * @param removerCasasDecimais Opcional. Retorna o valor sem as casas decimais. Default é false
 */ var $bbb39636244146a2$export$8c774148e0a4c35e = function(value, removerCasasDecimais) {
    if (removerCasasDecimais === void 0) removerCasasDecimais = false;
    var formatterCurrencyPtBr = new Intl.NumberFormat("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: removerCasasDecimais ? 0 : 2
    });
    return formatterCurrencyPtBr.format(value);
};
/**
 * Mostra data em Formato ISO em formato de data brasileiro
 * @param value Data em formato ISO
 * @param formatPadrao Opcional. Formato padrão para ser usado. O valor default é dd/MM/yyyy.
 * @param valueIfDtFalsy Opcional. Valor que será retornado caso o value enviado seja falsy(undefined/null). O valor default é "Dt não definida".
 * Segue as regras do método format do date-fns
 * @see {@link https://date-fns.org/docs/format|format} do date-fns
 */ var $bbb39636244146a2$export$343c905be2d0085f = function(value, formatPadrao, valueIfDtFalsy) {
    if (formatPadrao === void 0) formatPadrao = "dd/MM/yyyy";
    if (valueIfDtFalsy === void 0) valueIfDtFalsy = "Dt n\xe3o definida";
    if (!value) return valueIfDtFalsy;
    return (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)((0, $1869277eefbd126c$export$2e2bcd8739ae039)(value), formatPadrao);
};
/**
 * Mostra um valor formatado como CPF
 * @param value valor contendo CPF
 */ var $bbb39636244146a2$export$863413ac9091fa8e = function(value) {
    return $bbb39636244146a2$export$cbca280944bf4481(value).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
};
/**
 * Mostra um valor formatado como CNPJ
 * Suporta o formato alfanumérico (IN RFB 2229/2024, vigente a partir de julho/2026).
 * @param value valor contendo CNPJ
 */ var $bbb39636244146a2$export$9249afe54a28d2fd = function(value) {
    var clean = $bbb39636244146a2$export$1065c7cd26df03fa(value);
    return clean.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
};
/**
 * Mostra um valor formatado como CPF ou CNPJ
 * @param value valor contendo CPF ou CNPJ
 */ var $bbb39636244146a2$export$cd9a399eca510602 = function(value) {
    return $bbb39636244146a2$export$1065c7cd26df03fa(value).length === 11 ? $bbb39636244146a2$export$863413ac9091fa8e(value) : $bbb39636244146a2$export$9249afe54a28d2fd(value);
};
/**
 * Mantém somente os números da string passada
 * @param value string a ser mantida os números
 * @param valueIfFalsy valor a ser retornado se o value for um valor falsy. Opcional. Default é vazio
 * @returns
 */ var $bbb39636244146a2$export$cbca280944bf4481 = function(value, valueIfFalsy) {
    var _a, _b;
    if (valueIfFalsy === void 0) valueIfFalsy = "";
    return (_b = (_a = value === null || value === void 0 ? void 0 : value.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.join("")) !== null && _b !== void 0 ? _b : valueIfFalsy;
};
/**
 * Mantém somente as letras e números da string passada
 * @remarks Não mantém letras com acento
 * @param value string a ser mantida as letras e números
 * @param valueIfFalsy valor a ser retornado se o value for um valor falsy. Opcional. Default é vazio
 * @returns
 */ var $bbb39636244146a2$export$1065c7cd26df03fa = function(value, valueIfFalsy) {
    var _a;
    if (valueIfFalsy === void 0) valueIfFalsy = "";
    return (_a = value === null || value === void 0 ? void 0 : value.replace(/[^A-Za-z0-9]/g, "")) !== null && _a !== void 0 ? _a : valueIfFalsy;
};



var $1475e6ac38f9e759$exports = {};
$1475e6ac38f9e759$exports = new URL("mag-capitalizacao.aa44c761.png", import.meta.url).toString();


const $560785d072a9d48f$var$Header = ()=>{
    const headerState = (0, $fa93bfc840b773d3$export$7a18e83a30d41594)((0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).simulacaoState.header);
    const isCpf = headerState.tipoPessoa.get() == 0;
    return headerState.get() && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dc1f965cf97b1820$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            mb: 1
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
                        children: [
                            "Nome do Titular: ",
                            headerState.nome.get()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
                        children: [
                            isCpf ? "CPF" : "CNPJ",
                            ": ",
                            (0, $bbb39636244146a2$export$cd9a399eca510602)(headerState.cpfCnpj.get())
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $77f26cb2b0fda3b7$export$2e2bcd8739ae039), {
                        children: [
                            "Cota\xe7\xe3o: ",
                            headerState.idSimulacao.get()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    width: "130px",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1475e6ac38f9e759$exports)))
                })
            })
        ]
    });
};
var $560785d072a9d48f$export$2e2bcd8739ae039 = $560785d072a9d48f$var$Header;




const $45bf6d91f629f255$var$Home = ()=>{
    const simulacaoState = (0, $fa93bfc840b773d3$export$7a18e83a30d41594)((0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).simulacaoState);
    const match800 = (0, $cb6e65f4fdd325d8$export$2e2bcd8739ae039)("(max-width: 800px)");
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
            display: "flex",
            justifyContent: "center",
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
                p: match800 ? 1 : 3,
                pb: 3,
                width: "100%",
                sx: {
                    maxWidth: (t)=>`${t.breakpoints.values.lg}px`
                },
                position: "relative",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $560785d072a9d48f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $4a1891c94df691fd$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $8f1c19533f0ca7a5$export$2e2bcd8739ae039), {
                        px: match800 ? 1 : 3,
                        width: "100%",
                        height: "20px",
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2be18d44cc1d296c$export$2e2bcd8739ae039), {
                            nomeSistema: "MAG CAPITALIZA\xc7\xc3O",
                            nomeCorretora: simulacaoState.corretoraNome?.get()
                        })
                    })
                ]
            })
        })
    });
};
var $45bf6d91f629f255$export$2e2bcd8739ae039 = $45bf6d91f629f255$var$Home;






var $gcMmG = parcelRequire("gcMmG");
var $1e25dc7a96b22e35$export$bca14c5b3b88a9c9 = (0, $gcMmG.default)({
    palette: {
        primary: {
            main: "#214752",
            light: "#10A37F"
        }
    },
    typography: {
        allVariants: {
            fontFamily: "Open Sans"
        }
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: 14
                }
            }
        },
        MuiTypography: {
            variants: [
                {
                    props: {
                        variant: "caption"
                    },
                    style: {
                        fontSize: 12
                    }
                }
            ],
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: 14,
                    textTransform: "none"
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontFamily: "Open Sans"
                }
            }
        }
    }
});



var $gbgGf = parcelRequire("gbgGf");

var $iwq56 = parcelRequire("iwq56");
var $f1f439cb1f906708$exports = {};

$parcel$export($f1f439cb1f906708$exports, "extract", function () { return $f1f439cb1f906708$export$f9380c9a627682d3; });
$parcel$export($f1f439cb1f906708$exports, "parse", function () { return $f1f439cb1f906708$export$98e6a39c04603d36; });
$parcel$export($f1f439cb1f906708$exports, "stringify", function () { return $f1f439cb1f906708$export$fac44ee5b035f737; });
$parcel$export($f1f439cb1f906708$exports, "parseUrl", function () { return $f1f439cb1f906708$export$7a5253c0f62e0150; });
$parcel$export($f1f439cb1f906708$exports, "stringifyUrl", function () { return $f1f439cb1f906708$export$a8c1621ea79325d3; });
$parcel$export($f1f439cb1f906708$exports, "pick", function () { return $f1f439cb1f906708$export$357523c63a2253b9; });
$parcel$export($f1f439cb1f906708$exports, "exclude", function () { return $f1f439cb1f906708$export$44c361b8ec72ef7f; });
const $e1c58bf2e246f16d$var$token = "%[a-f0-9]{2}";
const $e1c58bf2e246f16d$var$singleMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")|([^%]+?)", "gi");
const $e1c58bf2e246f16d$var$multiMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")+", "gi");
function $e1c58bf2e246f16d$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $e1c58bf2e246f16d$var$decodeComponents(left), $e1c58bf2e246f16d$var$decodeComponents(right));
}
function $e1c58bf2e246f16d$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $e1c58bf2e246f16d$var$decodeComponents(tokens, i).join("");
            tokens = input.match($e1c58bf2e246f16d$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e1c58bf2e246f16d$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    let match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $e1c58bf2e246f16d$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $e1c58bf2e246f16d$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $e1c58bf2e246f16d$var$customDecodeURIComponent(encodedURI);
    }
}


function $731a0efefa6baa63$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $f2797a3f33da989b$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $f2797a3f33da989b$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $f2797a3f33da989b$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $f2797a3f33da989b$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $f1f439cb1f906708$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $f1f439cb1f906708$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $f1f439cb1f906708$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $f1f439cb1f906708$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[",
                            $f1f439cb1f906708$var$encode(index, options),
                            "]=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "[]=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            ":list=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $f1f439cb1f906708$var$encode(key, options),
                                keyValueSep,
                                $f1f439cb1f906708$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $f1f439cb1f906708$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $f1f439cb1f906708$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $f1f439cb1f906708$var$encode(key, options),
                            "=",
                            $f1f439cb1f906708$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $f1f439cb1f906708$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $f1f439cb1f906708$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $f1f439cb1f906708$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$f1f439cb1f906708$var$decode(item, options)) : value === null ? value : $f1f439cb1f906708$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $f1f439cb1f906708$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$f1f439cb1f906708$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $f1f439cb1f906708$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $f1f439cb1f906708$var$encode(value, options) {
    if (options.encode) return options.strict ? $f1f439cb1f906708$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $f1f439cb1f906708$var$decode(value, options) {
    if (options.decode) return (0, $e1c58bf2e246f16d$export$2e2bcd8739ae039)(value);
    return value;
}
function $f1f439cb1f906708$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $f1f439cb1f906708$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $f1f439cb1f906708$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $f1f439cb1f906708$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $f1f439cb1f906708$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $f1f439cb1f906708$export$f9380c9a627682d3(input) {
    input = $f1f439cb1f906708$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $f1f439cb1f906708$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $f1f439cb1f906708$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $f1f439cb1f906708$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $731a0efefa6baa63$export$2e2bcd8739ae039)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $f1f439cb1f906708$var$decode(value, options);
        formatter($f1f439cb1f906708$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $f1f439cb1f906708$var$parseValue(value2, options);
        else returnValue[key] = $f1f439cb1f906708$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? $f1f439cb1f906708$var$keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function $f1f439cb1f906708$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $f1f439cb1f906708$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $f1f439cb1f906708$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $f1f439cb1f906708$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $f1f439cb1f906708$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $f1f439cb1f906708$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $f1f439cb1f906708$var$encode(key, options) + "=" + $f1f439cb1f906708$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $f1f439cb1f906708$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $731a0efefa6baa63$export$2e2bcd8739ae039)(url, "#");
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split("?")?.[0] ?? "",
        query: $f1f439cb1f906708$export$98e6a39c04603d36($f1f439cb1f906708$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $f1f439cb1f906708$var$decode(hash, options)
        } : {}
    };
}
function $f1f439cb1f906708$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$f1f439cb1f906708$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $f1f439cb1f906708$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $f1f439cb1f906708$export$f9380c9a627682d3(object.url);
    const query = {
        ...$f1f439cb1f906708$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $f1f439cb1f906708$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $f1f439cb1f906708$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$f1f439cb1f906708$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $f1f439cb1f906708$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$f1f439cb1f906708$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $f1f439cb1f906708$export$7a5253c0f62e0150(input, options);
    return $f1f439cb1f906708$export$a8c1621ea79325d3({
        url: url,
        query: (0, $f2797a3f33da989b$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $f1f439cb1f906708$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $f1f439cb1f906708$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $d1ffd40e86b7fa1f$export$2e2bcd8739ae039 = $f1f439cb1f906708$exports;





const $824c6561abc67315$var$getSimulacaoFetch = ()=>(0, $761d92917786e027$export$482ff399fd242da7)("/api/Simulacao");
const $824c6561abc67315$export$2cd8252107eb640b = async ()=>{
    const simulacao = await $824c6561abc67315$var$getSimulacaoFetch();
    (0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).simulacaoState.set(simulacao);
    await (0, $19cef8fee6e269a4$export$49c0d29fa262aac4)();
};



const $cf8e090af1f692bd$export$2cd8252107eb640b = async ()=>{
    const requestParameters = (0, $d1ffd40e86b7fa1f$export$2e2bcd8739ae039).parse(window.location.search);
    const rsid = requestParameters.RSID;
    const customer = requestParameters.customer;
    if (rsid) {
        await (0, $761d92917786e027$export$482ff399fd242da7)(`/api/security/login?rsid=${rsid}&customer=${customer}`, null, {
            usingModularAuthentication: false
        });
        window.location.replace("/");
    } else //carrega simulação e outras telas
    await (0, $824c6561abc67315$export$2cd8252107eb640b)();
};




//necessário para forçar o uso do css dele, setado na página raiz
(0, $e4be14b5d2706883$export$e506a1d27d1eaa20).autoAddCss = false;
const $16e924f086a574be$var$nonceTag = document.getElementById("nonce");
const $16e924f086a574be$var$nonce = $16e924f086a574be$var$nonceTag.value;
const $16e924f086a574be$var$cache = (0, $gbgGf.default)({
    key: "refere-sistema",
    nonce: $16e924f086a574be$var$nonce,
    prepend: true
});
const $16e924f086a574be$export$5375cda95f0b0eb4 = (0, $0bd3411f2ec14e23$export$1f3f55432a00e06d)((0, $6a9dcc96d11bcd0d$export$16da398f5434bdec)(/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)((0, $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6), {
            path: "/",
            element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b354edeb06442c79$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)((0, $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6), {
            path: "/lead",
            element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $45bf6d91f629f255$export$2e2bcd8739ae039), {})
        })
    ]
})));
const $16e924f086a574be$var$GetThemeByCorretora = (corretoraTheme)=>{
    const customTheme = (0, $1e25dc7a96b22e35$export$bca14c5b3b88a9c9);
    switch(corretoraTheme){
        case "sicoob":
            customTheme.palette.primary.main = "#003E4D";
            break;
        case "ailos":
            customTheme.palette.primary.main = "#214752";
            break;
        case "unicred":
            (0, $1e25dc7a96b22e35$export$bca14c5b3b88a9c9).palette.primary.main = "#004C35";
            break;
        case "cresol":
            customTheme.palette.primary.main = "#13533E";
            break;
        default:
            customTheme.palette.primary.main = "#214752";
            break;
    }
    return customTheme;
};
const $16e924f086a574be$var$App = ()=>{
    const isLoading = (0, $fa93bfc840b773d3$export$7a18e83a30d41594)((0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).isLoading);
    const simulacaoState = (0, $fa93bfc840b773d3$export$7a18e83a30d41594)((0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).simulacaoState);
    (0, $bh6RR.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $cf8e090af1f692bd$export$2cd8252107eb640b)();
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $iwq56.C), {
        value: $16e924f086a574be$var$cache,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $c884fcbacf432c14$export$2e2bcd8739ae039), {
            theme: $16e924f086a574be$var$GetThemeByCorretora(simulacaoState.corretoraNome?.get()),
            isLoading: isLoading.get({
                noproxy: true
            }),
            setFetchErrorCallBack: (0, $24ebe8b71781ac87$export$554a3e2a5460d45b),
            onFetchError: ()=>(0, $e5e3739fa1d01a34$export$2e2bcd8739ae039).isLoading.set(false),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0bd3411f2ec14e23$export$323e4fc2fa4753fb), {
                router: $16e924f086a574be$export$5375cda95f0b0eb4
            })
        })
    });
};
var $16e924f086a574be$export$2e2bcd8739ae039 = $16e924f086a574be$var$App;


const $d0bb92445f8cf837$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.getElementById("root"));
$d0bb92445f8cf837$var$root.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $16e924f086a574be$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.cacdecf4.js.map
